!function (e, t) {
  for (var o in t) {
    e[o] = t[o];
  }
}(exports, function (e) {
  function t(n) {
    if (o[n]) return o[n].exports;
    var r = o[n] = {
      exports: {},
      id: n,
      loaded: !1
    };
    return e[n].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
  }

  var o = {};
  return t.m = e, t.c = o, t.p = "/", t(0);
}([function (e, t, o) {
  e.exports = o(25);
}, function (e, t) {
  "use strict";

  function o() {
    var e = !1,
        t = !1;
    this.stopPropagation = function () {
      e = !0;
    }, this.isPropagationStopped = function () {
      return e;
    }, this.stopImmediatePropagation = function () {
      t = !0;
    }, this.isImmediatePropagationStopped = function () {
      return t;
    };
  }

  function n() {
    var e = [];
    this.subscribe = function (t) {
      e.push(t);
    }, this.unsubscribe = function (t) {
      for (var o = e.length - 1; o >= 0; o--) {
        e[o] === t && e.splice(o, 1);
      }
    }, this.notify = function (t, n, r) {
      n = n || new o(), r = r || this;

      for (var i, s = 0; s < e.length && !n.isPropagationStopped() && !n.isImmediatePropagationStopped(); s++) {
        i = e[s].call(r, n, t);
      }

      return i;
    };
  }

  function r() {
    var e = [];
    this.subscribe = function (t, o) {
      return e.push({
        event: t,
        handler: o
      }), t.subscribe(o), this;
    }, this.unsubscribe = function (t, o) {
      for (var n = e.length; n--;) {
        if (e[n].event === t && e[n].handler === o) return e.splice(n, 1), void t.unsubscribe(o);
      }

      return this;
    }, this.unsubscribeAll = function () {
      for (var t = e.length; t--;) {
        e[t].event.unsubscribe(e[t].handler);
      }

      return e = [], this;
    };
  }

  function i(e, t, o, n) {
    void 0 === o && void 0 === n && (o = e, n = t), this.fromRow = Math.min(e, o), this.fromCell = Math.min(t, n), this.toRow = Math.max(e, o), this.toCell = Math.max(t, n), this.isSingleRow = function () {
      return this.fromRow == this.toRow;
    }, this.isSingleCell = function () {
      return this.fromRow == this.toRow && this.fromCell == this.toCell;
    }, this.contains = function (e, t) {
      return e >= this.fromRow && e <= this.toRow && t >= this.fromCell && t <= this.toCell;
    }, this.toString = function () {
      return this.isSingleCell() ? "(" + this.fromRow + ":" + this.fromCell + ")" : "(" + this.fromRow + ":" + this.fromCell + " - " + this.toRow + ":" + this.toCell + ")";
    };
  }

  function s() {
    this.__nonDataRow = !0;
  }

  function l() {
    this.__group = !0, this.level = 0, this.count = 0, this.value = null, this.title = null, this.collapsed = !1, this.totals = null, this.rows = [], this.groups = null, this.groupingKey = null;
  }

  function a() {
    this.__groupTotals = !0, this.group = null, this.initialized = !1;
  }

  function c() {
    var e = null;
    this.isActive = function (t) {
      return t ? e === t : null !== e;
    }, this.activate = function (t) {
      if (t !== e) {
        if (null !== e) throw "SlickGrid.EditorLock.activate: an editController is still active, can't activate another editController";
        if (!t.commitCurrentEdit) throw "SlickGrid.EditorLock.activate: editController must implement .commitCurrentEdit()";
        if (!t.cancelCurrentEdit) throw "SlickGrid.EditorLock.activate: editController must implement .cancelCurrentEdit()";
        e = t;
      }
    }, this.deactivate = function (t) {
      if (e !== t) throw "SlickGrid.EditorLock.deactivate: specified editController is not the currently active one";
      e = null;
    }, this.commitCurrentEdit = function () {
      return !e || e.commitCurrentEdit();
    }, this.cancelCurrentEdit = function () {
      return !e || e.cancelCurrentEdit();
    };
  }

  function d(e) {
    function t() {
      o(e);
    }

    function o(e) {
      e.forEach(function (e) {
        d[e.id] = e, e.columns && o(e.columns);
      });
    }

    function n(e, t) {
      return e.filter(function (e) {
        var o = t.call(e);
        return o && e.columns && (e.columns = n(e.columns, t)), o && (!e.columns || e.columns.length);
      });
    }

    function r(e, t) {
      e.sort(function (e, o) {
        var n = i(t.getColumnIndex(e.id)),
            r = i(t.getColumnIndex(o.id));
        return n - r;
      }).forEach(function (e) {
        e.columns && r(e.columns, t);
      });
    }

    function i(e) {
      return "undefined" == typeof e ? -1 : e;
    }

    function s(e) {
      if (!e.length) return e.columns ? 1 + s(e.columns) : 1;

      for (var t in e) {
        return s(e[t]);
      }
    }

    function l(e, t, o) {
      var n = [];
      if (o = o || 0, t == o) return e.length && e.forEach(function (e) {
        e.columns && (e.extractColumns = function () {
          return a(e);
        });
      }), e;

      for (var r in e) {
        e[r].columns && (n = n.concat(l(e[r].columns, t, o + 1)));
      }

      return n;
    }

    function a(e) {
      var t = [];
      if (e.hasOwnProperty("length")) for (var o = 0; o < e.length; o++) {
        t = t.concat(a(e[o]));
      } else {
        if (!e.hasOwnProperty("columns")) return e;
        t = t.concat(a(e.columns));
      }
      return t;
    }

    function c() {
      return $.extend(!0, [], e);
    }

    var d = {};
    t(), this.hasDepth = function () {
      for (var t in e) {
        if (e[t].hasOwnProperty("columns")) return !0;
      }

      return !1;
    }, this.getTreeColumns = function () {
      return e;
    }, this.extractColumns = function () {
      return this.hasDepth() ? a(e) : e;
    }, this.getDepth = function () {
      return s(e);
    }, this.getColumnsInDepth = function (t) {
      return l(e, t);
    }, this.getColumnsInGroup = function (e) {
      return a(e);
    }, this.visibleColumns = function () {
      return n(c(), function () {
        return this.visible;
      });
    }, this.filter = function (e) {
      return n(c(), e);
    }, this.reOrder = function (t) {
      return r(e, t);
    }, this.getById = function (e) {
      return d[e];
    }, this.getInIds = function (e) {
      return e.map(function (e) {
        return d[e];
      });
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u = {
    Event: n,
    EventData: o,
    EventHandler: r,
    Range: i,
    NonDataRow: s,
    Group: l,
    GroupTotals: a,
    EditorLock: c,
    GlobalEditorLock: new c(),
    TreeColumns: d,
    keyCode: {
      BACKSPACE: 8,
      DELETE: 46,
      DOWN: 40,
      END: 35,
      ENTER: 13,
      ESCAPE: 27,
      HOME: 36,
      INSERT: 45,
      LEFT: 37,
      PAGE_DOWN: 34,
      PAGE_UP: 33,
      RIGHT: 39,
      TAB: 9,
      UP: 38,
      SPACE: 32
    }
  };
  t.default = u, l.prototype = new s(), l.prototype.equals = function (e) {
    return this.value === e.value && this.count === e.count && this.collapsed === e.collapsed && this.title === e.title;
  }, a.prototype = new s();
}, function (e, t) {
  e.exports = require("jquery");
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e, t) {
    function o(o) {
      r || (r = (0, s.default)("<div></div>", {
        css: t.selectionCss
      }).addClass(t.selectionCssClass).css("position", "absolute").appendTo(e.getCanvasNode()));
      var n = e.getCellNodeBox(o.fromRow, o.fromCell),
          i = e.getCellNodeBox(o.toRow, o.toCell);
      return r.css({
        top: n.top - 1,
        left: n.left - 1,
        height: i.bottom - n.top - 2,
        width: i.right - n.left - 2
      }), r;
    }

    function n() {
      r && (r.remove(), r = null);
    }

    var r = void 0,
        i = {
      selectionCssClass: "slick-range-decorator",
      selectionCss: {
        zIndex: "9999",
        border: "2px dashed red"
      }
    };
    t = Object.assign({}, i, t), Object.assign(this, {
      show: o,
      hide: n
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(2),
      s = n(i),
      l = o(1);
  n(l);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t(t) {
      e = Object.assign({}, m, e), p = new d.default(t, e), c = t, u = c.getCanvasNode(), v.subscribe(c.onDragInit, n).subscribe(c.onDragStart, r).subscribe(c.onDrag, i).subscribe(c.onDragEnd, l);
    }

    function o() {
      v.unsubscribeAll();
    }

    function n(e, t) {
      e.stopImmediatePropagation();
    }

    function r(e, t) {
      var o = c.getCellFromEvent(t.originalEvent);

      if (g.onBeforeCellRangeSelected.notify(o) !== !1 && c.canCellBeSelected(o.row, o.cell) && (h = !0), h) {
        c.focus();
        var n = c.getCellFromPoint(t.x0 - (0, s.default)(u).offset().left, t.y0 - (0, s.default)(u).offset().top);
        return f = {
          start: n,
          end: {}
        }, p.show(new a.default.Range(n.row, n.cell));
      }
    }

    function i(e, t) {
      if (h) {
        var o = c.getCellFromPoint(t.pageX - (0, s.default)(u).offset().left, t.pageY - (0, s.default)(u).offset().top);
        c.canCellBeSelected(o.row, o.cell) && (f.end = o, p.show(new a.default.Range(f.start.row, f.start.cell, o.row, o.cell)));
      }
    }

    function l(e) {
      h && (h = !1, p.hide(), g.onCellRangeSelected.notify({
        range: new a.default.Range(f.start.row, f.start.cell, f.end.row, f.end.cell)
      }), f = {});
    }

    var c = void 0,
        u = void 0,
        h = void 0,
        p = void 0,
        f = {},
        g = this,
        v = new a.default.EventHandler(),
        m = {
      selectionCss: {}
    };
    Object.assign(this, {
      init: t,
      destroy: o,
      onBeforeCellRangeSelected: new a.default.Event(),
      onCellRangeSelected: new a.default.Event()
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(2),
      s = n(i),
      l = o(1),
      a = n(l),
      c = o(3),
      d = n(c);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  };
  !function (o) {
    function r() {}

    function i(e) {
      if (!e || "object" !== ("undefined" == typeof e ? "undefined" : n(e))) return !1;
      var t = $(e) || Ce;
      return /object|function/.test(n(t.Element)) ? e instanceof t.Element : 1 === e.nodeType && "string" == typeof e.nodeName;
    }

    function s(e) {
      return e === Ce || !(!e || !e.Window) && e instanceof e.Window;
    }

    function l(e) {
      return !!e && e instanceof ye;
    }

    function a(e) {
      return c(e) && void 0 !== n(e.length) && d(e.splice);
    }

    function c(e) {
      return !!e && "object" === ("undefined" == typeof e ? "undefined" : n(e));
    }

    function d(e) {
      return "function" == typeof e;
    }

    function u(e) {
      return "number" == typeof e;
    }

    function h(e) {
      return "boolean" == typeof e;
    }

    function p(e) {
      return "string" == typeof e;
    }

    function f(e) {
      return !!p(e) && (Re.querySelector(e), !0);
    }

    function g(e, t) {
      for (var o in t) {
        e[o] = t[o];
      }

      return e;
    }

    function v(e, t) {
      for (var o in t) {
        var n = !1;

        for (var r in Ze) {
          if (0 === o.indexOf(r) && Ze[r].test(o)) {
            n = !0;
            break;
          }
        }

        n || (e[o] = t[o]);
      }

      return e;
    }

    function m(e, t) {
      e.page = e.page || {}, e.page.x = t.page.x, e.page.y = t.page.y, e.client = e.client || {}, e.client.x = t.client.x, e.client.y = t.client.y, e.timeStamp = t.timeStamp;
    }

    function w(e, t, o) {
      var n = t.length > 1 ? D(t) : t[0];
      b(n, Pe, o), e.page.x = Pe.x, e.page.y = Pe.y, S(n, Pe, o), e.client.x = Pe.x, e.client.y = Pe.y, e.timeStamp = new Date().getTime();
    }

    function C(e, t, o) {
      e.page.x = o.page.x - t.page.x, e.page.y = o.page.y - t.page.y, e.client.x = o.client.x - t.client.x, e.client.y = o.client.y - t.client.y, e.timeStamp = new Date().getTime() - t.timeStamp;
      var n = Math.max(e.timeStamp / 1e3, .001);
      e.page.speed = $e(e.page.x, e.page.y) / n, e.page.vx = e.page.x / n, e.page.vy = e.page.y / n, e.client.speed = $e(e.client.x, e.page.y) / n, e.client.vx = e.client.x / n, e.client.vy = e.client.y / n;
    }

    function R(e) {
      return e instanceof Ce.Event || He && Ce.Touch && e instanceof Ce.Touch;
    }

    function y(e, t, o) {
      return o = o || {}, e = e || "page", o.x = t[e + "X"], o.y = t[e + "Y"], o;
    }

    function b(e, t) {
      return t = t || {}, Ye && R(e) ? (y("screen", e, t), t.x += Ce.scrollX, t.y += Ce.scrollY) : y("page", e, t), t;
    }

    function S(e, t) {
      return t = t || {}, Ye && R(e) ? y("screen", e, t) : y("client", e, t), t;
    }

    function x(e) {
      return e = e || Ce, {
        x: e.scrollX || e.document.documentElement.scrollLeft,
        y: e.scrollY || e.document.documentElement.scrollTop
      };
    }

    function E(e) {
      return u(e.pointerId) ? e.pointerId : e.identifier;
    }

    function _(e) {
      return e instanceof xe ? e.correspondingUseElement : e;
    }

    function $(e) {
      if (s(e)) return e;
      var t = e.ownerDocument || e;
      return t.defaultView || t.parentWindow || Ce;
    }

    function P(e) {
      var t = e instanceof be ? e.getBoundingClientRect() : e.getClientRects()[0];
      return t && {
        left: t.left,
        right: t.right,
        top: t.top,
        bottom: t.bottom,
        width: t.width || t.right - t.left,
        height: t.height || t.bottom - t.top
      };
    }

    function T(e) {
      var t = P(e);

      if (!Ge && t) {
        var o = x($(e));
        t.left += o.x, t.right += o.x, t.top += o.y, t.bottom += o.y;
      }

      return t;
    }

    function k(e) {
      var t = [];
      return a(e) ? (t[0] = e[0], t[1] = e[1]) : "touchend" === e.type ? 1 === e.touches.length ? (t[0] = e.touches[0], t[1] = e.changedTouches[0]) : 0 === e.touches.length && (t[0] = e.changedTouches[0], t[1] = e.changedTouches[1]) : (t[0] = e.touches[0], t[1] = e.touches[1]), t;
    }

    function D(e) {
      for (var t, o = {
        pageX: 0,
        pageY: 0,
        clientX: 0,
        clientY: 0,
        screenX: 0,
        screenY: 0
      }, n = 0; n < e.length; n++) {
        for (t in o) {
          o[t] += e[n][t];
        }
      }

      for (t in o) {
        o[t] /= e.length;
      }

      return o;
    }

    function z(e) {
      if (e.length || e.touches && e.touches.length > 1) {
        var t = k(e),
            o = Math.min(t[0].pageX, t[1].pageX),
            n = Math.min(t[0].pageY, t[1].pageY),
            r = Math.max(t[0].pageX, t[1].pageX),
            i = Math.max(t[0].pageY, t[1].pageY);
        return {
          x: o,
          y: n,
          left: o,
          top: n,
          width: r - o,
          height: i - n
        };
      }
    }

    function L(e, t) {
      t = t || Fe.deltaSource;
      var o = t + "X",
          n = t + "Y",
          r = k(e),
          i = r[0][o] - r[1][o],
          s = r[0][n] - r[1][n];
      return $e(i, s);
    }

    function F(e, t, o) {
      o = o || Fe.deltaSource;
      var n = o + "X",
          r = o + "Y",
          i = k(e),
          s = i[0][n] - i[1][n],
          l = i[0][r] - i[1][r],
          a = 180 * Math.atan(l / s) / Math.PI;

      if (u(t)) {
        var c = a - t,
            d = c % 360;
        d > 315 ? a -= 360 + a / 360 | 0 : d > 135 ? a -= 180 + a / 360 | 0 : d < -315 ? a += 360 + a / 360 | 0 : d < -135 && (a += 180 + a / 360 | 0);
      }

      return a;
    }

    function M(e, t) {
      var o = e ? e.options.origin : Fe.origin;
      return "parent" === o ? o = j(t) : "self" === o ? o = e.getRect(t) : f(o) && (o = W(t, o) || {
        x: 0,
        y: 0
      }), d(o) && (o = o(e && t)), i(o) && (o = T(o)), o.x = "x" in o ? o.x : o.left, o.y = "y" in o ? o.y : o.top, o;
    }

    function H(e, t, o, n) {
      var r = 1 - e;
      return r * r * t + 2 * r * e * o + e * e * n;
    }

    function I(e, t, o, n, r, i, s) {
      return {
        x: H(s, e, o, r),
        y: H(s, t, n, i)
      };
    }

    function A(e, t, o, n) {
      return e /= n, -o * e * (e - 2) + t;
    }

    function N(e, t) {
      for (; t;) {
        if (t === e) return !0;
        t = t.parentNode;
      }

      return !1;
    }

    function W(e, t) {
      for (var o = j(e); i(o);) {
        if (ge(o, t)) return o;
        o = j(o);
      }

      return null;
    }

    function j(e) {
      var t = e.parentNode;

      if (l(t)) {
        for (; (t = t.host) && l(t);) {
          ;
        }

        return t;
      }

      return t;
    }

    function q(e, t) {
      return e._context === t.ownerDocument || N(e._context, t);
    }

    function B(e, t, o) {
      var n = e.options.ignoreFrom;
      return !(!n || !i(o)) && (p(n) ? ve(o, n, t) : !!i(n) && N(n, o));
    }

    function V(e, t, o) {
      var n = e.options.allowFrom;
      return !n || !!i(o) && (p(n) ? ve(o, n, t) : !!i(n) && N(n, o));
    }

    function O(e, t) {
      if (!t) return !1;
      var o = t.options.drag.axis;
      return "xy" === e || "xy" === o || o === e;
    }

    function X(e, t) {
      var o = e.options;
      return /^resize/.test(t) && (t = "resize"), o[t].snap && o[t].snap.enabled;
    }

    function Y(e, t) {
      var o = e.options;
      return /^resize/.test(t) && (t = "resize"), o[t].restrict && o[t].restrict.enabled;
    }

    function G(e, t) {
      var o = e.options;
      return /^resize/.test(t) && (t = "resize"), o[t].autoScroll && o[t].autoScroll.enabled;
    }

    function K(e, t, o) {
      for (var n = e.options, r = n[o.name].max, i = n[o.name].maxPerElement, s = 0, l = 0, a = 0, c = 0, d = De.length; c < d; c++) {
        var u = De[c],
            h = u.prepared.name,
            p = u.interacting();

        if (p) {
          if (s++, s >= je) return !1;

          if (u.target === e) {
            if (l += h === o.name | 0, l >= r) return !1;
            if (u.element === t && (a++, h !== o.name || a >= i)) return !1;
          }
        }
      }

      return je > 0;
    }

    function U(e) {
      var t,
          o,
          n,
          r,
          i,
          s = e[0],
          l = s ? 0 : -1,
          a = [],
          c = [];

      for (r = 1; r < e.length; r++) {
        if (t = e[r], t && t !== s) if (s) {
          if (t.parentNode !== t.ownerDocument) if (s.parentNode !== t.ownerDocument) {
            if (!a.length) for (o = s; o.parentNode && o.parentNode !== o.ownerDocument;) {
              a.unshift(o), o = o.parentNode;
            }

            if (s instanceof Ee && t instanceof be && !(t instanceof Se)) {
              if (t === s.parentNode) continue;
              o = t.ownerSVGElement;
            } else o = t;

            for (c = []; o.parentNode !== o.ownerDocument;) {
              c.unshift(o), o = o.parentNode;
            }

            for (i = 0; c[i] && c[i] === a[i];) {
              i++;
            }

            var d = [c[i - 1], c[i], a[i]];

            for (n = d[0].lastChild; n;) {
              if (n === d[1]) {
                s = t, l = r, a = [];
                break;
              }

              if (n === d[2]) break;
              n = n.previousSibling;
            }
          } else s = t, l = r;
        } else s = t, l = r;
      }

      return l;
    }

    function Q() {
      if (this.target = null, this.element = null, this.dropTarget = null, this.dropElement = null, this.prevDropTarget = null, this.prevDropElement = null, this.prepared = {
        name: null,
        axis: null,
        edges: null
      }, this.matches = [], this.matchElements = [], this.inertiaStatus = {
        active: !1,
        smoothEnd: !1,
        ending: !1,
        startEvent: null,
        upCoords: {},
        xe: 0,
        ye: 0,
        sx: 0,
        sy: 0,
        t0: 0,
        vx0: 0,
        vys: 0,
        duration: 0,
        resumeDx: 0,
        resumeDy: 0,
        lambda_v0: 0,
        one_ve_v0: 0,
        i: null
      }, d(Function.prototype.bind)) this.boundInertiaFrame = this.inertiaFrame.bind(this), this.boundSmoothEndFrame = this.smoothEndFrame.bind(this);else {
        var e = this;
        this.boundInertiaFrame = function () {
          return e.inertiaFrame();
        }, this.boundSmoothEndFrame = function () {
          return e.smoothEndFrame();
        };
      }
      this.activeDrops = {
        dropzones: [],
        elements: [],
        rects: []
      }, this.pointers = [], this.pointerIds = [], this.downTargets = [], this.downTimes = [], this.holdTimers = [], this.prevCoords = {
        page: {
          x: 0,
          y: 0
        },
        client: {
          x: 0,
          y: 0
        },
        timeStamp: 0
      }, this.curCoords = {
        page: {
          x: 0,
          y: 0
        },
        client: {
          x: 0,
          y: 0
        },
        timeStamp: 0
      }, this.startCoords = {
        page: {
          x: 0,
          y: 0
        },
        client: {
          x: 0,
          y: 0
        },
        timeStamp: 0
      }, this.pointerDelta = {
        page: {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
          speed: 0
        },
        client: {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
          speed: 0
        },
        timeStamp: 0
      }, this.downEvent = null, this.downPointer = {}, this._eventTarget = null, this._curEventTarget = null, this.prevEvent = null, this.tapTime = 0, this.prevTap = null, this.startOffset = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }, this.restrictOffset = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }, this.snapOffsets = [], this.gesture = {
        start: {
          x: 0,
          y: 0
        },
        startDistance: 0,
        prevDistance: 0,
        distance: 0,
        scale: 1,
        startAngle: 0,
        prevAngle: 0
      }, this.snapStatus = {
        x: 0,
        y: 0,
        dx: 0,
        dy: 0,
        realX: 0,
        realY: 0,
        snappedX: 0,
        snappedY: 0,
        targets: [],
        locked: !1,
        changed: !1
      }, this.restrictStatus = {
        dx: 0,
        dy: 0,
        restrictedX: 0,
        restrictedY: 0,
        snap: null,
        restricted: !1,
        changed: !1
      }, this.restrictStatus.snap = this.snapStatus, this.pointerIsDown = !1, this.pointerWasMoved = !1, this.gesturing = !1, this.dragging = !1, this.resizing = !1, this.resizeAxes = "xy", this.mouse = !1, De.push(this);
    }

    function J(e, t, o) {
      var n,
          r = 0,
          i = De.length,
          s = /mouse/i.test(e.pointerType || t) || 4 === e.pointerType,
          l = E(e);
      if (/down|start/i.test(t)) for (r = 0; r < i; r++) {
        n = De[r];
        var a = o;
        if (n.inertiaStatus.active && n.target.options[n.prepared.name].inertia.allowResume && n.mouse === s) for (; a;) {
          if (a === n.element) return n;
          a = j(a);
        }
      }

      if (s || !He || Ie) {
        for (r = 0; r < i; r++) {
          if (De[r].mouse && !De[r].inertiaStatus.active) return De[r];
        }

        for (r = 0; r < i; r++) {
          if (De[r].mouse && (!/down/.test(t) || !De[r].inertiaStatus.active)) return n;
        }

        return n = new Q(), n.mouse = !0, n;
      }

      for (r = 0; r < i; r++) {
        if (fe(De[r].pointerIds, l)) return De[r];
      }

      if (/up|end|out/i.test(t)) return null;

      for (r = 0; r < i; r++) {
        if (n = De[r], (!n.prepared.name || n.target.options.gesture.enabled) && !n.interacting() && (s || !n.mouse)) return n;
      }

      return new Q();
    }

    function Z(e) {
      return function (t) {
        var o,
            n,
            r = _(t.path ? t.path[0] : t.target),
            i = _(t.currentTarget);

        if (He && /touch/.test(t.type)) for (We = new Date().getTime(), n = 0; n < t.changedTouches.length; n++) {
          var s = t.changedTouches[n];
          o = J(s, t.type, r), o && (o._updateEventTargets(r, i), o[e](s, t, r, i));
        } else {
          if (!Ie && /mouse/.test(t.type)) {
            for (n = 0; n < De.length; n++) {
              if (!De[n].mouse && De[n].pointerIsDown) return;
            }

            if (new Date().getTime() - We < 500) return;
          }

          if (o = J(t, t.type, r), !o) return;
          o._updateEventTargets(r, i), o[e](t, t, r, i);
        }
      };
    }

    function ee(e, t, o, n, r, i) {
      var s,
          l,
          a = e.target,
          c = e.snapStatus,
          d = e.restrictStatus,
          u = e.pointers,
          h = (a && a.options || Fe).deltaSource,
          p = h + "X",
          f = h + "Y",
          v = a ? a.options : Fe,
          m = M(a, r),
          w = "start" === n,
          C = "end" === n,
          R = w ? e.startCoords : e.curCoords;
      r = r || e.element, l = g({}, R.page), s = g({}, R.client), l.x -= m.x, l.y -= m.y, s.x -= m.x, s.y -= m.y;
      var y = v[o].snap && v[o].snap.relativePoints;
      !X(a, o) || w && y && y.length || (this.snap = {
        range: c.range,
        locked: c.locked,
        x: c.snappedX,
        y: c.snappedY,
        realX: c.realX,
        realY: c.realY,
        dx: c.dx,
        dy: c.dy
      }, c.locked && (l.x += c.dx, l.y += c.dy, s.x += c.dx, s.y += c.dy)), !Y(a, o) || w && v[o].restrict.elementRect || !d.restricted || (l.x += d.dx, l.y += d.dy, s.x += d.dx, s.y += d.dy, this.restrict = {
        dx: d.dx,
        dy: d.dy
      }), this.pageX = l.x, this.pageY = l.y, this.clientX = s.x, this.clientY = s.y, this.x0 = e.startCoords.page.x - m.x, this.y0 = e.startCoords.page.y - m.y, this.clientX0 = e.startCoords.client.x - m.x, this.clientY0 = e.startCoords.client.y - m.y, this.ctrlKey = t.ctrlKey, this.altKey = t.altKey, this.shiftKey = t.shiftKey, this.metaKey = t.metaKey, this.button = t.button, this.buttons = t.buttons, this.target = r, this.t0 = e.downTimes[0], this.type = o + (n || ""), this.interaction = e, this.interactable = a;
      var b = e.inertiaStatus;
      if (b.active && (this.detail = "inertia"), i && (this.relatedTarget = i), C ? "client" === h ? (this.dx = s.x - e.startCoords.client.x, this.dy = s.y - e.startCoords.client.y) : (this.dx = l.x - e.startCoords.page.x, this.dy = l.y - e.startCoords.page.y) : w ? (this.dx = 0, this.dy = 0) : "inertiastart" === n ? (this.dx = e.prevEvent.dx, this.dy = e.prevEvent.dy) : "client" === h ? (this.dx = s.x - e.prevEvent.clientX, this.dy = s.y - e.prevEvent.clientY) : (this.dx = l.x - e.prevEvent.pageX, this.dy = l.y - e.prevEvent.pageY), e.prevEvent && "inertia" === e.prevEvent.detail && !b.active && v[o].inertia && v[o].inertia.zeroResumeDelta && (b.resumeDx += this.dx, b.resumeDy += this.dy, this.dx = this.dy = 0), "resize" === o && e.resizeAxes ? v.resize.square ? ("y" === e.resizeAxes ? this.dx = this.dy : this.dy = this.dx, this.axes = "xy") : (this.axes = e.resizeAxes, "x" === e.resizeAxes ? this.dy = 0 : "y" === e.resizeAxes && (this.dx = 0)) : "gesture" === o && (this.touches = [u[0], u[1]], w ? (this.distance = L(u, h), this.box = z(u), this.scale = 1, this.ds = 0, this.angle = F(u, void 0, h), this.da = 0) : C || t instanceof ee ? (this.distance = e.prevEvent.distance, this.box = e.prevEvent.box, this.scale = e.prevEvent.scale, this.ds = this.scale - 1, this.angle = e.prevEvent.angle, this.da = this.angle - e.gesture.startAngle) : (this.distance = L(u, h), this.box = z(u), this.scale = this.distance / e.gesture.startDistance, this.angle = F(u, e.gesture.prevAngle, h), this.ds = this.scale - e.gesture.prevScale, this.da = this.angle - e.gesture.prevAngle)), w) this.timeStamp = e.downTimes[0], this.dt = 0, this.duration = 0, this.speed = 0, this.velocityX = 0, this.velocityY = 0;else if ("inertiastart" === n) this.timeStamp = e.prevEvent.timeStamp, this.dt = e.prevEvent.dt, this.duration = e.prevEvent.duration, this.speed = e.prevEvent.speed, this.velocityX = e.prevEvent.velocityX, this.velocityY = e.prevEvent.velocityY;else if (this.timeStamp = new Date().getTime(), this.dt = this.timeStamp - e.prevEvent.timeStamp, this.duration = this.timeStamp - e.downTimes[0], t instanceof ee) {
        var S = this[p] - e.prevEvent[p],
            x = this[f] - e.prevEvent[f],
            E = this.dt / 1e3;
        this.speed = $e(S, x) / E, this.velocityX = S / E, this.velocityY = x / E;
      } else this.speed = e.pointerDelta[h].speed, this.velocityX = e.pointerDelta[h].vx, this.velocityY = e.pointerDelta[h].vy;

      if ((C || "inertiastart" === n) && e.prevEvent.speed > 600 && this.timeStamp - e.prevEvent.timeStamp < 150) {
        var _ = 180 * Math.atan2(e.prevEvent.velocityY, e.prevEvent.velocityX) / Math.PI,
            $ = 22.5;

        _ < 0 && (_ += 360);
        var P = 135 - $ <= _ && _ < 225 + $,
            T = 225 - $ <= _ && _ < 315 + $,
            k = !P && (315 - $ <= _ || _ < 45 + $),
            D = !T && 45 - $ <= _ && _ < 135 + $;
        this.swipe = {
          up: T,
          down: D,
          left: P,
          right: k,
          angle: _,
          speed: e.prevEvent.speed,
          velocity: {
            x: e.prevEvent.velocityX,
            y: e.prevEvent.velocityY
          }
        };
      }
    }

    function te() {
      this.originalEvent.preventDefault();
    }

    function oe(e) {
      var t = "";
      if ("drag" === e.name && (t = qe.drag), "resize" === e.name) if (e.axis) t = qe[e.name + e.axis];else if (e.edges) {
        for (var o = "resize", n = ["top", "bottom", "left", "right"], r = 0; r < 4; r++) {
          e.edges[n[r]] && (o += n[r]);
        }

        t = qe[o];
      }
      return t;
    }

    function ne(e, t, o, n, r, s, l) {
      if (!t) return !1;

      if (t === !0) {
        var a = u(s.width) ? s.width : s.right - s.left,
            c = u(s.height) ? s.height : s.bottom - s.top;
        if (a < 0 && ("left" === e ? e = "right" : "right" === e && (e = "left")), c < 0 && ("top" === e ? e = "bottom" : "bottom" === e && (e = "top")), "left" === e) return o.x < (a >= 0 ? s.left : s.right) + l;
        if ("top" === e) return o.y < (c >= 0 ? s.top : s.bottom) + l;
        if ("right" === e) return o.x > (a >= 0 ? s.right : s.left) - l;
        if ("bottom" === e) return o.y > (c >= 0 ? s.bottom : s.top) - l;
      }

      return !!i(n) && (i(t) ? t === n : ve(n, t, r));
    }

    function re(e, t, o) {
      var n,
          r = this.getRect(o),
          i = !1,
          s = null,
          l = null,
          a = g({}, t.curCoords.page),
          d = this.options;
      if (!r) return null;

      if (Be.resize && d.resize.enabled) {
        var u = d.resize;

        if (n = {
          left: !1,
          right: !1,
          top: !1,
          bottom: !1
        }, c(u.edges)) {
          for (var h in n) {
            n[h] = ne(h, u.edges[h], a, t._eventTarget, o, r, u.margin || Ae);
          }

          n.left = n.left && !n.right, n.top = n.top && !n.bottom, i = n.left || n.right || n.top || n.bottom;
        } else {
          var p = "y" !== d.resize.axis && a.x > r.right - Ae,
              f = "x" !== d.resize.axis && a.y > r.bottom - Ae;
          i = p || f, l = (p ? "x" : "") + (f ? "y" : "");
        }
      }

      return s = i ? "resize" : Be.drag && d.drag.enabled ? "drag" : null, Be.gesture && t.pointerIds.length >= 2 && !t.dragging && !t.resizing && (s = "gesture"), s ? {
        name: s,
        axis: l,
        edges: n
      } : null;
    }

    function ie(e, t) {
      if (!c(e)) return null;
      var o = e.name,
          n = t.options;
      return ("resize" === o && n.resize.enabled || "drag" === o && n.drag.enabled || "gesture" === o && n.gesture.enabled) && Be[o] ? ("resize" !== o && "resizeyx" !== o || (o = "resizexy"), e) : null;
    }

    function se(e, t) {
      var o = {},
          n = Le[e.type],
          r = _(e.path ? e.path[0] : e.target),
          s = r;

      t = !!t;

      for (var l in e) {
        o[l] = e[l];
      }

      for (o.originalEvent = e, o.preventDefault = te; i(s);) {
        for (var a = 0; a < n.selectors.length; a++) {
          var c = n.selectors[a],
              d = n.contexts[a];

          if (ge(s, c) && N(d, r) && N(d, s)) {
            var u = n.listeners[a];
            o.currentTarget = s;

            for (var h = 0; h < u.length; h++) {
              u[h][1] === t && u[h][0](o);
            }
          }
        }

        s = j(s);
      }
    }

    function le(e) {
      return se.call(this, e, !0);
    }

    function ae(e, t) {
      return ke.get(e, t) || new ce(e, t);
    }

    function ce(e, t) {
      this._element = e, this._iEvents = this._iEvents || {};
      var o;

      if (f(e)) {
        this.selector = e;
        var n = t && t.context;
        o = n ? $(n) : Ce, n && (o.Node ? n instanceof o.Node : i(n) || n === o.document) && (this._context = n);
      } else o = $(e), i(e, o) && (Ie ? (Je.add(this._element, me.down, et.pointerDown), Je.add(this._element, me.move, et.pointerHover)) : (Je.add(this._element, "mousedown", et.pointerDown), Je.add(this._element, "mousemove", et.pointerHover), Je.add(this._element, "touchstart", et.pointerDown), Je.add(this._element, "touchmove", et.pointerHover)));

      this._doc = o.document, fe(Te, this._doc) || he(this._doc), ke.push(this), this.set(t);
    }

    function de(e, t) {
      var o = !1;
      return function () {
        return o || (Ce.console.warn(t), o = !0), e.apply(this, arguments);
      };
    }

    function ue(e) {
      for (var t = 0; t < De.length; t++) {
        De[t].pointerEnd(e, e);
      }
    }

    function he(e) {
      if (!fe(Te, e)) {
        var t = e.defaultView || e.parentWindow;

        for (var o in Le) {
          Je.add(e, o, se), Je.add(e, o, le, !0);
        }

        Ie ? (me = _e === t.MSPointerEvent ? {
          up: "MSPointerUp",
          down: "MSPointerDown",
          over: "mouseover",
          out: "mouseout",
          move: "MSPointerMove",
          cancel: "MSPointerCancel"
        } : {
          up: "pointerup",
          down: "pointerdown",
          over: "pointerover",
          out: "pointerout",
          move: "pointermove",
          cancel: "pointercancel"
        }, Je.add(e, me.down, et.selectorDown), Je.add(e, me.move, et.pointerMove), Je.add(e, me.over, et.pointerOver), Je.add(e, me.out, et.pointerOut), Je.add(e, me.up, et.pointerUp), Je.add(e, me.cancel, et.pointerCancel), Je.add(e, me.move, et.autoScrollMove)) : (Je.add(e, "mousedown", et.selectorDown), Je.add(e, "mousemove", et.pointerMove), Je.add(e, "mouseup", et.pointerUp), Je.add(e, "mouseover", et.pointerOver), Je.add(e, "mouseout", et.pointerOut), Je.add(e, "touchstart", et.selectorDown), Je.add(e, "touchmove", et.pointerMove), Je.add(e, "touchend", et.pointerUp), Je.add(e, "touchcancel", et.pointerCancel), Je.add(e, "mousemove", et.autoScrollMove), Je.add(e, "touchmove", et.autoScrollMove)), Je.add(t, "blur", ue);

        try {
          if (t.frameElement) {
            var n = t.frameElement.ownerDocument,
                r = n.defaultView;
            Je.add(n, "mouseup", et.pointerEnd), Je.add(n, "touchend", et.pointerEnd), Je.add(n, "touchcancel", et.pointerEnd), Je.add(n, "pointerup", et.pointerEnd), Je.add(n, "MSPointerUp", et.pointerEnd), Je.add(r, "blur", ue);
          }
        } catch (e) {
          ae.windowParentError = e;
        }

        Je.add(e, "dragstart", function (e) {
          for (var t = 0; t < De.length; t++) {
            var o = De[t];
            if (o.element && (o.element === e.target || N(o.element, e.target))) return void o.checkAndPreventDefault(e, o.target, o.element);
          }
        }), Je.useAttachEvent && (Je.add(e, "selectstart", function (e) {
          var t = De[0];
          t.currentAction() && t.checkAndPreventDefault(e);
        }), Je.add(e, "dblclick", Z("ie8Dblclick"))), Te.push(e);
      }
    }

    function pe(e, t) {
      for (var o = 0, n = e.length; o < n; o++) {
        if (e[o] === t) return o;
      }

      return -1;
    }

    function fe(e, t) {
      return pe(e, t) !== -1;
    }

    function ge(e, t, n) {
      return we ? we(e, t, n) : (Ce !== o && (t = t.replace(/\/deep\//g, " ")), e[Ke](t));
    }

    function ve(e, t, o) {
      for (; i(e);) {
        if (ge(e, t)) return !0;
        if (e = j(e), e === o) return ge(e, t);
      }

      return !1;
    }

    if (o) {
      var me,
          we,
          Ce = function () {
        var e = o.document.createTextNode("");
        return e.ownerDocument !== o.document && "function" == typeof o.wrap && o.wrap(e) === e ? o.wrap(o) : o;
      }(),
          Re = Ce.document,
          ye = Ce.DocumentFragment || r,
          be = Ce.SVGElement || r,
          Se = Ce.SVGSVGElement || r,
          xe = Ce.SVGElementInstance || r,
          Ee = Ce.HTMLElement || Ce.Element,
          _e = Ce.PointerEvent || Ce.MSPointerEvent,
          $e = Math.hypot || function (e, t) {
        return Math.sqrt(e * e + t * t);
      },
          Pe = {},
          Te = [],
          ke = [],
          De = [],
          ze = !1,
          Le = {},
          Fe = {
        base: {
          accept: null,
          actionChecker: null,
          styleCursor: !0,
          preventDefault: "auto",
          origin: {
            x: 0,
            y: 0
          },
          deltaSource: "page",
          allowFrom: null,
          ignoreFrom: null,
          _context: Re,
          dropChecker: null
        },
        drag: {
          enabled: !1,
          manualStart: !0,
          max: 1 / 0,
          maxPerElement: 1,
          snap: null,
          restrict: null,
          inertia: null,
          autoScroll: null,
          axis: "xy"
        },
        drop: {
          enabled: !1,
          accept: null,
          overlap: "pointer"
        },
        resize: {
          enabled: !1,
          manualStart: !1,
          max: 1 / 0,
          maxPerElement: 1,
          snap: null,
          restrict: null,
          inertia: null,
          autoScroll: null,
          square: !1,
          preserveAspectRatio: !1,
          axis: "xy",
          margin: NaN,
          edges: null,
          invert: "none"
        },
        gesture: {
          manualStart: !1,
          enabled: !1,
          max: 1 / 0,
          maxPerElement: 1,
          restrict: null
        },
        perAction: {
          manualStart: !1,
          max: 1 / 0,
          maxPerElement: 1,
          snap: {
            enabled: !1,
            endOnly: !1,
            range: 1 / 0,
            targets: null,
            offsets: null,
            relativePoints: null
          },
          restrict: {
            enabled: !1,
            endOnly: !1
          },
          autoScroll: {
            enabled: !1,
            container: null,
            margin: 60,
            speed: 300
          },
          inertia: {
            enabled: !1,
            resistance: 10,
            minSpeed: 100,
            endSpeed: 10,
            allowResume: !0,
            zeroResumeDelta: !0,
            smoothEndDuration: 300
          }
        },
        _holdDuration: 600
      },
          Me = {
        interaction: null,
        i: null,
        x: 0,
        y: 0,
        scroll: function scroll() {
          var e,
              t,
              o,
              n,
              r = Me.interaction.target.options[Me.interaction.prepared.name].autoScroll,
              i = r.container || $(Me.interaction.element),
              l = new Date().getTime(),
              a = (l - Me.prevTimeX) / 1e3,
              c = (l - Me.prevTimeY) / 1e3;
          r.velocity ? (e = r.velocity.x, t = r.velocity.y) : e = t = r.speed, o = e * a, n = t * c, (o >= 1 || n >= 1) && (s(i) ? i.scrollBy(Me.x * o, Me.y * n) : i && (i.scrollLeft += Me.x * o, i.scrollTop += Me.y * n), o >= 1 && (Me.prevTimeX = l), n >= 1 && (Me.prevTimeY = l)), Me.isScrolling && (Qe(Me.i), Me.i = Ue(Me.scroll));
        },
        isScrolling: !1,
        prevTimeX: 0,
        prevTimeY: 0,
        start: function start(e) {
          Me.isScrolling = !0, Qe(Me.i), Me.interaction = e, Me.prevTimeX = new Date().getTime(), Me.prevTimeY = new Date().getTime(), Me.i = Ue(Me.scroll);
        },
        stop: function stop() {
          Me.isScrolling = !1, Qe(Me.i);
        }
      },
          He = "ontouchstart" in Ce || Ce.DocumentTouch && Re instanceof Ce.DocumentTouch,
          Ie = _e && !/Chrome/.test(navigator.userAgent),
          Ae = He || Ie ? 20 : 10,
          Ne = 1,
          We = 0,
          je = 1 / 0,
          qe = Re.all && !Ce.atob ? {
        drag: "move",
        resizex: "e-resize",
        resizey: "s-resize",
        resizexy: "se-resize",
        resizetop: "n-resize",
        resizeleft: "w-resize",
        resizebottom: "s-resize",
        resizeright: "e-resize",
        resizetopleft: "se-resize",
        resizebottomright: "se-resize",
        resizetopright: "ne-resize",
        resizebottomleft: "ne-resize",
        gesture: ""
      } : {
        drag: "move",
        resizex: "ew-resize",
        resizey: "ns-resize",
        resizexy: "nwse-resize",
        resizetop: "ns-resize",
        resizeleft: "ew-resize",
        resizebottom: "ns-resize",
        resizeright: "ew-resize",
        resizetopleft: "nwse-resize",
        resizebottomright: "nwse-resize",
        resizetopright: "nesw-resize",
        resizebottomleft: "nesw-resize",
        gesture: ""
      },
          Be = {
        drag: !0,
        resize: !0,
        gesture: !0
      },
          Ve = "onmousewheel" in Re ? "mousewheel" : "wheel",
          Oe = ["dragstart", "dragmove", "draginertiastart", "dragend", "dragenter", "dragleave", "dropactivate", "dropdeactivate", "dropmove", "drop", "resizestart", "resizemove", "resizeinertiastart", "resizeend", "gesturestart", "gesturemove", "gestureinertiastart", "gestureend", "down", "move", "up", "cancel", "tap", "doubletap", "hold"],
          Xe = {},
          Ye = "Opera" == navigator.appName && He && navigator.userAgent.match("Presto"),
          Ge = /iP(hone|od|ad)/.test(navigator.platform) && /OS 7[^\d]/.test(navigator.appVersion),
          Ke = "matches" in Element.prototype ? "matches" : "webkitMatchesSelector" in Element.prototype ? "webkitMatchesSelector" : "mozMatchesSelector" in Element.prototype ? "mozMatchesSelector" : "oMatchesSelector" in Element.prototype ? "oMatchesSelector" : "msMatchesSelector",
          Ue = o.requestAnimationFrame,
          Qe = o.cancelAnimationFrame,
          Je = function () {
        function e(e, t, l, h) {
          var p = pe(c, e),
              f = d[p];

          if (f || (f = {
            events: {},
            typeCount: 0
          }, p = c.push(e) - 1, d.push(f), u.push(i ? {
            supplied: [],
            wrapped: [],
            useCount: []
          } : null)), f.events[t] || (f.events[t] = [], f.typeCount++), !fe(f.events[t], l)) {
            var g;

            if (i) {
              var v = u[p],
                  m = pe(v.supplied, l),
                  w = v.wrapped[m] || function (t) {
                t.immediatePropagationStopped || (t.target = t.srcElement, t.currentTarget = e, t.preventDefault = t.preventDefault || o, t.stopPropagation = t.stopPropagation || n, t.stopImmediatePropagation = t.stopImmediatePropagation || r, /mouse|click/.test(t.type) && (t.pageX = t.clientX + $(e).document.documentElement.scrollLeft, t.pageY = t.clientY + $(e).document.documentElement.scrollTop), l(t));
              };

              g = e[s](a + t, w, Boolean(h)), m === -1 ? (v.supplied.push(l), v.wrapped.push(w), v.useCount.push(1)) : v.useCount[m]++;
            } else g = e[s](t, l, h || !1);

            return f.events[t].push(l), g;
          }
        }

        function t(e, o, n, r) {
          var s,
              h,
              p,
              f = pe(c, e),
              g = d[f],
              v = n;
          if (g && g.events) if (i && (h = u[f], p = pe(h.supplied, n), v = h.wrapped[p]), "all" !== o) {
            if (g.events[o]) {
              var m = g.events[o].length;

              if ("all" === n) {
                for (s = 0; s < m; s++) {
                  t(e, o, g.events[o][s], Boolean(r));
                }

                return;
              }

              for (s = 0; s < m; s++) {
                if (g.events[o][s] === n) {
                  e[l](a + o, v, r || !1), g.events[o].splice(s, 1), i && h && (h.useCount[p]--, 0 === h.useCount[p] && (h.supplied.splice(p, 1), h.wrapped.splice(p, 1), h.useCount.splice(p, 1)));
                  break;
                }
              }

              g.events[o] && 0 === g.events[o].length && (g.events[o] = null, g.typeCount--);
            }

            g.typeCount || (d.splice(f, 1), c.splice(f, 1), u.splice(f, 1));
          } else for (o in g.events) {
            g.events.hasOwnProperty(o) && t(e, o, "all");
          }
        }

        function o() {
          this.returnValue = !1;
        }

        function n() {
          this.cancelBubble = !0;
        }

        function r() {
          this.cancelBubble = !0, this.immediatePropagationStopped = !0;
        }

        var i = "attachEvent" in Ce && !("addEventListener" in Ce),
            s = i ? "attachEvent" : "addEventListener",
            l = i ? "detachEvent" : "removeEventListener",
            a = i ? "on" : "",
            c = [],
            d = [],
            u = [];
        return {
          add: e,
          remove: t,
          useAttachEvent: i,
          _elements: c,
          _targets: d,
          _attachedListeners: u
        };
      }(),
          Ze = {
        webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/
      };

      Q.prototype = {
        getPageXY: function getPageXY(e, t) {
          return b(e, t, this);
        },
        getClientXY: function getClientXY(e, t) {
          return S(e, t, this);
        },
        setEventXY: function setEventXY(e, t) {
          return w(e, t, this);
        },
        pointerOver: function pointerOver(e, t, o) {
          function n(e, t) {
            e && q(e, o) && !B(e, o, o) && V(e, o, o) && ge(o, t) && (r.push(e), i.push(o));
          }

          if (!this.prepared.name && this.mouse) {
            var r = [],
                i = [],
                s = this.element;
            this.addPointer(e), !this.target || !B(this.target, this.element, o) && V(this.target, this.element, o) || (this.target = null, this.element = null, this.matches = [], this.matchElements = []);
            var l = ke.get(o),
                a = l && !B(l, o, o) && V(l, o, o) && ie(l.getAction(e, t, this, o), l);
            a && !K(l, o, a) && (a = null), a ? (this.target = l, this.element = o, this.matches = [], this.matchElements = []) : (ke.forEachSelector(n), this.validateSelector(e, t, r, i) ? (this.matches = r, this.matchElements = i, this.pointerHover(e, t, this.matches, this.matchElements), Je.add(o, Ie ? me.move : "mousemove", et.pointerHover)) : this.target && (N(s, o) ? (this.pointerHover(e, t, this.matches, this.matchElements), Je.add(this.element, Ie ? me.move : "mousemove", et.pointerHover)) : (this.target = null, this.element = null, this.matches = [], this.matchElements = [])));
          }
        },
        pointerHover: function pointerHover(e, t, o, n, r, i) {
          var s = this.target;

          if (!this.prepared.name && this.mouse) {
            var l;
            this.setEventXY(this.curCoords, [e]), r ? l = this.validateSelector(e, t, r, i) : s && (l = ie(s.getAction(this.pointers[0], t, this, this.element), this.target)), s && s.options.styleCursor && (l ? s._doc.documentElement.style.cursor = oe(l) : s._doc.documentElement.style.cursor = "");
          } else this.prepared.name && this.checkAndPreventDefault(t, s, this.element);
        },
        pointerOut: function pointerOut(e, t, o) {
          this.prepared.name || (ke.get(o) || Je.remove(o, Ie ? me.move : "mousemove", et.pointerHover), this.target && this.target.options.styleCursor && !this.interacting() && (this.target._doc.documentElement.style.cursor = ""));
        },
        selectorDown: function selectorDown(e, t, o, n) {
          function r(e, t, n) {
            var r = we ? n.querySelectorAll(t) : void 0;
            q(e, c) && !B(e, c, o) && V(e, c, o) && ge(c, t, r) && (l.matches.push(e), l.matchElements.push(c));
          }

          var s,
              l = this,
              a = Je.useAttachEvent ? g({}, t) : t,
              c = o,
              d = this.addPointer(e);
          if (this.holdTimers[d] = setTimeout(function () {
            l.pointerHold(Je.useAttachEvent ? a : e, a, o, n);
          }, Fe._holdDuration), this.pointerIsDown = !0, this.inertiaStatus.active && this.target.selector) for (; i(c);) {
            if (c === this.element && ie(this.target.getAction(e, t, this, this.element), this.target).name === this.prepared.name) return Qe(this.inertiaStatus.i), this.inertiaStatus.active = !1, void this.collectEventTargets(e, t, o, "down");
            c = j(c);
          }
          if (this.interacting()) return void this.collectEventTargets(e, t, o, "down");

          for (this.setEventXY(this.curCoords, [e]), this.downEvent = t; i(c) && !s;) {
            this.matches = [], this.matchElements = [], ke.forEachSelector(r), s = this.validateSelector(e, t, this.matches, this.matchElements), c = j(c);
          }

          return s ? (this.prepared.name = s.name, this.prepared.axis = s.axis, this.prepared.edges = s.edges, this.collectEventTargets(e, t, o, "down"), this.pointerDown(e, t, o, n, s)) : (this.downTimes[d] = new Date().getTime(), this.downTargets[d] = o, v(this.downPointer, e), m(this.prevCoords, this.curCoords), this.pointerWasMoved = !1, void this.collectEventTargets(e, t, o, "down"));
        },
        pointerDown: function pointerDown(e, t, o, n, r) {
          if (!r && !this.inertiaStatus.active && this.pointerWasMoved && this.prepared.name) return void this.checkAndPreventDefault(t, this.target, this.element);
          this.pointerIsDown = !0, this.downEvent = t;
          var i,
              s = this.addPointer(e);

          if (this.pointerIds.length > 1 && this.target._element === this.element) {
            var l = ie(r || this.target.getAction(e, t, this, this.element), this.target);
            K(this.target, this.element, l) && (i = l), this.prepared.name = null;
          } else if (!this.prepared.name) {
            var a = ke.get(n);
            a && !B(a, n, o) && V(a, n, o) && (i = ie(r || a.getAction(e, t, this, n), a, o)) && K(a, n, i) && (this.target = a, this.element = n);
          }

          var c = this.target,
              d = c && c.options;
          if (!c || !r && this.prepared.name) this.inertiaStatus.active && n === this.element && ie(c.getAction(e, t, this, this.element), c).name === this.prepared.name && (Qe(this.inertiaStatus.i), this.inertiaStatus.active = !1, this.checkAndPreventDefault(t, c, this.element));else {
            if (i = i || ie(r || c.getAction(e, t, this, n), c, this.element), this.setEventXY(this.startCoords, this.pointers), !i) return;
            d.styleCursor && (c._doc.documentElement.style.cursor = oe(i)), this.resizeAxes = "resize" === i.name ? i.axis : null, "gesture" === i && this.pointerIds.length < 2 && (i = null), this.prepared.name = i.name, this.prepared.axis = i.axis, this.prepared.edges = i.edges, this.snapStatus.snappedX = this.snapStatus.snappedY = this.restrictStatus.restrictedX = this.restrictStatus.restrictedY = NaN, this.downTimes[s] = new Date().getTime(), this.downTargets[s] = o, v(this.downPointer, e), m(this.prevCoords, this.startCoords), this.pointerWasMoved = !1, this.checkAndPreventDefault(t, c, this.element);
          }
        },
        setModifications: function setModifications(e, t) {
          var o = this.target,
              n = !0,
              r = X(o, this.prepared.name) && (!o.options[this.prepared.name].snap.endOnly || t),
              i = Y(o, this.prepared.name) && (!o.options[this.prepared.name].restrict.endOnly || t);
          return r ? this.setSnapping(e) : this.snapStatus.locked = !1, i ? this.setRestriction(e) : this.restrictStatus.restricted = !1, r && this.snapStatus.locked && !this.snapStatus.changed ? n = i && this.restrictStatus.restricted && this.restrictStatus.changed : i && this.restrictStatus.restricted && !this.restrictStatus.changed && (n = !1), n;
        },
        setStartOffsets: function setStartOffsets(e, t, o) {
          var n,
              r,
              i = t.getRect(o),
              s = M(t, o),
              l = t.options[this.prepared.name].snap,
              a = t.options[this.prepared.name].restrict;
          i ? (this.startOffset.left = this.startCoords.page.x - i.left, this.startOffset.top = this.startCoords.page.y - i.top, this.startOffset.right = i.right - this.startCoords.page.x, this.startOffset.bottom = i.bottom - this.startCoords.page.y, n = "width" in i ? i.width : i.right - i.left, r = "height" in i ? i.height : i.bottom - i.top) : this.startOffset.left = this.startOffset.top = this.startOffset.right = this.startOffset.bottom = 0, this.snapOffsets.splice(0);
          var c = l && "startCoords" === l.offset ? {
            x: this.startCoords.page.x - s.x,
            y: this.startCoords.page.y - s.y
          } : l && l.offset || {
            x: 0,
            y: 0
          };
          if (i && l && l.relativePoints && l.relativePoints.length) for (var d = 0; d < l.relativePoints.length; d++) {
            this.snapOffsets.push({
              x: this.startOffset.left - n * l.relativePoints[d].x + c.x,
              y: this.startOffset.top - r * l.relativePoints[d].y + c.y
            });
          } else this.snapOffsets.push(c);
          i && a.elementRect ? (this.restrictOffset.left = this.startOffset.left - n * a.elementRect.left, this.restrictOffset.top = this.startOffset.top - r * a.elementRect.top, this.restrictOffset.right = this.startOffset.right - n * (1 - a.elementRect.right), this.restrictOffset.bottom = this.startOffset.bottom - r * (1 - a.elementRect.bottom)) : this.restrictOffset.left = this.restrictOffset.top = this.restrictOffset.right = this.restrictOffset.bottom = 0;
        },
        start: function start(e, t, o) {
          this.interacting() || !this.pointerIsDown || this.pointerIds.length < ("gesture" === e.name ? 2 : 1) || (pe(De, this) === -1 && De.push(this), this.prepared.name || this.setEventXY(this.startCoords), this.prepared.name = e.name, this.prepared.axis = e.axis, this.prepared.edges = e.edges, this.target = t, this.element = o, this.setStartOffsets(e.name, t, o), this.setModifications(this.startCoords.page), this.prevEvent = this[this.prepared.name + "Start"](this.downEvent));
        },
        pointerMove: function pointerMove(e, t, o, n, r) {
          if (this.inertiaStatus.active) {
            var s = this.inertiaStatus.upCoords.page,
                l = this.inertiaStatus.upCoords.client,
                a = {
              pageX: s.x + this.inertiaStatus.sx,
              pageY: s.y + this.inertiaStatus.sy,
              clientX: l.x + this.inertiaStatus.sx,
              clientY: l.y + this.inertiaStatus.sy
            };
            this.setEventXY(this.curCoords, [a]);
          } else this.recordPointer(e), this.setEventXY(this.curCoords, this.pointers);

          var c,
              d,
              u = this.curCoords.page.x === this.prevCoords.page.x && this.curCoords.page.y === this.prevCoords.page.y && this.curCoords.client.x === this.prevCoords.client.x && this.curCoords.client.y === this.prevCoords.client.y,
              h = this.mouse ? 0 : pe(this.pointerIds, E(e));

          if (this.pointerIsDown && !this.pointerWasMoved && (c = this.curCoords.client.x - this.startCoords.client.x, d = this.curCoords.client.y - this.startCoords.client.y, this.pointerWasMoved = $e(c, d) > Ne), u || this.pointerIsDown && !this.pointerWasMoved || (this.pointerIsDown && clearTimeout(this.holdTimers[h]), this.collectEventTargets(e, t, o, "move")), this.pointerIsDown) {
            if (u && this.pointerWasMoved && !r) return void this.checkAndPreventDefault(t, this.target, this.element);

            if (C(this.pointerDelta, this.prevCoords, this.curCoords), this.prepared.name) {
              if (this.pointerWasMoved && (!this.inertiaStatus.active || e instanceof ee && /inertiastart/.test(e.type))) {
                if (!this.interacting() && (C(this.pointerDelta, this.prevCoords, this.curCoords), "drag" === this.prepared.name)) {
                  var p = Math.abs(c),
                      f = Math.abs(d),
                      g = this.target.options.drag.axis,
                      v = p > f ? "x" : p < f ? "y" : "xy";

                  if ("xy" !== v && "xy" !== g && g !== v) {
                    this.prepared.name = null;

                    for (var w = o; i(w);) {
                      var R = ke.get(w);

                      if (R && R !== this.target && !R.options.drag.manualStart && "drag" === R.getAction(this.downPointer, this.downEvent, this, w).name && O(v, R)) {
                        this.prepared.name = "drag", this.target = R, this.element = w;
                        break;
                      }

                      w = j(w);
                    }

                    if (!this.prepared.name) {
                      var y = this,
                          b = function b(e, t, n) {
                        var r = we ? n.querySelectorAll(t) : void 0;
                        if (e !== y.target) return q(e, o) && !e.options.drag.manualStart && !B(e, w, o) && V(e, w, o) && ge(w, t, r) && "drag" === e.getAction(y.downPointer, y.downEvent, y, w).name && O(v, e) && K(e, w, "drag") ? e : void 0;
                      };

                      for (w = o; i(w);) {
                        var S = ke.forEachSelector(b);

                        if (S) {
                          this.prepared.name = "drag", this.target = S, this.element = w;
                          break;
                        }

                        w = j(w);
                      }
                    }
                  }
                }

                var x = !!this.prepared.name && !this.interacting();
                if (x && (this.target.options[this.prepared.name].manualStart || !K(this.target, this.element, this.prepared))) return void this.stop(t);

                if (this.prepared.name && this.target) {
                  x && this.start(this.prepared, this.target, this.element);

                  var _ = this.setModifications(this.curCoords.page, r);

                  (_ || x) && (this.prevEvent = this[this.prepared.name + "Move"](t)), this.checkAndPreventDefault(t, this.target, this.element);
                }
              }

              m(this.prevCoords, this.curCoords), (this.dragging || this.resizing) && this.autoScrollMove(e);
            }
          }
        },
        dragStart: function dragStart(e) {
          var t = new ee(this, e, "drag", "start", this.element);
          t.originalEvent = e, this.dragging = !0, this.target.fire(t), this.activeDrops.dropzones = [], this.activeDrops.elements = [], this.activeDrops.rects = [], this.dynamicDrop || this.setActiveDrops(this.element);
          var o = this.getDropEvents(e, t);
          return o.activate && this.fireActiveDrops(o.activate), t;
        },
        dragMove: function dragMove(e) {
          var t = this.target,
              o = new ee(this, e, "drag", "move", this.element),
              n = this.element,
              r = this.getDrop(o, e, n);
          o.originalEvent = e, this.dropTarget = r.dropzone, this.dropElement = r.element;
          var i = this.getDropEvents(e, o);
          return t.fire(o), i.leave && this.prevDropTarget.fire(i.leave), i.enter && this.dropTarget.fire(i.enter), i.move && this.dropTarget.fire(i.move), this.prevDropTarget = this.dropTarget, this.prevDropElement = this.dropElement, o;
        },
        resizeStart: function resizeStart(e) {
          var t = new ee(this, e, "resize", "start", this.element);

          if (this.prepared.edges) {
            var o = this.target.getRect(this.element);

            if (this.target.options.resize.square || this.target.options.resize.preserveAspectRatio) {
              var n = g({}, this.prepared.edges);
              n.top = n.top || n.left && !n.bottom, n.left = n.left || n.top && !n.right, n.bottom = n.bottom || n.right && !n.top, n.right = n.right || n.bottom && !n.left, this.prepared._linkedEdges = n;
            } else this.prepared._linkedEdges = null;

            this.target.options.resize.preserveAspectRatio && (this.resizeStartAspectRatio = o.width / o.height), this.resizeRects = {
              start: o,
              current: g({}, o),
              restricted: g({}, o),
              previous: g({}, o),
              delta: {
                left: 0,
                right: 0,
                width: 0,
                top: 0,
                bottom: 0,
                height: 0
              }
            }, t.rect = this.resizeRects.restricted, t.deltaRect = this.resizeRects.delta;
          }

          return this.target.fire(t), this.resizing = !0, t;
        },
        resizeMove: function resizeMove(e) {
          var t = new ee(this, e, "resize", "move", this.element),
              o = this.prepared.edges,
              n = this.target.options.resize.invert,
              r = "reposition" === n || "negate" === n;

          if (o) {
            var i = t.dx,
                s = t.dy,
                l = this.resizeRects.start,
                a = this.resizeRects.current,
                c = this.resizeRects.restricted,
                d = this.resizeRects.delta,
                u = g(this.resizeRects.previous, c),
                h = o;

            if (this.target.options.resize.preserveAspectRatio) {
              var p = this.resizeStartAspectRatio;
              o = this.prepared._linkedEdges, h.left && h.bottom || h.right && h.top ? s = -i / p : h.left || h.right ? s = i / p : (h.top || h.bottom) && (i = s * p);
            } else this.target.options.resize.square && (o = this.prepared._linkedEdges, h.left && h.bottom || h.right && h.top ? s = -i : h.left || h.right ? s = i : (h.top || h.bottom) && (i = s));

            if (o.top && (a.top += s), o.bottom && (a.bottom += s), o.left && (a.left += i), o.right && (a.right += i), r) {
              if (g(c, a), "reposition" === n) {
                var f;
                c.top > c.bottom && (f = c.top, c.top = c.bottom, c.bottom = f), c.left > c.right && (f = c.left, c.left = c.right, c.right = f);
              }
            } else c.top = Math.min(a.top, l.bottom), c.bottom = Math.max(a.bottom, l.top), c.left = Math.min(a.left, l.right), c.right = Math.max(a.right, l.left);

            c.width = c.right - c.left, c.height = c.bottom - c.top;

            for (var v in c) {
              d[v] = c[v] - u[v];
            }

            t.edges = this.prepared.edges, t.rect = c, t.deltaRect = d;
          }

          return this.target.fire(t), t;
        },
        gestureStart: function gestureStart(e) {
          var t = new ee(this, e, "gesture", "start", this.element);
          return t.ds = 0, this.gesture.startDistance = this.gesture.prevDistance = t.distance, this.gesture.startAngle = this.gesture.prevAngle = t.angle, this.gesture.scale = 1, this.gesturing = !0, this.target.fire(t), t;
        },
        gestureMove: function gestureMove(e) {
          if (!this.pointerIds.length) return this.prevEvent;
          var t;
          return t = new ee(this, e, "gesture", "move", this.element), t.ds = t.scale - this.gesture.scale, this.target.fire(t), this.gesture.prevAngle = t.angle, this.gesture.prevDistance = t.distance, t.scale === 1 / 0 || null === t.scale || void 0 === t.scale || isNaN(t.scale) || (this.gesture.scale = t.scale), t;
        },
        pointerHold: function pointerHold(e, t, o) {
          this.collectEventTargets(e, t, o, "hold");
        },
        pointerUp: function pointerUp(e, t, o, n) {
          var r = this.mouse ? 0 : pe(this.pointerIds, E(e));
          clearTimeout(this.holdTimers[r]), this.collectEventTargets(e, t, o, "up"), this.collectEventTargets(e, t, o, "tap"), this.pointerEnd(e, t, o, n), this.removePointer(e);
        },
        pointerCancel: function pointerCancel(e, t, o, n) {
          var r = this.mouse ? 0 : pe(this.pointerIds, E(e));
          clearTimeout(this.holdTimers[r]), this.collectEventTargets(e, t, o, "cancel"), this.pointerEnd(e, t, o, n), this.removePointer(e);
        },
        ie8Dblclick: function ie8Dblclick(e, t, o) {
          this.prevTap && t.clientX === this.prevTap.clientX && t.clientY === this.prevTap.clientY && o === this.prevTap.target && (this.downTargets[0] = o, this.downTimes[0] = new Date().getTime(), this.collectEventTargets(e, t, o, "tap"));
        },
        pointerEnd: function pointerEnd(e, t, o, n) {
          var r,
              i = this.target,
              s = i && i.options,
              l = s && this.prepared.name && s[this.prepared.name].inertia,
              a = this.inertiaStatus;

          if (this.interacting()) {
            if (a.active && !a.ending) return;
            var c,
                d,
                u = new Date().getTime(),
                h = !1,
                p = !1,
                f = !1,
                v = X(i, this.prepared.name) && s[this.prepared.name].snap.endOnly,
                w = Y(i, this.prepared.name) && s[this.prepared.name].restrict.endOnly,
                C = 0,
                R = 0;

            if (c = this.dragging ? "x" === s.drag.axis ? Math.abs(this.pointerDelta.client.vx) : "y" === s.drag.axis ? Math.abs(this.pointerDelta.client.vy) : this.pointerDelta.client.speed : this.pointerDelta.client.speed, h = l && l.enabled && "gesture" !== this.prepared.name && t !== a.startEvent, p = h && u - this.curCoords.timeStamp < 50 && c > l.minSpeed && c > l.endSpeed, h && !p && (v || w)) {
              var y = {};
              y.snap = y.restrict = y, v && (this.setSnapping(this.curCoords.page, y), y.locked && (C += y.dx, R += y.dy)), w && (this.setRestriction(this.curCoords.page, y), y.restricted && (C += y.dx, R += y.dy)), (C || R) && (f = !0);
            }

            if (p || f) {
              if (m(a.upCoords, this.curCoords), this.pointers[0] = a.startEvent = d = new ee(this, t, this.prepared.name, "inertiastart", this.element), a.t0 = u, i.fire(a.startEvent), p) {
                a.vx0 = this.pointerDelta.client.vx, a.vy0 = this.pointerDelta.client.vy, a.v0 = c, this.calcInertia(a);
                var b,
                    S = g({}, this.curCoords.page),
                    x = M(i, this.element);

                if (S.x = S.x + a.xe - x.x, S.y = S.y + a.ye - x.y, b = {
                  useStatusXY: !0,
                  x: S.x,
                  y: S.y,
                  dx: 0,
                  dy: 0,
                  snap: null
                }, b.snap = b, C = R = 0, v) {
                  var E = this.setSnapping(this.curCoords.page, b);
                  E.locked && (C += E.dx, R += E.dy);
                }

                if (w) {
                  var _ = this.setRestriction(this.curCoords.page, b);

                  _.restricted && (C += _.dx, R += _.dy);
                }

                a.modifiedXe += C, a.modifiedYe += R, a.i = Ue(this.boundInertiaFrame);
              } else a.smoothEnd = !0, a.xe = C, a.ye = R, a.sx = a.sy = 0, a.i = Ue(this.boundSmoothEndFrame);

              return void (a.active = !0);
            }

            (v || w) && this.pointerMove(e, t, o, n, !0);
          }

          if (this.dragging) {
            r = new ee(this, t, "drag", "end", this.element);
            var $ = this.element,
                P = this.getDrop(r, t, $);
            this.dropTarget = P.dropzone, this.dropElement = P.element;
            var T = this.getDropEvents(t, r);
            T.leave && this.prevDropTarget.fire(T.leave), T.enter && this.dropTarget.fire(T.enter), T.drop && this.dropTarget.fire(T.drop), T.deactivate && this.fireActiveDrops(T.deactivate), i.fire(r);
          } else this.resizing ? (r = new ee(this, t, "resize", "end", this.element), i.fire(r)) : this.gesturing && (r = new ee(this, t, "gesture", "end", this.element), i.fire(r));

          this.stop(t);
        },
        collectDrops: function collectDrops(e) {
          var t,
              o = [],
              n = [];

          for (e = e || this.element, t = 0; t < ke.length; t++) {
            if (ke[t].options.drop.enabled) {
              var r = ke[t],
                  s = r.options.drop.accept;
              if (!(i(s) && s !== e || p(s) && !ge(e, s))) for (var l = r.selector ? r._context.querySelectorAll(r.selector) : [r._element], a = 0, c = l.length; a < c; a++) {
                var d = l[a];
                d !== e && (o.push(r), n.push(d));
              }
            }
          }

          return {
            dropzones: o,
            elements: n
          };
        },
        fireActiveDrops: function fireActiveDrops(e) {
          var t, o, n, r;

          for (t = 0; t < this.activeDrops.dropzones.length; t++) {
            o = this.activeDrops.dropzones[t], n = this.activeDrops.elements[t], n !== r && (e.target = n, o.fire(e)), r = n;
          }
        },
        setActiveDrops: function setActiveDrops(e) {
          var t = this.collectDrops(e, !0);
          this.activeDrops.dropzones = t.dropzones, this.activeDrops.elements = t.elements, this.activeDrops.rects = [];

          for (var o = 0; o < this.activeDrops.dropzones.length; o++) {
            this.activeDrops.rects[o] = this.activeDrops.dropzones[o].getRect(this.activeDrops.elements[o]);
          }
        },
        getDrop: function getDrop(e, t, o) {
          var n = [];
          ze && this.setActiveDrops(o);

          for (var r = 0; r < this.activeDrops.dropzones.length; r++) {
            var i = this.activeDrops.dropzones[r],
                s = this.activeDrops.elements[r],
                l = this.activeDrops.rects[r];
            n.push(i.dropCheck(e, t, this.target, o, s, l) ? s : null);
          }

          var a = U(n),
              c = this.activeDrops.dropzones[a] || null,
              d = this.activeDrops.elements[a] || null;
          return {
            dropzone: c,
            element: d
          };
        },
        getDropEvents: function getDropEvents(e, t) {
          var o = {
            enter: null,
            leave: null,
            activate: null,
            deactivate: null,
            move: null,
            drop: null
          };
          return this.dropElement !== this.prevDropElement && (this.prevDropTarget && (o.leave = {
            target: this.prevDropElement,
            dropzone: this.prevDropTarget,
            relatedTarget: t.target,
            draggable: t.interactable,
            dragEvent: t,
            interaction: this,
            timeStamp: t.timeStamp,
            type: "dragleave"
          }, t.dragLeave = this.prevDropElement, t.prevDropzone = this.prevDropTarget), this.dropTarget && (o.enter = {
            target: this.dropElement,
            dropzone: this.dropTarget,
            relatedTarget: t.target,
            draggable: t.interactable,
            dragEvent: t,
            interaction: this,
            timeStamp: t.timeStamp,
            type: "dragenter"
          }, t.dragEnter = this.dropElement, t.dropzone = this.dropTarget)), "dragend" === t.type && this.dropTarget && (o.drop = {
            target: this.dropElement,
            dropzone: this.dropTarget,
            relatedTarget: t.target,
            draggable: t.interactable,
            dragEvent: t,
            interaction: this,
            timeStamp: t.timeStamp,
            type: "drop"
          }, t.dropzone = this.dropTarget), "dragstart" === t.type && (o.activate = {
            target: null,
            dropzone: null,
            relatedTarget: t.target,
            draggable: t.interactable,
            dragEvent: t,
            interaction: this,
            timeStamp: t.timeStamp,
            type: "dropactivate"
          }), "dragend" === t.type && (o.deactivate = {
            target: null,
            dropzone: null,
            relatedTarget: t.target,
            draggable: t.interactable,
            dragEvent: t,
            interaction: this,
            timeStamp: t.timeStamp,
            type: "dropdeactivate"
          }), "dragmove" === t.type && this.dropTarget && (o.move = {
            target: this.dropElement,
            dropzone: this.dropTarget,
            relatedTarget: t.target,
            draggable: t.interactable,
            dragEvent: t,
            interaction: this,
            dragmove: t,
            timeStamp: t.timeStamp,
            type: "dropmove"
          }, t.dropzone = this.dropTarget), o;
        },
        currentAction: function currentAction() {
          return this.dragging && "drag" || this.resizing && "resize" || this.gesturing && "gesture" || null;
        },
        interacting: function interacting() {
          return this.dragging || this.resizing || this.gesturing;
        },
        clearTargets: function clearTargets() {
          this.target = this.element = null, this.dropTarget = this.dropElement = this.prevDropTarget = this.prevDropElement = null;
        },
        stop: function stop(e) {
          if (this.interacting()) {
            Me.stop(), this.matches = [], this.matchElements = [];
            var t = this.target;
            t.options.styleCursor && (t._doc.documentElement.style.cursor = ""), e && d(e.preventDefault) && this.checkAndPreventDefault(e, t, this.element), this.dragging && (this.activeDrops.dropzones = this.activeDrops.elements = this.activeDrops.rects = null);
          }

          this.clearTargets(), this.pointerIsDown = this.snapStatus.locked = this.dragging = this.resizing = this.gesturing = !1, this.prepared.name = this.prevEvent = null, this.inertiaStatus.resumeDx = this.inertiaStatus.resumeDy = 0;

          for (var o = 0; o < this.pointers.length; o++) {
            pe(this.pointerIds, E(this.pointers[o])) === -1 && this.pointers.splice(o, 1);
          }
        },
        inertiaFrame: function inertiaFrame() {
          var e = this.inertiaStatus,
              t = this.target.options[this.prepared.name].inertia,
              o = t.resistance,
              n = new Date().getTime() / 1e3 - e.t0;

          if (n < e.te) {
            var r = 1 - (Math.exp(-o * n) - e.lambda_v0) / e.one_ve_v0;
            if (e.modifiedXe === e.xe && e.modifiedYe === e.ye) e.sx = e.xe * r, e.sy = e.ye * r;else {
              var i = I(0, 0, e.xe, e.ye, e.modifiedXe, e.modifiedYe, r);
              e.sx = i.x, e.sy = i.y;
            }
            this.pointerMove(e.startEvent, e.startEvent), e.i = Ue(this.boundInertiaFrame);
          } else e.ending = !0, e.sx = e.modifiedXe, e.sy = e.modifiedYe, this.pointerMove(e.startEvent, e.startEvent), this.pointerEnd(e.startEvent, e.startEvent), e.active = e.ending = !1;
        },
        smoothEndFrame: function smoothEndFrame() {
          var e = this.inertiaStatus,
              t = new Date().getTime() - e.t0,
              o = this.target.options[this.prepared.name].inertia.smoothEndDuration;
          t < o ? (e.sx = A(t, 0, e.xe, o), e.sy = A(t, 0, e.ye, o), this.pointerMove(e.startEvent, e.startEvent), e.i = Ue(this.boundSmoothEndFrame)) : (e.ending = !0, e.sx = e.xe, e.sy = e.ye, this.pointerMove(e.startEvent, e.startEvent), this.pointerEnd(e.startEvent, e.startEvent), e.smoothEnd = e.active = e.ending = !1);
        },
        addPointer: function addPointer(e) {
          var t = E(e),
              o = this.mouse ? 0 : pe(this.pointerIds, t);
          return o === -1 && (o = this.pointerIds.length), this.pointerIds[o] = t, this.pointers[o] = e, o;
        },
        removePointer: function removePointer(e) {
          var t = E(e),
              o = this.mouse ? 0 : pe(this.pointerIds, t);
          o !== -1 && (this.pointers.splice(o, 1), this.pointerIds.splice(o, 1), this.downTargets.splice(o, 1), this.downTimes.splice(o, 1), this.holdTimers.splice(o, 1));
        },
        recordPointer: function recordPointer(e) {
          var t = this.mouse ? 0 : pe(this.pointerIds, E(e));
          t !== -1 && (this.pointers[t] = e);
        },
        collectEventTargets: function collectEventTargets(e, t, o, n) {
          function r(e, t, r) {
            var s = we ? r.querySelectorAll(t) : void 0;
            e._iEvents[n] && i(c) && q(e, c) && !B(e, c, o) && V(e, c, o) && ge(c, t, s) && (l.push(e), a.push(c));
          }

          var s = this.mouse ? 0 : pe(this.pointerIds, E(e));

          if ("tap" !== n || !this.pointerWasMoved && this.downTargets[s] && this.downTargets[s] === o) {
            for (var l = [], a = [], c = o; c;) {
              ae.isSet(c) && ae(c)._iEvents[n] && (l.push(ae(c)), a.push(c)), ke.forEachSelector(r), c = j(c);
            }

            (l.length || "tap" === n) && this.firePointers(e, t, o, l, a, n);
          }
        },
        firePointers: function firePointers(e, t, o, n, r, i) {
          var s,
              l,
              a,
              c = this.mouse ? 0 : pe(this.pointerIds, E(e)),
              d = {};

          for ("doubletap" === i ? d = e : (v(d, t), t !== e && v(d, e), d.preventDefault = te, d.stopPropagation = ee.prototype.stopPropagation, d.stopImmediatePropagation = ee.prototype.stopImmediatePropagation, d.interaction = this, d.timeStamp = new Date().getTime(), d.originalEvent = t, d.originalPointer = e, d.type = i, d.pointerId = E(e), d.pointerType = this.mouse ? "mouse" : Ie ? p(e.pointerType) ? e.pointerType : [,, "touch", "pen", "mouse"][e.pointerType] : "touch"), "tap" === i && (d.dt = d.timeStamp - this.downTimes[c], l = d.timeStamp - this.tapTime, a = !!(this.prevTap && "doubletap" !== this.prevTap.type && this.prevTap.target === d.target && l < 500), d.double = a, this.tapTime = d.timeStamp), s = 0; s < n.length && (d.currentTarget = r[s], d.interactable = n[s], n[s].fire(d), !(d.immediatePropagationStopped || d.propagationStopped && r[s + 1] !== d.currentTarget)); s++) {
            ;
          }

          if (a) {
            var u = {};
            g(u, d), u.dt = l, u.type = "doubletap", this.collectEventTargets(u, t, o, "doubletap"), this.prevTap = u;
          } else "tap" === i && (this.prevTap = d);
        },
        validateSelector: function validateSelector(e, t, o, n) {
          for (var r = 0, i = o.length; r < i; r++) {
            var s = o[r],
                l = n[r],
                a = ie(s.getAction(e, t, this, l), s);
            if (a && K(s, l, a)) return this.target = s, this.element = l, a;
          }
        },
        setSnapping: function setSnapping(e, t) {
          var o,
              n,
              r,
              i = this.target.options[this.prepared.name].snap,
              s = [];
          if (t = t || this.snapStatus, t.useStatusXY) n = {
            x: t.x,
            y: t.y
          };else {
            var l = M(this.target, this.element);
            n = g({}, e), n.x -= l.x, n.y -= l.y;
          }
          t.realX = n.x, t.realY = n.y, n.x = n.x - this.inertiaStatus.resumeDx, n.y = n.y - this.inertiaStatus.resumeDy;

          for (var a = i.targets ? i.targets.length : 0, c = 0; c < this.snapOffsets.length; c++) {
            var h = {
              x: n.x - this.snapOffsets[c].x,
              y: n.y - this.snapOffsets[c].y
            };

            for (r = 0; r < a; r++) {
              o = d(i.targets[r]) ? i.targets[r](h.x, h.y, this) : i.targets[r], o && s.push({
                x: u(o.x) ? o.x + this.snapOffsets[c].x : h.x,
                y: u(o.y) ? o.y + this.snapOffsets[c].y : h.y,
                range: u(o.range) ? o.range : i.range
              });
            }
          }

          var p = {
            target: null,
            inRange: !1,
            distance: 0,
            range: 0,
            dx: 0,
            dy: 0
          };

          for (r = 0, a = s.length; r < a; r++) {
            o = s[r];
            var f = o.range,
                v = o.x - n.x,
                m = o.y - n.y,
                w = $e(v, m),
                C = w <= f;
            f === 1 / 0 && p.inRange && p.range !== 1 / 0 && (C = !1), p.target && !(C ? p.inRange && f !== 1 / 0 ? w / f < p.distance / p.range : f === 1 / 0 && p.range !== 1 / 0 || w < p.distance : !p.inRange && w < p.distance) || (f === 1 / 0 && (C = !0), p.target = o, p.distance = w, p.range = f, p.inRange = C, p.dx = v, p.dy = m, t.range = f);
          }

          var R;
          return p.target ? (R = t.snappedX !== p.target.x || t.snappedY !== p.target.y, t.snappedX = p.target.x, t.snappedY = p.target.y) : (R = !0, t.snappedX = NaN, t.snappedY = NaN), t.dx = p.dx, t.dy = p.dy, t.changed = R || p.inRange && !t.locked, t.locked = p.inRange, t;
        },
        setRestriction: function setRestriction(e, t) {
          var o,
              n = this.target,
              r = n && n.options[this.prepared.name].restrict,
              s = r && r.restriction;
          if (!s) return t;
          t = t || this.restrictStatus, o = o = t.useStatusXY ? {
            x: t.x,
            y: t.y
          } : g({}, e), t.snap && t.snap.locked && (o.x += t.snap.dx || 0, o.y += t.snap.dy || 0), o.x -= this.inertiaStatus.resumeDx, o.y -= this.inertiaStatus.resumeDy, t.dx = 0, t.dy = 0, t.restricted = !1;
          var l, a, c;
          return p(s) && (s = "parent" === s ? j(this.element) : "self" === s ? n.getRect(this.element) : W(this.element, s), !s) ? t : (d(s) && (s = s(o.x, o.y, this.element)), i(s) && (s = T(s)), l = s, s ? "x" in s && "y" in s ? (a = Math.max(Math.min(l.x + l.width - this.restrictOffset.right, o.x), l.x + this.restrictOffset.left), c = Math.max(Math.min(l.y + l.height - this.restrictOffset.bottom, o.y), l.y + this.restrictOffset.top)) : (a = Math.max(Math.min(l.right - this.restrictOffset.right, o.x), l.left + this.restrictOffset.left), c = Math.max(Math.min(l.bottom - this.restrictOffset.bottom, o.y), l.top + this.restrictOffset.top)) : (a = o.x, c = o.y), t.dx = a - o.x, t.dy = c - o.y, t.changed = t.restrictedX !== a || t.restrictedY !== c, t.restricted = !(!t.dx && !t.dy), t.restrictedX = a, t.restrictedY = c, t);
        },
        checkAndPreventDefault: function checkAndPreventDefault(e, t, o) {
          if (t = t || this.target) {
            var n = t.options,
                r = n.preventDefault;

            if ("auto" === r && o && !/^(input|select|textarea)$/i.test(e.target.nodeName)) {
              if (/down|start/i.test(e.type) && "drag" === this.prepared.name && "xy" !== n.drag.axis) return;
              if (n[this.prepared.name] && n[this.prepared.name].manualStart && !this.interacting()) return;
              return void e.preventDefault();
            }

            return "always" === r ? void e.preventDefault() : void 0;
          }
        },
        calcInertia: function calcInertia(e) {
          var t = this.target.options[this.prepared.name].inertia,
              o = t.resistance,
              n = -Math.log(t.endSpeed / e.v0) / o;
          e.x0 = this.prevEvent.pageX, e.y0 = this.prevEvent.pageY, e.t0 = e.startEvent.timeStamp / 1e3, e.sx = e.sy = 0, e.modifiedXe = e.xe = (e.vx0 - n) / o, e.modifiedYe = e.ye = (e.vy0 - n) / o, e.te = n, e.lambda_v0 = o / e.v0, e.one_ve_v0 = 1 - t.endSpeed / e.v0;
        },
        autoScrollMove: function autoScrollMove(e) {
          if (this.interacting() && G(this.target, this.prepared.name)) {
            if (this.inertiaStatus.active) return void (Me.x = Me.y = 0);
            var t,
                o,
                n,
                r,
                i = this.target.options[this.prepared.name].autoScroll,
                l = i.container || $(this.element);
            if (s(l)) r = e.clientX < Me.margin, t = e.clientY < Me.margin, o = e.clientX > l.innerWidth - Me.margin, n = e.clientY > l.innerHeight - Me.margin;else {
              var a = P(l);
              r = e.clientX < a.left + Me.margin, t = e.clientY < a.top + Me.margin, o = e.clientX > a.right - Me.margin, n = e.clientY > a.bottom - Me.margin;
            }
            Me.x = o ? 1 : r ? -1 : 0, Me.y = n ? 1 : t ? -1 : 0, Me.isScrolling || (Me.margin = i.margin, Me.speed = i.speed, Me.start(this));
          }
        },
        _updateEventTargets: function _updateEventTargets(e, t) {
          this._eventTarget = e, this._curEventTarget = t;
        }
      }, ee.prototype = {
        preventDefault: r,
        stopImmediatePropagation: function stopImmediatePropagation() {
          this.immediatePropagationStopped = this.propagationStopped = !0;
        },
        stopPropagation: function stopPropagation() {
          this.propagationStopped = !0;
        }
      };

      for (var et = {}, tt = ["dragStart", "dragMove", "resizeStart", "resizeMove", "gestureStart", "gestureMove", "pointerOver", "pointerOut", "pointerHover", "selectorDown", "pointerDown", "pointerMove", "pointerUp", "pointerCancel", "pointerEnd", "addPointer", "removePointer", "recordPointer", "autoScrollMove"], ot = 0, nt = tt.length; ot < nt; ot++) {
        var rt = tt[ot];
        et[rt] = Z(rt);
      }

      ke.indexOfElement = function (e, t) {
        t = t || Re;

        for (var o = 0; o < this.length; o++) {
          var n = this[o];
          if (n.selector === e && n._context === t || !n.selector && n._element === e) return o;
        }

        return -1;
      }, ke.get = function (e, t) {
        return this[this.indexOfElement(e, t && t.context)];
      }, ke.forEachSelector = function (e) {
        for (var t = 0; t < this.length; t++) {
          var o = this[t];

          if (o.selector) {
            var n = e(o, o.selector, o._context, t, this);
            if (void 0 !== n) return n;
          }
        }
      }, ce.prototype = {
        setOnEvents: function setOnEvents(e, t) {
          return "drop" === e ? (d(t.ondrop) && (this.ondrop = t.ondrop), d(t.ondropactivate) && (this.ondropactivate = t.ondropactivate), d(t.ondropdeactivate) && (this.ondropdeactivate = t.ondropdeactivate), d(t.ondragenter) && (this.ondragenter = t.ondragenter), d(t.ondragleave) && (this.ondragleave = t.ondragleave), d(t.ondropmove) && (this.ondropmove = t.ondropmove)) : (e = "on" + e, d(t.onstart) && (this[e + "start"] = t.onstart), d(t.onmove) && (this[e + "move"] = t.onmove), d(t.onend) && (this[e + "end"] = t.onend), d(t.oninertiastart) && (this[e + "inertiastart"] = t.oninertiastart)), this;
        },
        draggable: function draggable(e) {
          return c(e) ? (this.options.drag.enabled = e.enabled !== !1, this.setPerAction("drag", e), this.setOnEvents("drag", e), /^x$|^y$|^xy$/.test(e.axis) ? this.options.drag.axis = e.axis : null === e.axis && delete this.options.drag.axis, this) : h(e) ? (this.options.drag.enabled = e, this) : this.options.drag;
        },
        setPerAction: function setPerAction(e, t) {
          for (var o in t) {
            o in Fe[e] && (c(t[o]) ? (this.options[e][o] = g(this.options[e][o] || {}, t[o]), c(Fe.perAction[o]) && "enabled" in Fe.perAction[o] && (this.options[e][o].enabled = t[o].enabled !== !1)) : h(t[o]) && c(Fe.perAction[o]) ? this.options[e][o].enabled = t[o] : void 0 !== t[o] && (this.options[e][o] = t[o]));
          }
        },
        dropzone: function dropzone(e) {
          return c(e) ? (this.options.drop.enabled = e.enabled !== !1, this.setOnEvents("drop", e), /^(pointer|center)$/.test(e.overlap) ? this.options.drop.overlap = e.overlap : u(e.overlap) && (this.options.drop.overlap = Math.max(Math.min(1, e.overlap), 0)), "accept" in e && (this.options.drop.accept = e.accept), "checker" in e && (this.options.drop.checker = e.checker), this) : h(e) ? (this.options.drop.enabled = e, this) : this.options.drop;
        },
        dropCheck: function dropCheck(e, t, o, n, r, i) {
          var s = !1;
          if (!(i = i || this.getRect(r))) return !!this.options.drop.checker && this.options.drop.checker(e, t, s, this, r, o, n);
          var l = this.options.drop.overlap;

          if ("pointer" === l) {
            var a,
                c,
                d = b(e),
                h = M(o, n);
            d.x += h.x, d.y += h.y, a = d.x > i.left && d.x < i.right, c = d.y > i.top && d.y < i.bottom, s = a && c;
          }

          var p = o.getRect(n);

          if ("center" === l) {
            var f = p.left + p.width / 2,
                g = p.top + p.height / 2;
            s = f >= i.left && f <= i.right && g >= i.top && g <= i.bottom;
          }

          if (u(l)) {
            var v = Math.max(0, Math.min(i.right, p.right) - Math.max(i.left, p.left)) * Math.max(0, Math.min(i.bottom, p.bottom) - Math.max(i.top, p.top)),
                m = v / (p.width * p.height);
            s = m >= l;
          }

          return this.options.drop.checker && (s = this.options.drop.checker(e, t, s, this, r, o, n)), s;
        },
        dropChecker: function dropChecker(e) {
          return d(e) ? (this.options.drop.checker = e, this) : null === e ? (delete this.options.getRect, this) : this.options.drop.checker;
        },
        accept: function accept(e) {
          return i(e) ? (this.options.drop.accept = e, this) : f(e) ? (this.options.drop.accept = e, this) : null === e ? (delete this.options.drop.accept, this) : this.options.drop.accept;
        },
        resizable: function resizable(e) {
          return c(e) ? (this.options.resize.enabled = e.enabled !== !1, this.setPerAction("resize", e), this.setOnEvents("resize", e), /^x$|^y$|^xy$/.test(e.axis) ? this.options.resize.axis = e.axis : null === e.axis && (this.options.resize.axis = Fe.resize.axis), h(e.preserveAspectRatio) ? this.options.resize.preserveAspectRatio = e.preserveAspectRatio : h(e.square) && (this.options.resize.square = e.square), this) : h(e) ? (this.options.resize.enabled = e, this) : this.options.resize;
        },
        squareResize: function squareResize(e) {
          return h(e) ? (this.options.resize.square = e, this) : null === e ? (delete this.options.resize.square, this) : this.options.resize.square;
        },
        gesturable: function gesturable(e) {
          return c(e) ? (this.options.gesture.enabled = e.enabled !== !1, this.setPerAction("gesture", e), this.setOnEvents("gesture", e), this) : h(e) ? (this.options.gesture.enabled = e, this) : this.options.gesture;
        },
        autoScroll: function autoScroll(e) {
          return c(e) ? e = g({
            actions: ["drag", "resize"]
          }, e) : h(e) && (e = {
            actions: ["drag", "resize"],
            enabled: e
          }), this.setOptions("autoScroll", e);
        },
        snap: function snap(e) {
          var t = this.setOptions("snap", e);
          return t === this ? this : t.drag;
        },
        setOptions: function setOptions(e, t) {
          var o,
              n = t && a(t.actions) ? t.actions : ["drag"];

          if (c(t) || h(t)) {
            for (o = 0; o < n.length; o++) {
              var r = /resize/.test(n[o]) ? "resize" : n[o];

              if (c(this.options[r])) {
                var i = this.options[r][e];
                c(t) ? (g(i, t), i.enabled = t.enabled !== !1, "snap" === e && ("grid" === i.mode ? i.targets = [ae.createSnapGrid(g({
                  offset: i.gridOffset || {
                    x: 0,
                    y: 0
                  }
                }, i.grid || {}))] : "anchor" === i.mode ? i.targets = i.anchors : "path" === i.mode && (i.targets = i.paths), "elementOrigin" in t && (i.relativePoints = [t.elementOrigin]))) : h(t) && (i.enabled = t);
              }
            }

            return this;
          }

          var s = {},
              l = ["drag", "resize", "gesture"];

          for (o = 0; o < l.length; o++) {
            e in Fe[l[o]] && (s[l[o]] = this.options[l[o]][e]);
          }

          return s;
        },
        inertia: function inertia(e) {
          var t = this.setOptions("inertia", e);
          return t === this ? this : t.drag;
        },
        getAction: function getAction(e, t, o, n) {
          var r = this.defaultActionChecker(e, o, n);
          return this.options.actionChecker ? this.options.actionChecker(e, t, r, this, n, o) : r;
        },
        defaultActionChecker: re,
        actionChecker: function actionChecker(e) {
          return d(e) ? (this.options.actionChecker = e, this) : null === e ? (delete this.options.actionChecker, this) : this.options.actionChecker;
        },
        getRect: function getRect(e) {
          return e = e || this._element, this.selector && !i(e) && (e = this._context.querySelector(this.selector)), T(e);
        },
        rectChecker: function rectChecker(e) {
          return d(e) ? (this.getRect = e, this) : null === e ? (delete this.options.getRect, this) : this.getRect;
        },
        styleCursor: function styleCursor(e) {
          return h(e) ? (this.options.styleCursor = e, this) : null === e ? (delete this.options.styleCursor, this) : this.options.styleCursor;
        },
        preventDefault: function preventDefault(e) {
          return /^(always|never|auto)$/.test(e) ? (this.options.preventDefault = e, this) : h(e) ? (this.options.preventDefault = e ? "always" : "never", this) : this.options.preventDefault;
        },
        origin: function origin(e) {
          return f(e) ? (this.options.origin = e, this) : c(e) ? (this.options.origin = e, this) : this.options.origin;
        },
        deltaSource: function deltaSource(e) {
          return "page" === e || "client" === e ? (this.options.deltaSource = e, this) : this.options.deltaSource;
        },
        restrict: function restrict(e) {
          if (!c(e)) return this.setOptions("restrict", e);

          for (var t, o = ["drag", "resize", "gesture"], n = 0; n < o.length; n++) {
            var r = o[n];

            if (r in e) {
              var i = g({
                actions: [r],
                restriction: e[r]
              }, e);
              t = this.setOptions("restrict", i);
            }
          }

          return t;
        },
        context: function context() {
          return this._context;
        },
        _context: Re,
        ignoreFrom: function ignoreFrom(e) {
          return f(e) ? (this.options.ignoreFrom = e, this) : i(e) ? (this.options.ignoreFrom = e, this) : this.options.ignoreFrom;
        },
        allowFrom: function allowFrom(e) {
          return f(e) ? (this.options.allowFrom = e, this) : i(e) ? (this.options.allowFrom = e, this) : this.options.allowFrom;
        },
        element: function element() {
          return this._element;
        },
        fire: function fire(e) {
          if (!e || !e.type || !fe(Oe, e.type)) return this;
          var t,
              o,
              n,
              r = "on" + e.type,
              i = "";
          if (e.type in this._iEvents) for (t = this._iEvents[e.type], o = 0, n = t.length; o < n && !e.immediatePropagationStopped; o++) {
            i = t[o].name, t[o](e);
          }
          if (d(this[r]) && (i = this[r].name, this[r](e)), e.type in Xe && (t = Xe[e.type])) for (o = 0, n = t.length; o < n && !e.immediatePropagationStopped; o++) {
            i = t[o].name, t[o](e);
          }
          return this;
        },
        on: function on(e, t, o) {
          var n;

          if (p(e) && e.search(" ") !== -1 && (e = e.trim().split(/ +/)), a(e)) {
            for (n = 0; n < e.length; n++) {
              this.on(e[n], t, o);
            }

            return this;
          }

          if (c(e)) {
            for (var r in e) {
              this.on(r, e[r], t);
            }

            return this;
          }

          if ("wheel" === e && (e = Ve), o = !!o, fe(Oe, e)) e in this._iEvents ? this._iEvents[e].push(t) : this._iEvents[e] = [t];else if (this.selector) {
            if (!Le[e]) for (Le[e] = {
              selectors: [],
              contexts: [],
              listeners: []
            }, n = 0; n < Te.length; n++) {
              Je.add(Te[n], e, se), Je.add(Te[n], e, le, !0);
            }
            var i,
                s = Le[e];

            for (i = s.selectors.length - 1; i >= 0 && (s.selectors[i] !== this.selector || s.contexts[i] !== this._context); i--) {
              ;
            }

            i === -1 && (i = s.selectors.length, s.selectors.push(this.selector), s.contexts.push(this._context), s.listeners.push([])), s.listeners[i].push([t, o]);
          } else Je.add(this._element, e, t, o);
          return this;
        },
        off: function off(e, t, o) {
          var n;

          if (p(e) && e.search(" ") !== -1 && (e = e.trim().split(/ +/)), a(e)) {
            for (n = 0; n < e.length; n++) {
              this.off(e[n], t, o);
            }

            return this;
          }

          if (c(e)) {
            for (var r in e) {
              this.off(r, e[r], t);
            }

            return this;
          }

          var i,
              s = -1;
          if (o = !!o, "wheel" === e && (e = Ve), fe(Oe, e)) i = this._iEvents[e], i && (s = pe(i, t)) !== -1 && this._iEvents[e].splice(s, 1);else if (this.selector) {
            var l = Le[e],
                d = !1;
            if (!l) return this;

            for (s = l.selectors.length - 1; s >= 0; s--) {
              if (l.selectors[s] === this.selector && l.contexts[s] === this._context) {
                var u = l.listeners[s];

                for (n = u.length - 1; n >= 0; n--) {
                  var h = u[n][0],
                      f = u[n][1];

                  if (h === t && f === o) {
                    u.splice(n, 1), u.length || (l.selectors.splice(s, 1), l.contexts.splice(s, 1), l.listeners.splice(s, 1), Je.remove(this._context, e, se), Je.remove(this._context, e, le, !0), l.selectors.length || (Le[e] = null)), d = !0;
                    break;
                  }
                }

                if (d) break;
              }
            }
          } else Je.remove(this._element, e, t, o);
          return this;
        },
        set: function set(e) {
          c(e) || (e = {}), this.options = g({}, Fe.base);
          var t,
              o = ["drag", "drop", "resize", "gesture"],
              n = ["draggable", "dropzone", "resizable", "gesturable"],
              r = g(g({}, Fe.perAction), e[i] || {});

          for (t = 0; t < o.length; t++) {
            var i = o[t];
            this.options[i] = g({}, Fe[i]), this.setPerAction(i, r), this[n[t]](e[i]);
          }

          var s = ["accept", "actionChecker", "allowFrom", "deltaSource", "dropChecker", "ignoreFrom", "origin", "preventDefault", "rectChecker", "styleCursor"];

          for (t = 0, nt = s.length; t < nt; t++) {
            var l = s[t];
            this.options[l] = Fe.base[l], l in e && this[l](e[l]);
          }

          return this;
        },
        unset: function unset() {
          if (Je.remove(this._element, "all"), p(this.selector)) for (var e in Le) {
            for (var t = Le[e], o = 0; o < t.selectors.length; o++) {
              t.selectors[o] === this.selector && t.contexts[o] === this._context && (t.selectors.splice(o, 1), t.contexts.splice(o, 1), t.listeners.splice(o, 1), t.selectors.length || (Le[e] = null)), Je.remove(this._context, e, se), Je.remove(this._context, e, le, !0);
              break;
            }
          } else Je.remove(this, "all"), this.options.styleCursor && (this._element.style.cursor = "");
          return this.dropzone(!1), ke.splice(pe(ke, this), 1), ae;
        }
      }, ce.prototype.snap = de(ce.prototype.snap, "Interactable#snap is deprecated. See the new documentation for snapping at http://interactjs.io/docs/snapping"), ce.prototype.restrict = de(ce.prototype.restrict, "Interactable#restrict is deprecated. See the new documentation for resticting at http://interactjs.io/docs/restriction"), ce.prototype.inertia = de(ce.prototype.inertia, "Interactable#inertia is deprecated. See the new documentation for inertia at http://interactjs.io/docs/inertia"), ce.prototype.autoScroll = de(ce.prototype.autoScroll, "Interactable#autoScroll is deprecated. See the new documentation for autoScroll at http://interactjs.io/docs/#autoscroll"), ce.prototype.squareResize = de(ce.prototype.squareResize, "Interactable#squareResize is deprecated. See http://interactjs.io/docs/#resize-square"), ce.prototype.accept = de(ce.prototype.accept, "Interactable#accept is deprecated. use Interactable#dropzone({ accept: target }) instead"), ce.prototype.dropChecker = de(ce.prototype.dropChecker, "Interactable#dropChecker is deprecated. use Interactable#dropzone({ dropChecker: checkerFunction }) instead"), ce.prototype.context = de(ce.prototype.context, "Interactable#context as a method is deprecated. It will soon be a DOM Node instead"), ae.isSet = function (e, t) {
        return ke.indexOfElement(e, t && t.context) !== -1;
      }, ae.on = function (e, t, o) {
        if (p(e) && e.search(" ") !== -1 && (e = e.trim().split(/ +/)), a(e)) {
          for (var n = 0; n < e.length; n++) {
            ae.on(e[n], t, o);
          }

          return ae;
        }

        if (c(e)) {
          for (var r in e) {
            ae.on(r, e[r], t);
          }

          return ae;
        }

        return fe(Oe, e) ? Xe[e] ? Xe[e].push(t) : Xe[e] = [t] : Je.add(Re, e, t, o), ae;
      }, ae.off = function (e, t, o) {
        if (p(e) && e.search(" ") !== -1 && (e = e.trim().split(/ +/)), a(e)) {
          for (var n = 0; n < e.length; n++) {
            ae.off(e[n], t, o);
          }

          return ae;
        }

        if (c(e)) {
          for (var r in e) {
            ae.off(r, e[r], t);
          }

          return ae;
        }

        if (fe(Oe, e)) {
          var i;
          e in Xe && (i = pe(Xe[e], t)) !== -1 && Xe[e].splice(i, 1);
        } else Je.remove(Re, e, t, o);

        return ae;
      }, ae.enableDragging = de(function (e) {
        return null !== e && void 0 !== e ? (Be.drag = e, ae) : Be.drag;
      }, "interact.enableDragging is deprecated and will soon be removed."), ae.enableResizing = de(function (e) {
        return null !== e && void 0 !== e ? (Be.resize = e, ae) : Be.resize;
      }, "interact.enableResizing is deprecated and will soon be removed."), ae.enableGesturing = de(function (e) {
        return null !== e && void 0 !== e ? (Be.gesture = e, ae) : Be.gesture;
      }, "interact.enableGesturing is deprecated and will soon be removed."), ae.eventTypes = Oe, ae.debug = function () {
        var e = De[0] || new Q();
        return {
          interactions: De,
          target: e.target,
          dragging: e.dragging,
          resizing: e.resizing,
          gesturing: e.gesturing,
          prepared: e.prepared,
          matches: e.matches,
          matchElements: e.matchElements,
          prevCoords: e.prevCoords,
          startCoords: e.startCoords,
          pointerIds: e.pointerIds,
          pointers: e.pointers,
          addPointer: et.addPointer,
          removePointer: et.removePointer,
          recordPointer: et.recordPointer,
          snap: e.snapStatus,
          restrict: e.restrictStatus,
          inertia: e.inertiaStatus,
          downTime: e.downTimes[0],
          downEvent: e.downEvent,
          downPointer: e.downPointer,
          prevEvent: e.prevEvent,
          Interactable: ce,
          interactables: ke,
          pointerIsDown: e.pointerIsDown,
          defaultOptions: Fe,
          defaultActionChecker: re,
          actionCursors: qe,
          dragMove: et.dragMove,
          resizeMove: et.resizeMove,
          gestureMove: et.gestureMove,
          pointerUp: et.pointerUp,
          pointerDown: et.pointerDown,
          pointerMove: et.pointerMove,
          pointerHover: et.pointerHover,
          eventTypes: Oe,
          events: Je,
          globalEvents: Xe,
          delegatedEvents: Le,
          prefixedPropREs: Ze
        };
      }, ae.getPointerAverage = D, ae.getTouchBBox = z, ae.getTouchDistance = L, ae.getTouchAngle = F, ae.getElementRect = T, ae.getElementClientRect = P, ae.matchesSelector = ge, ae.closest = W, ae.margin = de(function (e) {
        return u(e) ? (Ae = e, ae) : Ae;
      }, "interact.margin is deprecated. Use interact(target).resizable({ margin: number }); instead."), ae.supportsTouch = function () {
        return He;
      }, ae.supportsPointerEvent = function () {
        return Ie;
      }, ae.stop = function (e) {
        for (var t = De.length - 1; t >= 0; t--) {
          De[t].stop(e);
        }

        return ae;
      }, ae.dynamicDrop = function (e) {
        return h(e) ? (ze = e, ae) : ze;
      }, ae.pointerMoveTolerance = function (e) {
        return u(e) ? (Ne = e, this) : Ne;
      }, ae.maxInteractions = function (e) {
        return u(e) ? (je = e, this) : je;
      }, ae.createSnapGrid = function (e) {
        return function (t, o) {
          var n = 0,
              r = 0;
          c(e.offset) && (n = e.offset.x, r = e.offset.y);
          var i = Math.round((t - n) / e.x),
              s = Math.round((o - r) / e.y),
              l = i * e.x + n,
              a = s * e.y + r;
          return {
            x: l,
            y: a,
            range: e.range
          };
        };
      }, he(Re), Ke in Element.prototype && d(Element.prototype[Ke]) || (we = function we(e, t, o) {
        o = o || e.parentNode.querySelectorAll(t);

        for (var n = 0, r = o.length; n < r; n++) {
          if (o[n] === e) return !0;
        }

        return !1;
      }), function () {
        for (var e = 0, t = ["ms", "moz", "webkit", "o"], n = 0; n < t.length && !o.requestAnimationFrame; ++n) {
          Ue = o[t[n] + "RequestAnimationFrame"], Qe = o[t[n] + "CancelAnimationFrame"] || o[t[n] + "CancelRequestAnimationFrame"];
        }

        Ue || (Ue = function Ue(t) {
          var o = new Date().getTime(),
              n = Math.max(0, 16 - (o - e)),
              r = setTimeout(function () {
            t(o + n);
          }, n);
          return e = o + n, r;
        }), Qe || (Qe = function Qe(e) {
          clearTimeout(e);
        });
      }(), "undefined" != typeof e && e.exports && (t = e.exports = ae), t.interact = ae;
    }
  }("undefined" == typeof window ? void 0 : window);
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RowSelectionModel = t.RowMoveManager = t.HeaderMenu = t.HeaderButtons = t.CheckboxSelectColumn = t.CellSelectionModel = t.CellRangeSelector = t.CellRangeDecorator = t.CellCopyManager = t.AutoTooltips = void 0;
  var r = o(7),
      i = n(r),
      s = o(9),
      l = n(s),
      a = o(11),
      c = n(a),
      d = o(12),
      u = n(d),
      h = o(13),
      p = n(h),
      f = o(15),
      g = n(f),
      v = o(17),
      m = n(v),
      w = o(19),
      C = n(w),
      R = o(21),
      y = n(R),
      b = o(23),
      S = n(b);
  t.AutoTooltips = i.default, t.CellCopyManager = l.default, t.CellRangeDecorator = c.default, t.CellRangeSelector = u.default, t.CellSelectionModel = p.default, t.CheckboxSelectColumn = g.default, t.HeaderButtons = m.default, t.HeaderMenu = C.default, t.RowMoveManager = y.default, t.RowSelectionModel = S.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(8),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t(t) {
      e = Object.assign({}, l, e), i = t, e.enableForCells && i.onMouseEnter.subscribe(n), e.enableForHeaderCells && i.onHeaderMouseEnter.subscribe(r);
    }

    function o() {
      e.enableForCells && i.onMouseEnter.unsubscribe(n), e.enableForHeaderCells && i.onHeaderMouseEnter.unsubscribe(r);
    }

    function n(t) {
      var o = i.getCellFromEvent(t);

      if (o) {
        var n = (0, s.default)(i.getCellNode(o.row, o.cell)),
            r = void 0;
        n.innerWidth() < n[0].scrollWidth ? (r = s.default.trim(n.text()), e.maxToolTipLength && r.length > e.maxToolTipLength && (r = r.substr(0, e.maxToolTipLength - 3) + "...")) : r = "", n.attr("title", r);
      }
    }

    function r(e, t) {
      var o = t.column,
          n = (0, s.default)(e.target).closest(".slick-header-column");
      o && !o.toolTip && n.attr("title", n.innerWidth() < n[0].scrollWidth ? o.name : "");
    }

    var i = void 0,
        l = {
      enableForCells: !0,
      enableForHeaderCells: !1,
      maxToolTipLength: null
    };
    Object.assign(this, {
      init: t,
      destroy: o
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(2),
      s = n(i);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(10),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r() {
    function e(e) {
      i = e, i.onKeyDown.subscribe(o);
    }

    function t() {
      i.onKeyDown.unsubscribe(o);
    }

    function o(e, t) {
      var o;
      i.getEditorLock().isActive() || (e.which == l.ESCAPE && a && (e.preventDefault(), r(), c.onCopyCancelled.notify({
        ranges: a
      }), a = null), 67 == e.which && (e.ctrlKey || e.metaKey) && (o = i.getSelectionModel().getSelectedRanges(), 0 != o.length && (e.preventDefault(), a = o, n(o), c.onCopyCells.notify({
        ranges: o
      }))), 86 == e.which && (e.ctrlKey || e.metaKey) && a && (e.preventDefault(), r(), o = i.getSelectionModel().getSelectedRanges(), c.onPasteCells.notify({
        from: a,
        to: o
      }), a = null));
    }

    function n(e) {
      for (var t = i.getColumns(), o = {}, n = 0; n < e.length; n++) {
        for (var r = e[n].fromRow; r <= e[n].toRow; r++) {
          o[r] = {};

          for (var s = e[n].fromCell; s <= e[n].toCell; s++) {
            o[r][t[s].id] = "copied";
          }
        }
      }

      i.setCellCssStyles("copy-manager", o);
    }

    function r() {
      i.removeCellCssStyles("copy-manager");
    }

    var i,
        a,
        c = this;
    Object.assign(this, {
      init: e,
      destroy: t,
      clearCopySelection: r,
      onCopyCells: new s.default.Event(),
      onCopyCancelled: new s.default.Event(),
      onPasteCells: new s.default.Event()
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(1),
      s = n(i),
      l = s.default.keyCode;
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(3),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(4),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(14),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r() {
    function e(e) {
      m = Object.assign({}, u), h = e, p = h.getCanvasNode(), h.onActiveCellChanged.subscribe(c), h.onKeyDown.subscribe(d), e.registerPlugin(v), v.onCellRangeSelected.subscribe(l), v.onBeforeCellRangeSelected.subscribe(i);
    }

    function t() {
      h.onActiveCellChanged.unsubscribe(c), h.onKeyDown.unsubscribe(d), v.onCellRangeSelected.unsubscribe(l), v.onBeforeCellRangeSelected.unsubscribe(i), h.unregisterPlugin(v);
    }

    function o(e) {
      for (var t = [], o = 0; o < e.length; o++) {
        var n = e[o];
        h.canCellBeSelected(n.fromRow, n.fromCell) && h.canCellBeSelected(n.toRow, n.toCell) && t.push(n);
      }

      return t;
    }

    function n(e) {
      (f && 0 !== f.length || e && 0 !== e.length) && (f = o(e), g.onSelectedRangesChanged.notify(f));
    }

    function r() {
      return f;
    }

    function i(e, t) {
      if (h.getEditorLock().isActive()) return e.stopPropagation(), !1;
    }

    function l(e, t) {
      n([t.range]);
    }

    function c(e, t) {
      m.selectActiveCell && null != t.row && null != t.cell && n([new s.default.Range(t.row, t.cell)]);
    }

    function d(e) {
      var t = void 0,
          i = void 0,
          l = h.getActiveCell();

      if (l && e.shiftKey && !e.ctrlKey && !e.altKey && (37 == e.which || 39 == e.which || 38 == e.which || 40 == e.which)) {
        t = r(), t.length || t.push(new s.default.Range(l.row, l.cell)), i = t.pop(), i.contains(l.row, l.cell) || (i = new s.default.Range(l.row, l.cell));
        var a = i.toRow - i.fromRow,
            c = i.toCell - i.fromCell,
            d = l.row == i.fromRow ? 1 : -1,
            u = l.cell == i.fromCell ? 1 : -1;
        37 == e.which ? c -= u : 39 == e.which ? c += u : 38 == e.which ? a -= d : 40 == e.which && (a += d);
        var p = new s.default.Range(l.row, l.cell, l.row + d * a, l.cell + u * c);

        if (o([p]).length) {
          t.push(p);
          var f = d > 0 ? p.toRow : p.fromRow,
              g = u > 0 ? p.toCell : p.fromCell;
          h.scrollRowIntoView(f), h.scrollCellIntoView(f, g);
        } else t.push(i);

        n(t), e.preventDefault(), e.stopPropagation();
      }
    }

    var u = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
      selectActiveCell: !0
    },
        h = void 0,
        p = void 0,
        f = [],
        g = this,
        v = new a.default({
      selectionCss: {
        border: "2px solid black"
      }
    }),
        m = void 0;
    Object.assign(this, {
      getSelectedRanges: r,
      setSelectedRanges: n,
      init: e,
      destroy: t,
      onSelectedRangesChanged: new s.default.Event()
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(1),
      s = n(i),
      l = o(4),
      a = n(l);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(16),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t(e) {
      h = e, p.subscribe(h.onSelectedRowsChanged, n).subscribe(h.onClick, i).subscribe(h.onHeaderClick, c).subscribe(h.onKeyDown, r);
    }

    function o() {
      p.unsubscribeAll();
    }

    function n(e, t) {
      var o = h.getSelectedRows(),
          n = {},
          r = void 0,
          i = void 0;

      for (i = 0; i < o.length; i++) {
        r = o[i], n[r] = !0, n[r] !== f[r] && (h.invalidateRow(r), delete f[r]);
      }

      for (i in f) {
        h.invalidateRow(i);
      }

      f = n, h.render(), o.length && o.length == h.getDataLength() ? h.updateColumnHeader(v.columnId, "<input type='checkbox' checked='checked'>", v.toolTip) : h.updateColumnHeader(v.columnId, "<input type='checkbox'>", v.toolTip);
    }

    function r(e, t) {
      32 == e.which && h.getColumns()[t.cell].id === v.columnId && (h.getEditorLock().isActive() && !h.getEditorLock().commitCurrentEdit() || l(t.row), e.preventDefault(), e.stopImmediatePropagation());
    }

    function i(e, t) {
      if (h.getColumns()[t.cell].id === v.columnId && (0, s.default)(e.target).is(":checkbox")) {
        if (h.getEditorLock().isActive() && !h.getEditorLock().commitCurrentEdit()) return e.preventDefault(), void e.stopImmediatePropagation();
        l(t.row), e.stopPropagation(), e.stopImmediatePropagation();
      }
    }

    function l(e) {
      f[e] ? h.setSelectedRows(s.default.grep(h.getSelectedRows(), function (t) {
        return t != e;
      })) : h.setSelectedRows(h.getSelectedRows().concat(e));
    }

    function c(e, t) {
      if (t.column.id == v.columnId && (0, s.default)(e.target).is(":checkbox")) {
        if (h.getEditorLock().isActive() && !h.getEditorLock().commitCurrentEdit()) return e.preventDefault(), void e.stopImmediatePropagation();

        if ((0, s.default)(e.target).is(":checked")) {
          for (var o = [], n = 0; n < h.getDataLength(); n++) {
            o.push(n);
          }

          h.setSelectedRows(o);
        } else h.setSelectedRows([]);

        e.stopPropagation(), e.stopImmediatePropagation();
      }
    }

    function d() {
      return {
        id: v.columnId,
        name: "<input type='checkbox'>",
        toolTip: v.toolTip,
        field: "sel",
        width: v.width,
        resizable: !1,
        sortable: !1,
        cssClass: v.cssClass,
        formatter: u
      };
    }

    function u(e, t, o, n, r) {
      return r ? f[e] ? "<input type='checkbox' checked='checked'>" : "<input type='checkbox'>" : null;
    }

    var h = void 0,
        p = new a.default.EventHandler(),
        f = {},
        g = {
      columnId: "_checkbox_selector",
      cssClass: null,
      toolTip: "Select/Deselect All",
      width: 30
    },
        v = s.default.extend(!0, {}, g, e);
    Object.assign(this, {
      init: t,
      destroy: o,
      getColumnDefinition: d
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(2),
      s = n(i),
      l = o(1),
      a = n(l);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(18),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t(t) {
      e = Object.assign({}, u, e), l = t, d.subscribe(l.onHeaderCellRendered, n).subscribe(l.onBeforeHeaderCellDestroy, r), l.setColumns(l.getColumns());
    }

    function o() {
      d.unsubscribeAll();
    }

    function n(t, o) {
      var n = o.column;
      if (n.header && n.header.buttons) for (var r = n.header.buttons.length; r--;) {
        var l = n.header.buttons[r],
            a = (0, s.default)("<div></div>").addClass(e.buttonCssClass).data("column", n).data("button", l);
        l.showOnHover && a.addClass("slick-header-button-hidden"), l.image && a.css("backgroundImage", "url(" + l.image + ")"), l.cssClass && a.addClass(l.cssClass), l.tooltip && a.attr("title", l.tooltip), l.command && a.data("command", l.command), l.handler && a.bind("click", l.handler), a.bind("click", i).appendTo(o.node), o.node.classList.add("has-buttons");
      }
    }

    function r(t, o) {
      var n = o.column;
      n.header && n.header.buttons && (0, s.default)(o.node).find("." + e.buttonCssClass).remove();
    }

    function i(e) {
      var t = (0, s.default)(this).data("command"),
          o = (0, s.default)(this).data("column"),
          n = (0, s.default)(this).data("button");
      null != t && (c.onCommand.notify({
        grid: l,
        column: o,
        command: t,
        button: n
      }, e, c), l.updateColumnHeader(o.id)), e.preventDefault(), e.stopPropagation();
    }

    var l,
        c = this,
        d = new a.default.EventHandler(),
        u = {
      buttonCssClass: "slick-header-button"
    };
    Object.assign(this, {
      init: t,
      destroy: o,
      onCommand: new a.default.Event()
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(2),
      s = n(i),
      l = o(1),
      a = n(l);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(20),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t(t) {
      e = Object.assign({}, f, e), u = t, p.subscribe(u.onHeaderCellRendered, i).subscribe(u.onBeforeHeaderCellDestroy, l), u.setColumns(u.getColumns()), (0, s.default)(document.body).bind("mousedown", n);
    }

    function o() {
      p.unsubscribeAll(), (0, s.default)(document.body).unbind("mousedown", n);
    }

    function n(e) {
      g && g[0] != e.target && !s.default.contains(g[0], e.target) && r();
    }

    function r() {
      g && (g.remove(), g = null, v.removeClass("slick-header-column-active"));
    }

    function i(t, o) {
      var n = o.column,
          r = n.header && n.header.menu;

      if (r) {
        var i = (0, s.default)("<div></div>").addClass("slick-header-menubutton").data("column", n).data("menu", r);
        e.buttonCssClass && i.addClass(e.buttonCssClass), e.buttonImage && i.css("background-image", "url(" + e.buttonImage + ")"), r.tooltip && i.attr("title", r.tooltip), i.bind("click", c).appendTo(o.node);
      }
    }

    function l(e, t) {
      var o = t.column;
      o.header && o.header.menu && (0, s.default)(t.node).find(".slick-header-menubutton").remove();
    }

    function c(e) {
      var t = (0, s.default)(this),
          o = t.data("menu"),
          n = t.data("column");

      if (0 != h.onBeforeMenuShow.notify({
        grid: u,
        column: n,
        menu: o
      }, e, h)) {
        g || (g = (0, s.default)("<div class='slick-header-menu'></div>").appendTo(u.getContainerNode())), g.empty();

        for (var r = 0; r < o.items.length; r++) {
          var i = o.items[r],
              l = (0, s.default)("<div class='slick-header-menuitem'></div>").data("command", i.command || "").data("column", n).data("item", i).bind("click", d).appendTo(g);
          i.disabled && l.addClass("slick-header-menuitem-disabled"), i.tooltip && l.attr("title", i.tooltip);
          var a = (0, s.default)("<div class='slick-header-menuicon'></div>").appendTo(l);
          i.iconCssClass && a.addClass(i.iconCssClass), i.iconImage && a.css("background-image", "url(" + i.iconImage + ")"), (0, s.default)("<span class='slick-header-menucontent'></span>").text(i.title).appendTo(l);
        }

        g.offset({
          top: (0, s.default)(this).offset().top + (0, s.default)(this).height(),
          left: (0, s.default)(this).offset().left
        }), v = t.closest(".slick-header-column"), v.addClass("slick-header-column-active"), e.preventDefault(), e.stopPropagation();
      }
    }

    function d(e) {
      var t = (0, s.default)(this).data("command"),
          o = (0, s.default)(this).data("column"),
          n = (0, s.default)(this).data("item");
      n.disabled || (r(), null != t && "" != t && h.onCommand.notify({
        grid: u,
        column: o,
        command: t,
        item: n
      }, e, h), e.preventDefault(), e.stopPropagation());
    }

    var u = void 0,
        h = this,
        p = new a.default.EventHandler(),
        f = {
      buttonCssClass: null,
      buttonImage: null
    },
        g = void 0,
        v = void 0;
    Object.assign(this, {
      init: t,
      destroy: o,
      onBeforeMenuShow: new a.default.Event(),
      onCommand: new a.default.Event()
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(2),
      s = n(i),
      l = o(1),
      a = n(l);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(22),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t(t) {
      e = Object.assign({}, p, e), a = t, c = a.getCanvasNode(), h.subscribe(a.onDragInit, n).subscribe(a.onDragStart, r).subscribe(a.onDrag, i).subscribe(a.onDragEnd, l);
    }

    function o() {
      h.unsubscribeAll();
    }

    function n(e, t) {
      e.stopImmediatePropagation();
    }

    function r(t, o) {
      var n = a.getCellFromEvent(t);
      if (e.cancelEditOnDrag && a.getEditorLock().isActive() && a.getEditorLock().cancelCurrentEdit(), a.getEditorLock().isActive() || !/move|selectAndMove/.test(a.getColumns()[n.cell].behavior)) return !1;
      d = !0, t.stopImmediatePropagation();
      var r = a.getSelectedRows();
      0 != r.length && $.inArray(n.row, r) != -1 || (r = [n.row], a.setSelectedRows(r));
      var i = a.getOptions().rowHeight;
      o.selectedRows = r, o.selectionProxy = $("<div class='slick-reorder-proxy'/>").css("position", "absolute").css("zIndex", "99999").css("width", $(c).innerWidth()).css("height", i * r.length).appendTo(c), o.guide = $("<div class='slick-reorder-guide'/>").css("position", "absolute").css("zIndex", "99998").css("width", $(c).innerWidth()).css("top", -1e3).appendTo(c), o.insertBefore = -1;
    }

    function i(e, t) {
      if (d) {
        e.stopImmediatePropagation();
        var o = e.pageY - $(c).offset().top;
        t.selectionProxy.css("top", o - 5);
        var n = Math.max(0, Math.min(Math.round(o / a.getOptions().rowHeight), a.getDataLength()));

        if (n !== t.insertBefore) {
          var r = {
            rows: t.selectedRows,
            insertBefore: n
          };
          u.onBeforeMoveRows.notify(r) === !1 ? (t.guide.css("top", -1e3), t.canMove = !1) : (t.guide.css("top", n * a.getOptions().rowHeight), t.canMove = !0), t.insertBefore = n;
        }
      }
    }

    function l(e, t) {
      if (d && (d = !1, e.stopImmediatePropagation(), t.guide.remove(), t.selectionProxy.remove(), t.canMove)) {
        var o = {
          rows: t.selectedRows,
          insertBefore: t.insertBefore
        };
        u.onMoveRows.notify(o);
      }
    }

    var a = void 0,
        c = void 0,
        d = void 0,
        u = this,
        h = new s.default.EventHandler(),
        p = {
      cancelEditOnDrag: !1
    };
    Object.assign(this, {
      onBeforeMoveRows: new s.default.Event(),
      onMoveRows: new s.default.Event(),
      init: t,
      destroy: o
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(1),
      s = n(i);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(24),
      i = n(r);
  t.default = i.default;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t(t) {
      y = Object.assign({}, b, e), v = t, C.subscribe(v.onActiveCellChanged, n(p)), C.subscribe(v.onKeyDown, n(f)), C.subscribe(v.onClick, n(g));
    }

    function o() {
      C.unsubscribeAll();
    }

    function n(e) {
      return function () {
        R || (R = !0, e.apply(this, arguments), R = !1);
      };
    }

    function r(e) {
      for (var t = [], o = 0; o < e.length; o++) {
        for (var n = e[o].fromRow; n <= e[o].toRow; n++) {
          t.push(n);
        }
      }

      return t;
    }

    function i(e) {
      for (var t = [], o = v.getColumns().length - 1, n = 0; n < e.length; n++) {
        t.push(new a.default.Range(e[n], 0, e[n], o));
      }

      return t;
    }

    function l(e, t) {
      var o = void 0,
          n = [];

      for (o = e; o <= t; o++) {
        n.push(o);
      }

      for (o = t; o < e; o++) {
        n.push(o);
      }

      return n;
    }

    function c() {
      return r(m);
    }

    function d(e) {
      u(i(e));
    }

    function u(e) {
      (m && 0 !== m.length || e && 0 !== e.length) && (m = e, w.onSelectedRangesChanged.notify(m));
    }

    function h() {
      return m;
    }

    function p(e, t) {
      y.selectActiveRow && null != t.row && u([new a.default.Range(t.row, 0, t.row, v.getColumns().length - 1)]);
    }

    function f(e) {
      var t = v.getActiveCell();

      if (t && e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey && (38 == e.which || 40 == e.which)) {
        var o = c();
        o.sort(function (e, t) {
          return e - t;
        }), o.length || (o = [t.row]);
        var n = o[0],
            r = o[o.length - 1],
            s = void 0;
        s = 40 == e.which ? t.row < r || n == r ? ++r : ++n : t.row < r ? --r : --n, s >= 0 && s < v.getDataLength() && (v.scrollRowIntoView(s), m = i(l(n, r)), u(m)), e.preventDefault(), e.stopPropagation();
      }
    }

    function g(e) {
      var t = v.getCellFromEvent(e);
      if (!t || !v.canCellBeActive(t.row, t.cell)) return !1;
      if (!v.getOptions().multiSelect || !e.ctrlKey && !e.shiftKey && !e.metaKey) return !1;
      var o = r(m),
          n = s.default.inArray(t.row, o);
      if (n === -1 && (e.ctrlKey || e.metaKey)) o.push(t.row), v.setActiveCell(t.row, t.cell);else if (n !== -1 && (e.ctrlKey || e.metaKey)) o = s.default.grep(o, function (e, o) {
        return e !== t.row;
      }), v.setActiveCell(t.row, t.cell);else if (o.length && e.shiftKey) {
        var l = o.pop(),
            a = Math.min(t.row, l),
            c = Math.max(t.row, l);
        o = [];

        for (var d = a; d <= c; d++) {
          d !== l && o.push(d);
        }

        o.push(l), v.setActiveCell(t.row, t.cell);
      }
      return m = i(o), u(m), e.stopImmediatePropagation(), !0;
    }

    var v = void 0,
        m = [],
        w = this,
        C = new a.default.EventHandler(),
        R = void 0,
        y = void 0,
        b = {
      selectActiveRow: !0
    };
    Object.assign(this, {
      getSelectedRows: c,
      setSelectedRows: d,
      getSelectedRanges: h,
      setSelectedRanges: u,
      init: t,
      destroy: o,
      onSelectedRangesChanged: new a.default.Event()
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(2),
      s = n(i),
      l = o(1),
      a = n(l);
  t.default = r;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var o in e) {
      Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
    }
    return t.default = e, t;
  }

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Plugins = t.FrozenGrid = t.Grid = t.Data = t.Formatters = t.Editors = t.Slick = void 0;
  var i = o(1),
      s = r(i),
      l = o(28),
      a = r(l),
      c = o(27),
      d = r(c),
      u = o(30),
      h = r(u),
      p = o(26),
      f = r(p),
      g = o(29),
      v = r(g),
      m = o(6),
      w = n(m);
  t.Slick = s.default, t.Editors = a.default, t.Formatters = v.default, t.Data = d.default, t.Grid = h.default, t.FrozenGrid = f.default, t.Plugins = w;
}, function (module, exports, __webpack_require__) {
  "use strict";

  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function SlickGrid(container, data, columns, options) {
    function init() {
      if ($container = (0, _jquery2.default)(container), $container.length < 1) throw new Error("SlickGrid requires a valid container, " + container + " does not exist in the DOM.");
      maxSupportedCssHeight = maxSupportedCssHeight || getMaxSupportedCssHeight(), scrollbarDimensions = scrollbarDimensions || measureScrollbar(), options = _jquery2.default.extend({}, defaults, options), validateAndEnforceOptions(), columnDefaults.width = options.defaultColumnWidth, treeColumns = new _slick2.default.TreeColumns(columns), columns = treeColumns.extractColumns(), columnsById = {};

      for (var e = 0; e < columns.length; e++) {
        var t = columns[e] = _jquery2.default.extend({}, columnDefaults, columns[e]);

        columnsById[t.id] = e, t.minWidth && t.width < t.minWidth && (t.width = t.minWidth), t.maxWidth && t.width > t.maxWidth && (t.width = t.maxWidth);
      }

      if (editController = {
        commitCurrentEdit: commitCurrentEdit,
        cancelCurrentEdit: cancelCurrentEdit
      }, $container.empty().css("overflow", "hidden").css("outline", 0).addClass(uid).addClass("ui-widget"), /relative|absolute|fixed/.test($container.css("position")) || $container.css("position", "relative"), $focusSink = (0, _jquery2.default)("<div tabIndex='0' hideFocus style='position:fixed;width:0;height:0;top:0;left:0;outline:0;'></div>").appendTo($container), $paneHeaderL = (0, _jquery2.default)("<div class='slick-pane slick-pane-header slick-pane-left' tabIndex='0' />").appendTo($container), $paneHeaderR = (0, _jquery2.default)("<div class='slick-pane slick-pane-header slick-pane-right' tabIndex='0' />").appendTo($container), $paneTopL = (0, _jquery2.default)("<div class='slick-pane slick-pane-top slick-pane-left' tabIndex='0' />").appendTo($container), $paneTopR = (0, _jquery2.default)("<div class='slick-pane slick-pane-top slick-pane-right' tabIndex='0' />").appendTo($container), $paneBottomL = (0, _jquery2.default)("<div class='slick-pane slick-pane-bottom slick-pane-left' tabIndex='0' />").appendTo($container), $paneBottomR = (0, _jquery2.default)("<div class='slick-pane slick-pane-bottom slick-pane-right' tabIndex='0' />").appendTo($container), $headerScrollerL = (0, _jquery2.default)("<div class='ui-state-default slick-header slick-header-left' />").appendTo($paneHeaderL), $headerScrollerR = (0, _jquery2.default)("<div class='ui-state-default slick-header slick-header-right' />").appendTo($paneHeaderR), $headerScroller = (0, _jquery2.default)().add($headerScrollerL).add($headerScrollerR), treeColumns.hasDepth()) {
        $groupHeadersL = [], $groupHeadersR = [];

        for (var o = 0; o < treeColumns.getDepth() - 1; o++) {
          $groupHeadersL[o] = (0, _jquery2.default)("<div class='slick-group-header-columns slick-group-header-columns-left' style='left:-1000px' />").appendTo($headerScrollerL), $groupHeadersR[o] = (0, _jquery2.default)("<div class='slick-group-header-columns slick-group-header-columns-right' style='left:-1000px' />").appendTo($headerScrollerR);
        }

        $groupHeaders = (0, _jquery2.default)().add($groupHeadersL).add($groupHeadersR);
      }

      $headerL = (0, _jquery2.default)("<div class='slick-header-columns slick-header-columns-left' style='left:-1000px' />").appendTo($headerScrollerL), $headerR = (0, _jquery2.default)("<div class='slick-header-columns slick-header-columns-right' style='left:-1000px' />").appendTo($headerScrollerR), $headers = (0, _jquery2.default)().add($headerL).add($headerR), $headerRowScrollerL = (0, _jquery2.default)("<div class='ui-state-default slick-headerrow' />").appendTo($paneTopL), $headerRowScrollerR = (0, _jquery2.default)("<div class='ui-state-default slick-headerrow' />").appendTo($paneTopR), $headerRowScroller = (0, _jquery2.default)().add($headerRowScrollerL).add($headerRowScrollerR), $headerRowSpacerL = (0, _jquery2.default)("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").css("width", getCanvasWidth() + scrollbarDimensions.width + "px").appendTo($headerRowScrollerL), $headerRowSpacerR = (0, _jquery2.default)("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").css("width", getCanvasWidth() + scrollbarDimensions.width + "px").appendTo($headerRowScrollerR), $headerRowL = (0, _jquery2.default)("<div class='slick-headerrow-columns slick-headerrow-columns-left' />").appendTo($headerRowScrollerL), $headerRowR = (0, _jquery2.default)("<div class='slick-headerrow-columns slick-headerrow-columns-right' />").appendTo($headerRowScrollerR), $headerRow = (0, _jquery2.default)().add($headerRowL).add($headerRowR), $topPanelScrollerL = (0, _jquery2.default)("<div class='ui-state-default slick-top-panel-scroller' />").appendTo($paneTopL), $topPanelScrollerR = (0, _jquery2.default)("<div class='ui-state-default slick-top-panel-scroller' />").appendTo($paneTopR), $topPanelScroller = (0, _jquery2.default)().add($topPanelScrollerL).add($topPanelScrollerR), $topPanelL = (0, _jquery2.default)("<div class='slick-top-panel' style='width:10000px' />").appendTo($topPanelScrollerL), $topPanelR = (0, _jquery2.default)("<div class='slick-top-panel' style='width:10000px' />").appendTo($topPanelScrollerR), $topPanel = (0, _jquery2.default)().add($topPanelL).add($topPanelR), options.showTopPanel || $topPanelScroller.hide(), options.showHeaderRow || $headerRowScroller.hide(), $viewportTopL = (0, _jquery2.default)("<div class='slick-viewport slick-viewport-top slick-viewport-left' tabIndex='0' hideFocus />").appendTo($paneTopL), $viewportTopR = (0, _jquery2.default)("<div class='slick-viewport slick-viewport-top slick-viewport-right' tabIndex='0' hideFocus />").appendTo($paneTopR), $viewportBottomL = (0, _jquery2.default)("<div class='slick-viewport slick-viewport-bottom slick-viewport-left' tabIndex='0' hideFocus />").appendTo($paneBottomL), $viewportBottomR = (0, _jquery2.default)("<div class='slick-viewport slick-viewport-bottom slick-viewport-right' tabIndex='0' hideFocus />").appendTo($paneBottomR), $viewport = (0, _jquery2.default)().add($viewportTopL).add($viewportTopR).add($viewportBottomL).add($viewportBottomR), $activeViewportNode = $viewportTopL, $canvasTopL = (0, _jquery2.default)("<div class='grid-canvas grid-canvas-top grid-canvas-left' tabIndex='0' hideFocus />").appendTo($viewportTopL), $canvasTopR = (0, _jquery2.default)("<div class='grid-canvas grid-canvas-top grid-canvas-right' tabIndex='0' hideFocus />").appendTo($viewportTopR), $canvasBottomL = (0, _jquery2.default)("<div class='grid-canvas grid-canvas-bottom grid-canvas-left' tabIndex='0' hideFocus />").appendTo($viewportBottomL), $canvasBottomR = (0, _jquery2.default)("<div class='grid-canvas grid-canvas-bottom grid-canvas-right' tabIndex='0' hideFocus />").appendTo($viewportBottomR), $canvas = (0, _jquery2.default)().add($canvasTopL).add($canvasTopR).add($canvasBottomL).add($canvasBottomR), $activeCanvasNode = $canvasTopL, $footerRowScrollerR = (0, _jquery2.default)("<div class='ui-state-default slick-footerrow' />").appendTo($paneTopR), $footerRowScrollerL = (0, _jquery2.default)("<div class='ui-state-default slick-footerrow' />").appendTo($paneTopL), $footerRowScroller = (0, _jquery2.default)().add($footerRowScrollerL).add($footerRowScrollerR), $footerRowSpacerL = (0, _jquery2.default)("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").css("width", getCanvasWidth() + scrollbarDimensions.width + "px").appendTo($footerRowScrollerL), $footerRowSpacerR = (0, _jquery2.default)("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").css("width", getCanvasWidth() + scrollbarDimensions.width + "px").appendTo($footerRowScrollerR), $footerRowL = (0, _jquery2.default)("<div class='slick-footerrow-columns slick-footerrow-columns-left' />").appendTo($footerRowScrollerL), $footerRowR = (0, _jquery2.default)("<div class='slick-footerrow-columns slick-footerrow-columns-right' />").appendTo($footerRowScrollerR), $footerRow = (0, _jquery2.default)().add($footerRowL).add($footerRowR), options.showFooterRow || $footerRowScroller.hide(), $focusSink2 = $focusSink.clone().appendTo($container), options.explicitInitialization || finishInitialization();
    }

    function finishInitialization() {
      initialized || (initialized = !0, getViewportWidth(), getViewportHeight(), measureCellPaddingAndBorder(), disableSelection($headers), options.enableTextSelectionOnCells || $viewport.bind("selectstart.ui", function (e) {
        return (0, _jquery2.default)(e.target).is("input,textarea");
      }), setFrozenOptions(), setPaneVisibility(), setScroller(), setOverflow(), updateColumnCaches(), createColumnHeaders(), createColumnGroupHeaders(), createColumnFooter(), setupColumnSort(), createCssRules(), resizeCanvas(), bindAncestorScrollEvents(), $container.bind("resize.slickgrid", resizeCanvas), $viewport.on("scroll", handleScroll), _jquery2.default.fn.mousewheel && (options.frozenColumn > -1 || hasFrozenRows) && $viewport.on("mousewheel", handleMouseWheel), $headerScroller.bind("contextmenu", handleHeaderContextMenu).bind("click", handleHeaderClick).delegate(".slick-header-column", "mouseenter", handleHeaderMouseEnter).delegate(".slick-header-column", "mouseleave", handleHeaderMouseLeave), $headerRowScroller.bind("scroll", handleHeaderRowScroll), $footerRowScroller.bind("scroll", handleFooterRowScroll), $focusSink.add($focusSink2).bind("keydown", handleKeyDown), $canvas.bind("keydown", handleKeyDown).bind("click", handleClick).bind("dblclick", handleDblClick).bind("contextmenu", handleContextMenu).delegate(".slick-cell", "mouseenter", handleMouseEnter).delegate(".slick-cell", "mouseleave", handleMouseLeave), (0, _interact2.default)($canvas[0]).allowFrom("div.slick-cell").draggable({
        onmove: handleDrag,
        onstart: handleDragStart,
        onend: handleDragEnd
      }).styleCursor(!1), navigator.userAgent.toLowerCase().match(/webkit/) && navigator.userAgent.toLowerCase().match(/macintosh/) && $canvas.on("mousewheel", handleMouseWheel));
    }

    function hasFrozenColumns() {
      return options.frozenColumn > -1;
    }

    function registerPlugin(e) {
      plugins.unshift(e), e.init(self);
    }

    function unregisterPlugin(e) {
      for (var t = plugins.length; t >= 0; t--) {
        if (plugins[t] === e) {
          plugins[t].destroy && plugins[t].destroy(), plugins.splice(t, 1);
          break;
        }
      }
    }

    function setSelectionModel(e) {
      selectionModel && (selectionModel.onSelectedRangesChanged.unsubscribe(handleSelectedRangesChanged), selectionModel.destroy && selectionModel.destroy()), selectionModel = e, selectionModel && (selectionModel.init(self), selectionModel.onSelectedRangesChanged.subscribe(handleSelectedRangesChanged));
    }

    function getSelectionModel() {
      return selectionModel;
    }

    function getCanvasNode() {
      return $canvas[0];
    }

    function getActiveCanvasNode(e) {
      return setActiveCanvasNode(e), $activeCanvasNode[0];
    }

    function getCanvases() {
      return $canvas;
    }

    function setActiveCanvasNode(e) {
      e && ($activeCanvasNode = (0, _jquery2.default)(e.target).closest(".grid-canvas"));
    }

    function getViewportNode() {
      return $viewport[0];
    }

    function getActiveViewportNode(e) {
      return setActiveViewportNode(e), $activeViewportNode[0];
    }

    function setActiveViewportNode(e) {
      e && ($activeViewportNode = (0, _jquery2.default)(e.target).closest(".slick-viewport"));
    }

    function measureScrollbar() {
      var e = (0, _jquery2.default)("<div class='scrollbar-fix' style='position:absolute; top:-10000px; left:-10000px; width:100px; height:100px; overflow:scroll;'></div>").appendTo(document.body),
          t = {
        width: e.width() - e[0].clientWidth,
        height: e.height() - e[0].clientHeight
      };
      return e.remove(), t;
    }

    function getHeadersWidth() {
      headersWidth = headersWidthL = headersWidthR = 0;

      for (var e = 0, t = columns.length; e < t; e++) {
        var o = columns[e].width;
        options.frozenColumn > -1 && e > options.frozenColumn ? headersWidthR += o : headersWidthL += o;
      }

      hasFrozenColumns() ? (headersWidthL += 1e3, headersWidthR = Math.max(headersWidthR, viewportW) + headersWidthL, headersWidthR += scrollbarDimensions.width) : (headersWidthL += scrollbarDimensions.width, headersWidthL = Math.max(headersWidthL, viewportW) + 1e3), headersWidth = headersWidthL + headersWidthR;
    }

    function getHeadersWidthL() {
      return headersWidthL = 0, columns.forEach(function (e, t) {
        options.frozenColumn > -1 && t > options.frozenColumn || (headersWidthL += e.width);
      }), hasFrozenColumns() ? headersWidthL += 1e3 : (headersWidthL += scrollbarDimensions.width, headersWidthL = Math.max(headersWidthL, viewportW) + 1e3), headersWidthL;
    }

    function getHeadersWidthR() {
      return headersWidthR = 0, columns.forEach(function (e, t) {
        options.frozenColumn > -1 && t > options.frozenColumn && (headersWidthR += e.width);
      }), hasFrozenColumns() && (headersWidthR = Math.max(headersWidthR, viewportW) + getHeadersWidthL(), headersWidthR += scrollbarDimensions.width), headersWidthR;
    }

    function getCanvasWidth() {
      var e = viewportHasVScroll ? viewportW - scrollbarDimensions.width : viewportW,
          t = columns.length;

      for (canvasWidthL = canvasWidthR = 0; t--;) {
        hasFrozenColumns() && t > options.frozenColumn ? canvasWidthR += columns[t].width : canvasWidthL += columns[t].width;
      }

      var o = canvasWidthL + canvasWidthR;
      return options.fullWidthRows ? Math.max(o, e) : o;
    }

    function updateCanvasWidth(e) {
      var t,
          o = canvasWidth,
          n = canvasWidthL,
          r = canvasWidthR;
      canvasWidth = getCanvasWidth(), t = canvasWidth !== o || canvasWidthL !== n || canvasWidthR !== r, (t || hasFrozenColumns() || hasFrozenRows) && ($canvasTopL.width(canvasWidthL), getHeadersWidth(), $headerL.width(headersWidthL), $headerR.width(headersWidthR), hasFrozenColumns() ? ($canvasTopR.width(canvasWidthR), $paneHeaderL.width(canvasWidthL), $paneHeaderR.css("left", canvasWidthL), $paneHeaderR.css("width", viewportW - canvasWidthL), $paneTopL.width(canvasWidthL), $paneTopR.css("left", canvasWidthL), $paneTopR.css("width", viewportW - canvasWidthL), $headerRowScrollerL.width(canvasWidthL), $headerRowScrollerR.width(viewportW - canvasWidthL), $headerRowL.width(canvasWidthL), $headerRowR.width(canvasWidthR), $footerRowScrollerL.width(canvasWidthL), $footerRowScrollerR.width(viewportW - canvasWidthL), $footerRowL.width(canvasWidthL), $footerRowR.width(canvasWidthR), $viewportTopL.width(canvasWidthL), $viewportTopR.width(viewportW - canvasWidthL), hasFrozenRows && ($paneBottomL.width(canvasWidthL), $paneBottomR.css("left", canvasWidthL), $viewportBottomL.width(canvasWidthL), $viewportBottomR.width(viewportW - canvasWidthL), $canvasBottomL.width(canvasWidthL), $canvasBottomR.width(canvasWidthR))) : ($paneHeaderL.width("100%"), $paneTopL.width("100%"), $headerRowScrollerL.width("100%"), $headerRowL.width(canvasWidth), $footerRowScrollerL.width("100%"), $footerRowL.width(canvasWidth), $viewportTopL.width("100%"), hasFrozenRows && ($viewportBottomL.width("100%"), $canvasBottomL.width(canvasWidthL))), viewportHasHScroll = canvasWidth > viewportW - scrollbarDimensions.width), $headerRowSpacerL.width(canvasWidth + (viewportHasVScroll ? scrollbarDimensions.width : 0)), $headerRowSpacerR.width(canvasWidth + (viewportHasVScroll ? scrollbarDimensions.width : 0)), $footerRowSpacerL.width(canvasWidth + (viewportHasVScroll ? scrollbarDimensions.width : 0)), $footerRowSpacerR.width(canvasWidth + (viewportHasVScroll ? scrollbarDimensions.width : 0)), (t || e) && applyColumnWidths();
    }

    function disableSelection(e) {
      e && e.jquery && e.attr("unselectable", "on").css("MozUserSelect", "none").bind("selectstart.ui", function () {
        return !1;
      });
    }

    function getMaxSupportedCssHeight() {
      for (var e = 1e6, t = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9, o = (0, _jquery2.default)("<div style='display:none' />").appendTo(document.body);;) {
        var n = 2 * e;
        if (o.css("height", n), n > t || o.height() !== n) break;
        e = n;
      }

      return o.remove(), e;
    }

    function bindAncestorScrollEvents() {
      for (var e = hasFrozenRows && !options.frozenBottom ? $canvasBottomL[0] : $canvasTopL[0]; (e = e.parentNode) != document.body && null != e;) {
        if (e == $viewportTopL[0] || e.scrollWidth != e.clientWidth || e.scrollHeight != e.clientHeight) {
          var t = (0, _jquery2.default)(e);
          $boundAncestors = $boundAncestors ? $boundAncestors.add(t) : t, t.bind("scroll." + uid, handleActiveCellPositionChange);
        }
      }
    }

    function unbindAncestorScrollEvents() {
      $boundAncestors && ($boundAncestors.unbind("scroll." + uid), $boundAncestors = null);
    }

    function updateColumnHeader(e, t, o) {
      if (initialized) {
        var n = getColumnIndex(e);

        if (null != n) {
          var r = columns[n],
              i = $headers.children().eq(n);
          i && (void 0 !== t && (columns[n].name = t), void 0 !== o && (columns[n].toolTip = o), trigger(self.onBeforeHeaderCellDestroy, {
            node: i[0],
            column: r
          }), i.attr("title", o || "").children().eq(0).html(t), trigger(self.onHeaderCellRendered, {
            node: i[0],
            column: r
          }));
        }
      }
    }

    function getHeaderRow() {
      return hasFrozenColumns() ? $headerRow : $headerRow[0];
    }

    function getHeaderRowColumn(e) {
      var t,
          o = getColumnIndex(e);
      hasFrozenColumns() ? o <= options.frozenColumn ? t = $headerRowL : (t = $headerRowR, o -= options.frozenColumn + 1) : t = $headerRowL;
      var n = t.children().eq(o);
      return n && n[0];
    }

    function getFooterRow() {
      return hasFrozenColumns() ? $footerRow : $footerRow[0];
    }

    function getFooterRowColumn(e) {
      var t,
          o = getColumnIndex(e);
      hasFrozenColumns() ? o <= options.frozenColumn ? t = $footerRowL : (t = $footerRowR, o -= options.frozenColumn + 1) : t = $footerRowL;
      var n = t.children().eq(o);
      return n && n[0];
    }

    function createColumnFooter() {
      $footerRow.find(".slick-footerrow-column").each(function () {
        var e = (0, _jquery2.default)(this).data("column");
        e && trigger(self.onBeforeFooterRowCellDestroy, {
          node: this,
          column: e
        });
      }), $footerRowL.empty(), $footerRowR.empty();

      for (var e = 0; e < columns.length; e++) {
        var t = columns[e],
            o = (0, _jquery2.default)("<div class='ui-state-default slick-footerrow-column l" + e + " r" + e + "'></div>").data("column", t).addClass(hasFrozenColumns() && e <= options.frozenColumn ? "frozen" : "").appendTo(hasFrozenColumns() && e > options.frozenColumn ? $footerRowR : $footerRowL);
        trigger(self.onFooterRowCellRendered, {
          node: o[0],
          column: t
        });
      }
    }

    function createColumnGroupHeaders() {
      var e = 0,
          t = !1;

      if (treeColumns.hasDepth()) {
        for (var o = 0; o < $groupHeadersL.length; o++) {
          $groupHeadersL[o].empty(), $groupHeadersR[o].empty();
          var n = treeColumns.getColumnsInDepth(o);

          for (var r in n) {
            var i = n[r];
            e += i.extractColumns().length, hasFrozenColumns() && 0 == o && e - 1 === options.frozenColumn && (t = !0), (0, _jquery2.default)("<div class='ui-state-default slick-group-header-column' />").html("<span class='slick-column-name'>" + i.name + "</span>").attr("id", "" + uid + i.id).attr("title", i.toolTip || "").data("column", i).addClass(i.headerCssClass || "").addClass(hasFrozenColumns() && e - 1 <= options.frozenColumn ? "frozen" : "").appendTo(hasFrozenColumns() && e - 1 > options.frozenColumn ? $groupHeadersR[o] : $groupHeadersL[o]);
          }

          if (hasFrozenColumns() && 0 == o && !t) {
            $groupHeadersL[o].empty(), $groupHeadersR[o].empty(), alert("All columns of group should to be grouped!");
            break;
          }
        }

        applyColumnGroupHeaderWidths();
      }
    }

    function createColumnHeaders() {
      function e() {
        (0, _jquery2.default)(this).addClass("ui-state-hover");
      }

      function t() {
        (0, _jquery2.default)(this).removeClass("ui-state-hover");
      }

      $headers.find(".slick-header-column").each(function () {
        var e = (0, _jquery2.default)(this).data("column");
        e && trigger(self.onBeforeHeaderCellDestroy, {
          node: this,
          column: e
        });
      }), $headerL.empty(), $headerR.empty(), getHeadersWidth(), $headerL.width(headersWidthL), $headerR.width(headersWidthR), $headerRow.find(".slick-headerrow-column").each(function () {
        var e = (0, _jquery2.default)(this).data("column");
        e && trigger(self.onBeforeHeaderRowCellDestroy, {
          node: this,
          column: e
        });
      }), $headerRowL.empty(), $headerRowR.empty();

      for (var o = 0; o < columns.length; o++) {
        var n = columns[o],
            r = hasFrozenColumns() ? o <= options.frozenColumn ? $headerL : $headerR : $headerL,
            i = hasFrozenColumns() ? o <= options.frozenColumn ? $headerRowL : $headerRowR : $headerRowL,
            s = (0, _jquery2.default)("<div class='ui-state-default slick-header-column' />").html("<span class='slick-column-name'>" + n.name + "</span>").width(n.width - headerColumnWidthDiff).attr("id", "" + uid + n.id).attr("title", n.toolTip || "").data("column", n).addClass(n.headerCssClass || "").addClass(hasFrozenColumns() && o <= options.frozenColumn ? "frozen" : "").appendTo(r);

        if ((options.enableColumnReorder || n.sortable) && s.on("mouseenter", e).on("mouseleave", t), n.sortable && (s.addClass("slick-header-sortable"), s.append("<span class='slick-sort-indicator' />")), trigger(self.onHeaderCellRendered, {
          node: s[0],
          column: n
        }), options.showHeaderRow) {
          var l = (0, _jquery2.default)("<div class='ui-state-default slick-headerrow-column l" + o + " r" + o + "'></div>").data("column", n).appendTo(i);
          trigger(self.onHeaderRowCellRendered, {
            node: l[0],
            column: n
          });
        }
      }

      setSortColumns(sortColumns), setupColumnResize(), options.enableColumnReorder && setupColumnReorder();
    }

    function setupColumnSort() {
      $headers.click(function (e) {
        if (e.metaKey = e.metaKey || e.ctrlKey, !(0, _jquery2.default)(e.target).hasClass("slick-resizable-handle")) {
          var t = (0, _jquery2.default)(e.target).closest(".slick-header-column");

          if (t.length) {
            var o = t.data("column");

            if (o.sortable) {
              if (!getEditorLock().commitCurrentEdit()) return;

              for (var n = null, r = 0; r < sortColumns.length; r++) {
                if (sortColumns[r].columnId == o.id) {
                  n = sortColumns[r], n.sortAsc = !n.sortAsc;
                  break;
                }
              }

              e.metaKey && options.multiColumnSort ? n && sortColumns.splice(r, 1) : ((e.shiftKey || e.metaKey) && options.multiColumnSort || (sortColumns = []), n ? 0 == sortColumns.length && sortColumns.push(n) : (n = {
                columnId: o.id,
                sortAsc: o.defaultSortAsc
              }, sortColumns.push(n))), setSortColumns(sortColumns), options.multiColumnSort ? trigger(self.onSort, {
                multiColumnSort: !0,
                sortCols: _jquery2.default.map(sortColumns, function (e) {
                  return {
                    sortCol: columns[getColumnIndex(e.columnId)],
                    sortAsc: e.sortAsc
                  };
                })
              }, e) : trigger(self.onSort, {
                multiColumnSort: !1,
                sortCol: o,
                sortAsc: n.sortAsc
              }, e);
            }
          }
        }
      });
    }

    function currentPositionInHeader(e) {
      var t = 0;
      return $headers.find(".slick-header-column").each(function (o) {
        if (this.id == e) return t = o, !1;
      }), t;
    }

    function limitPositionInGroup(e) {
      var t,
          o = 0,
          n = 0;
      return treeColumns.getColumnsInDepth($groupHeadersL.length - 1).some(function (r) {
        return o = n, n += r.columns.length, r.columns.some(function (o) {
          return o.id === e && (t = r), t;
        }), t;
      }), n--, {
        start: o,
        end: n,
        group: t
      };
    }

    function remove(e, t) {
      var o = e.lastIndexOf(t);
      o > -1 && (e.splice(o, 1), remove(e, t));
    }

    function columnPositionValidInGroup(e) {
      var t = currentPositionInHeader(e[0].id),
          o = limitPositionInGroup(e.data("column").id),
          n = o.start <= t && t <= o.end;
      return {
        limit: o,
        valid: n,
        message: n ? "" : 'Column "'.concat(e.text(), '" can be reordered only within the "', o.group.name, '" group!')
      };
    }

    function setupColumnReorder() {
      var e = 0,
          t = 0,
          o = document.createElement("div");
      o.className = "interact-placeholder", (0, _interact2.default)(".slick-header-column", {
        context: $container[0]
      }).ignoreFrom(".slick-resizable-handle").draggable({
        inertia: !0,
        restrict: {
          restriction: "parent",
          endOnly: !0,
          elementRect: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
          }
        },
        autoScroll: !0,
        axis: "x",
        onstart: function onstart(n) {
          e = 0, t = n.target.offsetWidth, $headers.find(".slick-header-column").each(function (e) {
            (0, _jquery2.default)(this).data("index", e);
          }), o.style.height = n.target.offsetHeight + "px", o.style.width = t + "px", (0, _jquery2.default)(n.target).after(o).css({
            position: "absolute",
            zIndex: 1e3,
            marginLeft: (0, _jquery2.default)(n.target).position().left - 1e3
          });
        },
        onmove: function onmove(t) {
          e += t.dx, t.target.style.transform = "translate3d(" + e + "px, -3px, 100px)";
        },
        onend: function onend(n) {
          if (e = 0, t = 0, treeColumns.hasDepth()) {
            var r = columnPositionValidInGroup((0, _jquery2.default)(n.target)),
                i = r.limit,
                s = !r.valid;
            s && alert(r.message);
          }

          if (o.parentNode.removeChild(o), s) return n.target.style.transform = "none", void setColumns(getColumns());
          (0, _jquery2.default)(n.target).css({
            position: "relative",
            zIndex: "",
            marginLeft: 0,
            transform: "none"
          });
          var l = [];
          $headers.find(".slick-header-column").each(function (e) {
            l.push(columns[(0, _jquery2.default)(this).data("index")]), (0, _jquery2.default)(this).removeData("index");
          }), setColumns(l), trigger(self.onColumnsReordered, {
            impactedColumns: getImpactedColumns(i),
            grid: self
          }), setupColumnResize();
        }
      }).dropzone({
        accept: ".slick-header-column",
        ondragenter: function ondragenter(e) {
          e.target.classList.add("interact-drop-active"), e.relatedTarget.classList.add("interact-can-drop");
        },
        ondragleave: function ondragleave(e) {
          e.target.classList.remove("interact-drop-active"), e.relatedTarget.classList.remove("interact-can-drop");
        },
        ondrop: function ondrop(t) {
          t.target.classList.remove("interact-drop-active"), t.relatedTarget.classList.remove("interact-can-drop"), (0, _jquery2.default)(t.target)[e > 0 ? "after" : "before"](t.relatedTarget);
        }
      }).styleCursor(!1);
    }

    function getImpactedColumns(e) {
      var t = [];
      if (void 0 != e) for (var o = e.start; o <= e.end; o++) {
        t.push(columns[o]);
      } else t = columns;
      return t;
    }

    function setupColumnResize() {
      var e, t, o, n;
      t = $headers.children(), t.find(".slick-resizable-handle").remove(), t.each(function (e, t) {
        columns[e].resizable && (void 0 === o && (o = e), n = e);
      }), void 0 !== o && t.each(function (t, r) {
        if (!(t < o || options.forceFitColumns && t >= n)) {
          e = (0, _jquery2.default)(r);
          var i = (0, _jquery2.default)("<div class='slick-resizable-handle' />");

          if (i.appendTo(r), !e.data("resizable")) {
            var s = columns[t];
            s.resizable && (e.data("resizable", !0), (0, _interact2.default)(r).resizable({
              preserveAspectRatio: !1,
              edges: {
                left: !0,
                right: !0,
                bottom: !1,
                top: !1
              }
            }).on("resizestart", function (e) {
              return !!getEditorLock().commitCurrentEdit() && (s.previousWidth = e.rect.width, void e.target.classList.add("slick-header-column-active"));
            }).on("resizemove", function (e) {
              var t = e.dx,
                  o = s.width += t;
              s.minWidth > 0 && s.minWidth > o ? o = s.minWidth : s.maxWidth > 0 && s.maxWidth < o && (o = s.maxWidth), s.width = o, options.forceFitColumns && autosizeColumns(), applyColumnHeaderWidths(), options.syncColumnCellResize && applyColumnWidths();
            }).on("resizeend", function (e) {
              e.target.classList.remove("slick-header-column-active"), treeColumns.hasDepth() && createColumnGroupHeaders(), invalidateAllRows(), updateCanvasWidth(!0), render(), trigger(self.onColumnsResized, {
                grid: self
              });
            }));
          }
        }
      });
    }

    function getVBoxDelta(e) {
      var t = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"],
          o = 0;
      return _jquery2.default.each(t, function (t, n) {
        o += parseFloat(e.css(n)) || 0;
      }), o;
    }

    function setFrozenOptions() {
      if (options.frozenColumn = options.frozenColumn >= 0 && options.frozenColumn < columns.length ? parseInt(options.frozenColumn) : -1, options.frozenRow = options.frozenRow >= 0 && options.frozenRow < numVisibleRows ? parseInt(options.frozenRow) : -1, options.frozenRow > -1) {
        hasFrozenRows = !0, frozenRowsHeight = options.frozenRow * options.rowHeight;
        var e = getDataLength() || this.data.length;
        actualFrozenRow = options.frozenBottom ? e - options.frozenRow : options.frozenRow;
      } else hasFrozenRows = !1;
    }

    function setPaneVisibility() {
      hasFrozenColumns() ? ($paneHeaderR.show(), $paneTopR.show(), hasFrozenRows ? ($paneBottomL.show(), $paneBottomR.show()) : ($paneBottomR.hide(), $paneBottomL.hide())) : ($paneHeaderR.hide(), $paneTopR.hide(), $paneBottomR.hide(), hasFrozenRows ? $paneBottomL.show() : ($paneBottomR.hide(), $paneBottomL.hide()));
    }

    function setOverflow() {
      $viewportTopL.css({
        "overflow-x": hasFrozenColumns() ? hasFrozenRows ? "hidden" : "scroll" : hasFrozenRows ? "hidden" : "auto",
        "overflow-y": hasFrozenColumns() ? "hidden" : hasFrozenRows ? "scroll" : "auto"
      }), $viewportTopR.css({
        "overflow-x": hasFrozenColumns() ? hasFrozenRows ? "hidden" : "scroll" : hasFrozenRows ? "hidden" : "auto",
        "overflow-y": hasFrozenColumns() ? hasFrozenRows ? "scroll" : "auto" : hasFrozenRows ? "scroll" : "auto"
      }), $viewportBottomL.css({
        "overflow-x": hasFrozenColumns() && hasFrozenRows ? "scroll" : "auto",
        "overflow-y": hasFrozenColumns() ? "hidden" : hasFrozenRows ? "scroll" : "auto"
      }), $viewportBottomR.css({
        "overflow-x": hasFrozenColumns() && hasFrozenRows ? "scroll" : "auto",
        "overflow-y": (hasFrozenColumns(), "auto")
      });
    }

    function setScroller() {
      hasFrozenColumns() ? ($headerScrollContainer = $headerScrollerR, $headerRowScrollContainer = $headerRowScrollerR, $footerRowScrollContainer = $footerRowScrollerR, hasFrozenRows ? options.frozenBottom ? ($viewportScrollContainerX = $viewportBottomR, $viewportScrollContainerY = $viewportTopR) : $viewportScrollContainerX = $viewportScrollContainerY = $viewportBottomR : $viewportScrollContainerX = $viewportScrollContainerY = $viewportTopR) : ($headerScrollContainer = $headerScrollerL, $headerRowScrollContainer = $headerRowScrollerL, $footerRowScrollContainer = $footerRowScrollerL, hasFrozenRows ? options.frozenBottom ? ($viewportScrollContainerX = $viewportBottomL, $viewportScrollContainerY = $viewportTopL) : $viewportScrollContainerX = $viewportScrollContainerY = $viewportBottomL : $viewportScrollContainerX = $viewportScrollContainerY = $viewportTopL);
    }

    function measureCellPaddingAndBorder() {
      var e,
          t = ["borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight"],
          o = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"];
      e = (0, _jquery2.default)("<div class='ui-state-default slick-header-column' style='visibility:hidden'>-</div>").appendTo($headers), headerColumnWidthDiff = headerColumnHeightDiff = 0, "border-box" != e.css("box-sizing") && "border-box" != e.css("-moz-box-sizing") && "border-box" != e.css("-webkit-box-sizing") && (_jquery2.default.each(t, function (t, o) {
        headerColumnWidthDiff += parseFloat(e.css(o)) || 0;
      }), _jquery2.default.each(o, function (t, o) {
        headerColumnHeightDiff += parseFloat(e.css(o)) || 0;
      })), e.remove();
      var n = (0, _jquery2.default)("<div class='slick-row' />").appendTo($canvas);
      e = (0, _jquery2.default)("<div class='slick-cell' id='' style='visibility:hidden'>-</div>").appendTo(n), cellWidthDiff = cellHeightDiff = 0, "border-box" != e.css("box-sizing") && "border-box" != e.css("-moz-box-sizing") && "border-box" != e.css("-webkit-box-sizing") && (_jquery2.default.each(t, function (t, o) {
        cellWidthDiff += parseFloat(e.css(o)) || 0;
      }), _jquery2.default.each(o, function (t, o) {
        cellHeightDiff += parseFloat(e.css(o)) || 0;
      })), n.remove(), absoluteColumnMinWidth = Math.max(headerColumnWidthDiff, cellWidthDiff);
    }

    function createCssRules() {
      $style = (0, _jquery2.default)("<style type='text/css' rel='stylesheet' />").appendTo((0, _jquery2.default)("head"));

      for (var e = options.rowHeight - cellHeightDiff, t = ["." + uid + " .slick-group-header-column { left: 1000px; }", "." + uid + " .slick-header-column { left: 1000px; }", "." + uid + " .slick-top-panel { height:" + options.topPanelHeight + "px; }", "." + uid + " .slick-headerrow-columns { height:" + options.headerRowHeight + "px; }", "." + uid + " .slick-cell { height:" + e + "px; }", "." + uid + " .slick-row { height:" + options.rowHeight + "px; }", "." + uid + " .slick-footerrow-columns { height:" + options.footerRowHeight + "px; }"], o = 0; o < columns.length; o++) {
        t.push("." + uid + " .l" + o + " { }"), t.push("." + uid + " .r" + o + " { }");
      }

      $style[0].styleSheet ? $style[0].styleSheet.cssText = t.join(" ") : $style[0].appendChild(document.createTextNode(t.join(" ")));
    }

    function getColumnCssRules(e) {
      if (!stylesheet) {
        for (var t = document.styleSheets, o = 0; o < t.length; o++) {
          if ((t[o].ownerNode || t[o].owningElement) == $style[0]) {
            stylesheet = t[o];
            break;
          }
        }

        if (!stylesheet) throw new Error("Cannot find stylesheet.");
        columnCssRulesL = [], columnCssRulesR = [];

        for (var n, r, i = stylesheet.cssRules || stylesheet.rules, o = 0; o < i.length; o++) {
          var s = i[o].selectorText;
          (n = /\.l\d+/.exec(s)) ? (r = parseInt(n[0].substr(2, n[0].length - 2), 10), columnCssRulesL[r] = i[o]) : (n = /\.r\d+/.exec(s)) && (r = parseInt(n[0].substr(2, n[0].length - 2), 10), columnCssRulesR[r] = i[o]);
        }
      }

      return {
        left: columnCssRulesL[e],
        right: columnCssRulesR[e]
      };
    }

    function removeCssRules() {
      $style.remove(), stylesheet = null;
    }

    function destroy() {
      getEditorLock().cancelCurrentEdit(), trigger(self.onBeforeDestroy, {});

      for (var e = plugins.length; e--;) {
        unregisterPlugin(plugins[e]);
      }

      unbindAncestorScrollEvents(), $container.unbind(".slickgrid"), removeCssRules(), $container.empty().removeClass(uid);
    }

    function trigger(e, t, o) {
      return o = o || new _slick2.default.EventData(), t = t || {}, t.grid = self, e.notify(t, o, self);
    }

    function getEditorLock() {
      return options.editorLock;
    }

    function getEditController() {
      return editController;
    }

    function getColumnIndex(e) {
      return columnsById[e];
    }

    function autosizeColumns() {
      var e,
          t,
          o,
          n = [],
          r = 0,
          i = 0,
          s = viewportHasVScroll ? viewportW - scrollbarDimensions.width : viewportW;

      for (e = 0; e < columns.length; e++) {
        t = columns[e], n.push(t.width), i += t.width, t.resizable && (r += t.width - Math.max(t.minWidth, absoluteColumnMinWidth));
      }

      for (o = i; i > s && r;) {
        var l = (i - s) / r;

        for (e = 0; e < columns.length && i > s; e++) {
          t = columns[e];
          var a = n[e];

          if (!(!t.resizable || a <= t.minWidth || a <= absoluteColumnMinWidth)) {
            var c = Math.max(t.minWidth, absoluteColumnMinWidth),
                d = Math.floor(l * (a - c)) || 1;
            d = Math.min(d, a - c), i -= d, r -= d, n[e] -= d;
          }
        }

        if (o <= i) break;
        o = i;
      }

      for (o = i; i < s;) {
        var u = s / i;

        for (e = 0; e < columns.length && i < s; e++) {
          t = columns[e];
          var h,
              p = n[e];
          h = !t.resizable || t.maxWidth <= p ? 0 : Math.min(Math.floor(u * p) - p, t.maxWidth - p || 1e6) || 1, i += h, n[e] += h;
        }

        if (o >= i) break;
        o = i;
      }

      var f = !1;

      for (e = 0; e < columns.length; e++) {
        columns[e].rerenderOnResize && columns[e].width != n[e] && (f = !0), columns[e].width = n[e];
      }

      applyColumnHeaderWidths(), applyColumnGroupHeaderWidths(), updateCanvasWidth(!0), f && (invalidateAllRows(), render());
    }

    function applyColumnGroupHeaderWidths() {
      if (treeColumns.hasDepth()) for (var e = $groupHeadersL.length - 1; e >= 0; e--) {
        treeColumns.getColumnsInDepth(e);
        (0, _jquery2.default)().add($groupHeadersL[e]).add($groupHeadersR[e]).each(function (e) {
          var t = (0, _jquery2.default)(this),
              o = 0;
          t.width(0 == e ? getHeadersWidthL() : getHeadersWidthR()), t.children().each(function () {
            var e = (0, _jquery2.default)(this),
                n = (0, _jquery2.default)(this).data("column");
            n.width = 0, n.columns.forEach(function () {
              var e = t.next().children(":eq(" + o++ + ")");
              n.width += e.outerWidth();
            }), e.width(n.width - headerColumnWidthDiff);
          });
        });
      }
    }

    function applyColumnHeaderWidths() {
      if (initialized) {
        for (var e, t = 0, o = $headers.children(), n = o.length; t < n; t++) {
          e = (0, _jquery2.default)(o[t]), e.width() !== columns[t].width - headerColumnWidthDiff && e.width(columns[t].width - headerColumnWidthDiff);
        }

        updateColumnCaches();
      }
    }

    function applyColumnWidths() {
      for (var e, t, o = 0, n = 0; n < columns.length; n++) {
        e = columns[n].width, t = getColumnCssRules(n), t.left.style.left = o + "px", t.right.style.right = (options.frozenColumn != -1 && n > options.frozenColumn ? canvasWidthR : canvasWidthL) - o - e + "px", options.frozenColumn == n ? o = 0 : o += columns[n].width;
      }
    }

    function setSortColumn(e, t) {
      setSortColumns([{
        columnId: e,
        sortAsc: t
      }]);
    }

    function setSortColumns(e) {
      sortColumns = e;
      var t = $headers.children();
      t.removeClass("slick-header-column-sorted").find(".slick-sort-indicator").removeClass("slick-sort-indicator-asc slick-sort-indicator-desc"), _jquery2.default.each(sortColumns, function (e, o) {
        null == o.sortAsc && (o.sortAsc = !0);
        var n = getColumnIndex(o.columnId);
        null != n && t.eq(n).addClass("slick-header-column-sorted").find(".slick-sort-indicator").addClass(o.sortAsc ? "slick-sort-indicator-asc" : "slick-sort-indicator-desc");
      });
    }

    function getSortColumns() {
      return sortColumns;
    }

    function handleSelectedRangesChanged(e, t) {
      selectedRows = [];

      for (var o = {}, n = 0; n < t.length; n++) {
        for (var r = t[n].fromRow; r <= t[n].toRow; r++) {
          o[r] || (selectedRows.push(r), o[r] = {});

          for (var i = t[n].fromCell; i <= t[n].toCell; i++) {
            canCellBeSelected(r, i) && (o[r][columns[i].id] = options.selectedCellCssClass);
          }
        }
      }

      setCellCssStyles(options.selectedCellCssClass, o), trigger(self.onSelectedRowsChanged, {
        rows: getSelectedRows()
      }, e);
    }

    function getColumns() {
      return columns;
    }

    function updateColumnCaches() {
      columnPosLeft = [], columnPosRight = [];

      for (var e = 0, t = 0, o = columns.length; t < o; t++) {
        columnPosLeft[t] = e, columnPosRight[t] = e + columns[t].width, options.frozenColumn == t ? e = 0 : e += columns[t].width;
      }
    }

    function setColumns(e) {
      var t = new _slick2.default.TreeColumns(e);
      t.hasDepth() ? (treeColumns = t, columns = treeColumns.extractColumns()) : columns = e, columnsById = {};

      for (var o = 0; o < columns.length; o++) {
        var n = columns[o] = _jquery2.default.extend({}, columnDefaults, columns[o]);

        columnsById[n.id] = o, n.minWidth && n.width < n.minWidth && (n.width = n.minWidth), n.maxWidth && n.width > n.maxWidth && (n.width = n.maxWidth);
      }

      updateColumnCaches(), initialized && (setPaneVisibility(), setOverflow(), invalidateAllRows(), createColumnHeaders(), createColumnGroupHeaders(), createColumnFooter(), removeCssRules(), createCssRules(), resizeCanvas(), updateCanvasWidth(), applyColumnWidths(), handleScroll());
    }

    function getOptions() {
      return options;
    }

    function setOptions(e) {
      getEditorLock().commitCurrentEdit() && (makeActiveCellNormal(), options.enableAddRow !== e.enableAddRow && invalidateRow(getDataLength()), options = _jquery2.default.extend(options, e), validateAndEnforceOptions(), setFrozenOptions(), setScroller(), zombieRowNodeFromLastMouseWheelEvent = null, setColumns(treeColumns.extractColumns()), render());
    }

    function validateAndEnforceOptions() {
      options.autoHeight && (options.leaveSpaceForNewRows = !1);
    }

    function setData(e, t) {
      data = e, invalidateAllRows(), updateRowCount(), t && scrollTo(0);
    }

    function getData() {
      return data;
    }

    function getDataLength() {
      return data.getLength ? data.getLength() : data.length;
    }

    function getDataLengthIncludingAddNew() {
      return getDataLength() + (options.enableAddRow ? 1 : 0);
    }

    function getDataItem(e) {
      return data.getItem ? data.getItem(e) : data[e];
    }

    function getTopPanel() {
      return $topPanel[0];
    }

    function setTopPanelVisibility(e) {
      options.showTopPanel != e && (options.showTopPanel = e, e ? $topPanelScroller.slideDown("fast", resizeCanvas) : $topPanelScroller.slideUp("fast", resizeCanvas));
    }

    function setHeaderRowVisibility(e) {
      options.showHeaderRow != e && (options.showHeaderRow = e, e ? $headerRowScroller.slideDown("fast", resizeCanvas) : $headerRowScroller.slideUp("fast", resizeCanvas));
    }

    function setFooterRowVisibility(e) {
      options.showFooterRow != e && (options.showFooterRow = e, e ? $footerRowScroller.fadeIn("fast", resizeCanvas) : $footerRowScroller.slideDown("fast", resizeCanvas));
    }

    function getContainerNode() {
      return $container.get(0);
    }

    function getRowTop(e) {
      return options.rowHeight * e - offset;
    }

    function getRowFromPosition(e) {
      return Math.floor((e + offset) / options.rowHeight);
    }

    function scrollTo(e) {
      e = Math.max(e, 0), e = Math.min(e, th - $viewportScrollContainerY.height() + (viewportHasHScroll || hasFrozenColumns() ? scrollbarDimensions.height : 0));
      var t = offset;
      page = Math.min(n - 1, Math.floor(e / ph)), offset = Math.round(page * cj);
      var o = e - offset;

      if (offset != t) {
        var r = getVisibleRange(o);
        cleanupRows(r), updateRowPositions();
      }

      prevScrollTop != o && (vScrollDir = prevScrollTop + t < o + offset ? 1 : -1, lastRenderedScrollTop = scrollTop = prevScrollTop = o, hasFrozenColumns() && ($viewportTopL[0].scrollTop = o), hasFrozenRows && ($viewportBottomL[0].scrollTop = $viewportBottomR[0].scrollTop = o), $viewportScrollContainerY[0].scrollTop = o, trigger(self.onViewportChanged, {}));
    }

    function defaultFormatter(e, t, o, n, r) {
      return null == o ? "" : (o + "").replace(/&/g, "&").replace(/</g, "<").replace(/>/g, ">");
    }

    function getFormatter(e, t) {
      var o = data.getItemMetadata && data.getItemMetadata(e),
          n = o && o.columns && (o.columns[t.id] || o.columns[getColumnIndex(t.id)]);
      return n && n.formatter || o && o.formatter || t.formatter || options.formatterFactory && options.formatterFactory.getFormatter(t) || options.defaultFormatter;
    }

    function callFormatter(e, t, o, n, r) {
      var i,
          s = data.getItemMetadata && data.getItemMetadata(e);

      if (s = s && s.columns) {
        var l = s[n.id] || s[t];
        i = getFormatter(e, n)(e, t, o, n, r, l);
      } else i = getFormatter(e, n)(e, t, o, n, r);

      return i;
    }

    function getEditor(e, t) {
      var o = columns[t],
          n = data.getItemMetadata && data.getItemMetadata(e),
          r = n && n.columns;
      return r && r[o.id] && void 0 !== r[o.id].editor ? r[o.id].editor : r && r[t] && void 0 !== r[t].editor ? r[t].editor : o.editor || options.editorFactory && options.editorFactory.getEditor(o);
    }

    function getDataItemValueForColumn(e, t) {
      return options.dataItemColumnValueExtractor ? options.dataItemColumnValueExtractor(e, t) : e[t.field];
    }

    function appendRowHtml(e, t, o, n, r) {
      var i = getDataItem(o),
          s = o < r && !i,
          l = "slick-row" + (hasFrozenRows && o < options.frozenRow ? " frozen" : "") + (s ? " loading" : "") + (o === activeRow ? " active" : "") + (o % 2 == 1 ? " odd" : " even");
      i || (l += " " + options.addNewRowCssClass);
      var a = data.getItemMetadata && data.getItemMetadata(o);
      a && a.cssClasses && (l += " " + a.cssClasses);
      var c = getFrozenRowOffset(o),
          d = "<div class='ui-widget-content " + l + "' style='top:" + (getRowTop(o) - c) + "px'>";
      e.push(d), hasFrozenColumns() && t.push(d);

      for (var u, h, p = 0, f = columns.length; p < f; p++) {
        if (h = columns[p], u = 1, a && a.columns) {
          var g = a.columns[h.id] || a.columns[p];
          u = g && g.colspan || 1, "*" === u && (u = f - p);
        }

        if (columnPosRight[Math.min(f - 1, p + u - 1)] > n.leftPx) {
          if (columnPosLeft[p] > n.rightPx) break;
          hasFrozenColumns() && p > options.frozenColumn ? appendCellHtml(t, o, p, u, i) : appendCellHtml(e, o, p, u, i);
        } else hasFrozenColumns() && p <= options.frozenColumn && appendCellHtml(e, o, p, u, i);

        u > 1 && (p += u - 1);
      }

      e.push("</div>"), hasFrozenColumns() && t.push("</div>");
    }

    function appendCellHtml(e, t, o, n, r) {
      var i = columns[o],
          s = "slick-cell l" + o + " r" + Math.min(columns.length - 1, o + n - 1) + (i.cssClass ? " " + i.cssClass : "");
      hasFrozenColumns() && o <= options.frozenColumn && (s += " frozen"), t === activeRow && o === activeCell && (s += " active");

      for (var l in cellCssClasses) {
        cellCssClasses[l][t] && cellCssClasses[l][t][i.id] && (s += " " + cellCssClasses[l][t][i.id]);
      }

      if (e.push("<div class='" + s + "'>"), r) {
        var a = getDataItemValueForColumn(r, i);
        e.push(callFormatter(t, o, a, i, r));
      }

      e.push("</div>"), rowsCache[t].cellRenderQueue.push(o), rowsCache[t].cellColSpans[o] = n;
    }

    function cleanupRows(e) {
      for (var t in rowsCache) {
        var o = !0;
        hasFrozenRows && (options.frozenBottom && t >= actualFrozenRow || !options.frozenBottom && t <= actualFrozenRow) && (o = !1), (t = parseInt(t, 10)) !== activeRow && (t < e.top || t > e.bottom) && o && removeRowFromCache(t);
      }
    }

    function invalidate() {
      updateRowCount(), invalidateAllRows(), render();
    }

    function invalidateAllRows() {
      currentEditor && makeActiveCellNormal();

      for (var e in rowsCache) {
        removeRowFromCache(e);
      }
    }

    function removeRowFromCache(e) {
      var t = rowsCache[e];
      t && (rowNodeFromLastMouseWheelEvent == t.rowNode[0] || hasFrozenColumns() && rowNodeFromLastMouseWheelEvent == t.rowNode[1] ? (t.rowNode.hide(), zombieRowNodeFromLastMouseWheelEvent = t.rowNode) : t.rowNode.each(function () {
        this.parentElement.removeChild(this);
      }), delete rowsCache[e], delete postProcessedRows[e], renderedRows--, counter_rows_removed++);
    }

    function invalidateRows(e) {
      var t, o;
      if (e && e.length) for (vScrollDir = 0, t = 0, o = e.length; t < o; t++) {
        currentEditor && activeRow === e[t] && makeActiveCellNormal(), rowsCache[e[t]] && removeRowFromCache(e[t]);
      }
    }

    function invalidateRow(e) {
      invalidateRows([e]);
    }

    function updateCell(e, t) {
      var o = getCellNode(e, t);

      if (o) {
        var n = columns[t],
            r = getDataItem(e);
        currentEditor && activeRow === e && activeCell === t ? currentEditor.loadValue(r) : (o.innerHTML = r ? callFormatter(e, t, getDataItemValueForColumn(r, n), n, r) : "", invalidatePostProcessingResults(e));
      }
    }

    function updateRow(e) {
      var t = rowsCache[e];

      if (t) {
        ensureCellNodesInRowsCache(e);
        var o = getDataItem(e);

        for (var n in t.cellNodesByColumnIdx) {
          if (t.cellNodesByColumnIdx.hasOwnProperty(n)) {
            n |= 0;
            var r = columns[n],
                i = t.cellNodesByColumnIdx[n][0];
            e === activeRow && n === activeCell && currentEditor ? currentEditor.loadValue(o) : o ? i.innerHTML = callFormatter(e, n, getDataItemValueForColumn(o, r), r, o) : i.innerHTML = "";
          }
        }

        invalidatePostProcessingResults(e);
      }
    }

    function getViewportHeight() {
      options.autoHeight ? viewportH = options.rowHeight * getDataLengthIncludingAddNew() + (options.frozenColumn == -1 ? $headers.outerHeight() : 0) : (topPanelH = options.showTopPanel ? options.topPanelHeight + getVBoxDelta($topPanelScroller) : 0, headerRowH = options.showHeaderRow ? options.headerRowHeight + getVBoxDelta($headerRowScroller) : 0, footerRowH = options.showFooterRow ? options.footerRowHeight + getVBoxDelta($footerRowScroller) : 0, viewportH = parseFloat(_jquery2.default.css($container[0], "height", !0)) - parseFloat(_jquery2.default.css($container[0], "paddingTop", !0)) - parseFloat(_jquery2.default.css($container[0], "paddingBottom", !0)) - parseFloat(_jquery2.default.css($headerScroller[0], "height")) - getVBoxDelta($headerScroller) - topPanelH - headerRowH - footerRowH), numVisibleRows = Math.ceil(viewportH / options.rowHeight);
    }

    function getViewportWidth() {
      viewportW = parseFloat(_jquery2.default.css($container[0], "width", !0));
    }

    function resizeCanvas() {
      if (initialized) {
        paneTopH = 0, paneBottomH = 0, viewportTopH = 0, viewportBottomH = 0, getViewportWidth(), getViewportHeight(), hasFrozenRows ? options.frozenBottom ? (paneTopH = viewportH - frozenRowsHeight - scrollbarDimensions.height, paneBottomH = frozenRowsHeight + scrollbarDimensions.height) : (paneTopH = frozenRowsHeight, paneBottomH = viewportH - frozenRowsHeight) : paneTopH = viewportH, paneTopH += topPanelH + headerRowH + footerRowH, hasFrozenColumns() && options.autoHeight && (paneTopH += scrollbarDimensions.height), viewportTopH = paneTopH - topPanelH - headerRowH - footerRowH, options.autoHeight && (hasFrozenColumns() && $container.height(paneTopH + parseFloat(_jquery2.default.css($headerScrollerL[0], "height"))), $paneTopL.css("position", "relative")), $paneTopL.css({
          top: $paneHeaderL.height(),
          height: paneTopH
        });
        var e = $paneTopL.position().top + paneTopH;
        $viewportTopL.height(viewportTopH), hasFrozenColumns() ? ($paneTopR.css({
          top: $paneHeaderL.height(),
          height: paneTopH
        }), $viewportTopR.height(viewportTopH), hasFrozenRows && ($paneBottomL.css({
          top: e,
          height: paneBottomH
        }), $paneBottomR.css({
          top: e,
          height: paneBottomH
        }), $viewportBottomR.height(paneBottomH))) : hasFrozenRows && ($paneBottomL.css({
          width: "100%",
          height: paneBottomH
        }), $paneBottomL.css("top", e)), hasFrozenRows ? ($viewportBottomL.height(paneBottomH), options.frozenBottom ? ($canvasBottomL.height(frozenRowsHeight), hasFrozenColumns() && $canvasBottomR.height(frozenRowsHeight)) : ($canvasTopL.height(frozenRowsHeight), hasFrozenColumns() && $canvasTopR.height(frozenRowsHeight))) : $viewportTopR.height(viewportTopH), options.forceFitColumns && autosizeColumns(), updateRowCount(), handleScroll(), lastRenderedScrollLeft = -1, render();
      }
    }

    function updateRowCount() {
      if (initialized) {
        var e = getDataLengthIncludingAddNew(),
            t = 0,
            o = hasFrozenRows && !options.frozenBottom ? $canvasBottomL.height() : $canvasTopL.height();
        if (hasFrozenRows) var t = getDataLength() - options.frozenRow;else var t = e + (options.leaveSpaceForNewRows ? numVisibleRows - 1 : 0);
        var r = $viewportScrollContainerY.height(),
            i = viewportHasVScroll;
        viewportHasVScroll = !options.autoHeight && t * options.rowHeight > r, makeActiveCellNormal();
        var s = e - 1;

        for (var l in rowsCache) {
          l >= s && removeRowFromCache(l);
        }

        th = Math.max(options.rowHeight * t, r - scrollbarDimensions.height), activeCellNode && activeRow > s && resetActiveCell(), th < maxSupportedCssHeight ? (h = ph = th, n = 1, cj = 0) : (h = maxSupportedCssHeight, ph = h / 100, n = Math.floor(th / ph), cj = (th - h) / (n - 1)), h !== o && (hasFrozenRows && !options.frozenBottom ? ($canvasBottomL.css("height", h), hasFrozenColumns() && $canvasBottomR.css("height", h)) : ($canvasTopL.css("height", h), $canvasTopR.css("height", h)), scrollTop = $viewportScrollContainerY[0].scrollTop);
        var a = scrollTop + offset <= th - r;
        0 == th || 0 == scrollTop ? page = offset = 0 : scrollTo(a ? scrollTop + offset : th - r), h != o && options.autoHeight && resizeCanvas(), options.forceFitColumns && i != viewportHasVScroll && autosizeColumns(), updateCanvasWidth(!1);
      }
    }

    function getVisibleRange(e, t) {
      return null == e && (e = scrollTop), null == t && (t = scrollLeft), {
        top: getRowFromPosition(e),
        bottom: getRowFromPosition(e + viewportH) + 1,
        leftPx: t,
        rightPx: t + viewportW
      };
    }

    function getRenderedRange(e, t) {
      var o = getVisibleRange(e, t),
          n = Math.round(viewportH / options.rowHeight),
          r = 3;
      return vScrollDir == -1 ? (o.top -= n, o.bottom += r) : 1 == vScrollDir ? (o.top -= r, o.bottom += n) : (o.top -= r, o.bottom += r), o.top = Math.max(0, o.top), o.bottom = Math.min(getDataLengthIncludingAddNew() - 1, o.bottom), o.leftPx -= viewportW, o.rightPx += viewportW, o.leftPx = Math.max(0, o.leftPx), o.rightPx = Math.min(canvasWidth, o.rightPx), o;
    }

    function ensureCellNodesInRowsCache(e) {
      var t = rowsCache[e];
      if (t && t.cellRenderQueue.length) for (var o = t.rowNode.children().last(); t.cellRenderQueue.length;) {
        var n = t.cellRenderQueue.pop();
        t.cellNodesByColumnIdx[n] = o, o = o.prev(), 0 == o.length && (o = (0, _jquery2.default)(t.rowNode[0]).children().last());
      }
    }

    function cleanUpCells(e, t) {
      if (!hasFrozenRows || !(options.frozenBottom && t > actualFrozenRow || t <= actualFrozenRow)) {
        var o = 0,
            n = rowsCache[t],
            r = [];

        for (var i in n.cellNodesByColumnIdx) {
          if (n.cellNodesByColumnIdx.hasOwnProperty(i) && (i |= 0, !(i <= options.frozenColumn))) {
            var s = n.cellColSpans[i];
            (columnPosLeft[i] > e.rightPx || columnPosRight[Math.min(columns.length - 1, i + s - 1)] < e.leftPx) && (t == activeRow && i == activeCell || r.push(i));
          }
        }

        for (var l; null != (l = r.pop());) {
          n.cellNodesByColumnIdx[l][0].parentElement.removeChild(n.cellNodesByColumnIdx[l][0]), delete n.cellColSpans[l], delete n.cellNodesByColumnIdx[l], postProcessedRows[t] && delete postProcessedRows[t][l], o++;
        }
      }
    }

    function cleanUpAndRenderCells(e) {
      for (var t, o, n, r = [], i = [], s = 0, l = e.top, a = e.bottom; l <= a; l++) {
        if (t = rowsCache[l]) {
          ensureCellNodesInRowsCache(l), cleanUpCells(e, l), o = 0;
          var c = data.getItemMetadata && data.getItemMetadata(l);
          c = c && c.columns;

          for (var d = getDataItem(l), u = 0, h = columns.length; u < h && !(columnPosLeft[u] > e.rightPx); u++) {
            if (null == (n = t.cellColSpans[u])) {
              if (n = 1, c) {
                var p = c[columns[u].id] || c[u];
                n = p && p.colspan || 1, "*" === n && (n = h - u);
              }

              columnPosRight[Math.min(h - 1, u + n - 1)] > e.leftPx && (appendCellHtml(r, l, u, n, d), o++), u += n > 1 ? n - 1 : 0;
            } else u += n > 1 ? n - 1 : 0;
          }

          o && (s += o, i.push(l));
        }
      }

      if (r.length) {
        var f = document.createElement("div");
        f.innerHTML = r.join("");

        for (var g, v; null != (g = i.pop());) {
          t = rowsCache[g];

          for (var m; null != (m = t.cellRenderQueue.pop());) {
            v = (0, _jquery2.default)(f).children().last(), hasFrozenColumns() && m > options.frozenColumn ? (0, _jquery2.default)(t.rowNode[1]).append(v) : (0, _jquery2.default)(t.rowNode[0]).append(v), t.cellNodesByColumnIdx[m] = v;
          }
        }
      }
    }

    function renderRows(e) {
      for (var t = [], o = [], n = [], r = !1, i = getDataLength(), s = e.top, l = e.bottom; s <= l; s++) {
        rowsCache[s] || hasFrozenRows && options.frozenBottom && s == getDataLength() || (renderedRows++, n.push(s), rowsCache[s] = {
          rowNode: null,
          cellColSpans: [],
          cellNodesByColumnIdx: [],
          cellRenderQueue: []
        }, appendRowHtml(t, o, s, e, i), activeCellNode && activeRow === s && (r = !0), counter_rows_rendered++);
      }

      if (n.length) {
        var a = document.createElement("div"),
            c = document.createElement("div");
        a.innerHTML = t.join(""), c.innerHTML = o.join("");

        for (var s = 0, l = n.length; s < l; s++) {
          hasFrozenRows && n[s] >= actualFrozenRow ? hasFrozenColumns() ? rowsCache[n[s]].rowNode = (0, _jquery2.default)().add((0, _jquery2.default)(a.firstChild).appendTo($canvasBottomL)).add((0, _jquery2.default)(c.firstChild).appendTo($canvasBottomR)) : rowsCache[n[s]].rowNode = (0, _jquery2.default)().add((0, _jquery2.default)(a.firstChild).appendTo($canvasBottomL)) : hasFrozenColumns() ? rowsCache[n[s]].rowNode = (0, _jquery2.default)().add((0, _jquery2.default)(a.firstChild).appendTo($canvasTopL)).add((0, _jquery2.default)(c.firstChild).appendTo($canvasTopR)) : rowsCache[n[s]].rowNode = (0, _jquery2.default)().add((0, _jquery2.default)(a.firstChild).appendTo($canvasTopL));
        }

        r && (activeCellNode = getCellNode(activeRow, activeCell));
      }
    }

    function startPostProcessing() {
      options.enableAsyncPostRender && (clearTimeout(h_postrender), h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay));
    }

    function invalidatePostProcessingResults(e) {
      delete postProcessedRows[e], postProcessFromRow = Math.min(postProcessFromRow, e), postProcessToRow = Math.max(postProcessToRow, e), startPostProcessing();
    }

    function updateRowPositions() {
      for (var e in rowsCache) {
        rowsCache[e].rowNode.css("top", getRowTop(e) + "px");
      }
    }

    function render() {
      if (initialized) {
        var e = getVisibleRange(),
            t = getRenderedRange();

        if (cleanupRows(t), lastRenderedScrollLeft != scrollLeft) {
          if (hasFrozenRows) {
            var o = _jquery2.default.extend(!0, {}, t);

            options.frozenBottom ? (o.top = actualFrozenRow, o.bottom = getDataLength()) : (o.top = 0, o.bottom = options.frozenRow), cleanUpAndRenderCells(o);
          }

          cleanUpAndRenderCells(t);
        }

        renderRows(t), hasFrozenRows && renderRows(options.frozenBottom ? {
          top: actualFrozenRow,
          bottom: getDataLength() - 1,
          leftPx: t.leftPx,
          rightPx: t.rightPx
        } : {
          top: 0,
          bottom: options.frozenRow - 1,
          leftPx: t.leftPx,
          rightPx: t.rightPx
        }), postProcessFromRow = e.top, postProcessToRow = Math.min(getDataLengthIncludingAddNew() - 1, e.bottom), startPostProcessing(), lastRenderedScrollTop = scrollTop, lastRenderedScrollLeft = scrollLeft, h_render = null;
      }
    }

    function handleHeaderRowScroll() {
      var e = $headerRowScrollContainer[0].scrollLeft;
      e != $viewportScrollContainerX[0].scrollLeft && ($viewportScrollContainerX[0].scrollLeft = e);
    }

    function handleFooterRowScroll() {
      var e = $footerRowScrollContainer[0].scrollLeft;
      e != $viewportScrollContainerX[0].scrollLeft && ($viewportScrollContainerX[0].scrollLeft = e);
    }

    function handleMouseWheel(e, t, o, n) {
      var r = (0, _jquery2.default)(e.target).closest(".slick-row"),
          i = r[0];

      if (i != rowNodeFromLastMouseWheelEvent) {
        var s = r.parents(".grid-canvas"),
            l = s.hasClass("grid-canvas-left");

        if (zombieRowNodeFromLastMouseWheelEvent && zombieRowNodeFromLastMouseWheelEvent[l ? 0 : 1] != i) {
          var a = zombieRowNodeFromLastMouseWheelEvent[l || 1 == zombieRowNodeFromLastMouseWheelEvent.length ? 0 : 1];
          a.parentElement.removeChild(a), zombieRowNodeFromLastMouseWheelEvent = null;
        }

        rowNodeFromLastMouseWheelEvent = i;
      }

      scrollTop = Math.max(0, $viewportScrollContainerY[0].scrollTop - n * options.rowHeight), scrollLeft = $viewportScrollContainerX[0].scrollLeft + 10 * o;

      var c = _handleScroll(!0);

      c && e.preventDefault();
    }

    function handleScroll() {
      return scrollTop = $viewportScrollContainerY[0].scrollTop, scrollLeft = $viewportScrollContainerX[0].scrollLeft, _handleScroll(!1);
    }

    function _handleScroll(e) {
      var t = $viewportScrollContainerY[0].scrollHeight - $viewportScrollContainerY[0].clientHeight,
          o = $viewportScrollContainerY[0].scrollWidth - $viewportScrollContainerY[0].clientWidth,
          r = hasFrozenColumns();
      scrollTop > t && (scrollTop = t), scrollLeft > o && (scrollLeft = o);
      var i = Math.abs(scrollTop - prevScrollTop),
          s = Math.abs(scrollLeft - prevScrollLeft);
      if (s && (prevScrollLeft = scrollLeft, $viewportScrollContainerX[0].scrollLeft = scrollLeft, $headerScrollContainer[0].scrollLeft = scrollLeft, $topPanelScroller[0].scrollLeft = scrollLeft, $headerRowScrollContainer[0].scrollLeft = scrollLeft, $footerRowScrollContainer[0].scrollLeft = scrollLeft, r ? hasFrozenRows && ($viewportTopR[0].scrollLeft = scrollLeft) : hasFrozenRows && ($viewportTopL[0].scrollLeft = scrollLeft)), i) if (vScrollDir = prevScrollTop < scrollTop ? 1 : -1, prevScrollTop = scrollTop, e && ($viewportScrollContainerY[0].scrollTop = scrollTop), r && (hasFrozenRows && !options.frozenBottom ? $viewportBottomL[0].scrollTop = scrollTop : $viewportTopL[0].scrollTop = scrollTop), i < viewportH) scrollTo(scrollTop + offset);else {
        var l = offset;
        page = h == viewportH ? 0 : Math.min(n - 1, Math.floor(scrollTop * ((th - viewportH) / (h - viewportH)) * (1 / ph))), offset = Math.round(page * cj), l != offset && invalidateAllRows();
      }
      return (s || i) && (h_render && clearTimeout(h_render), (Math.abs(lastRenderedScrollTop - scrollTop) > 20 || Math.abs(lastRenderedScrollLeft - scrollLeft) > 20) && (options.forceSyncScrolling || Math.abs(lastRenderedScrollTop - scrollTop) < viewportH && Math.abs(lastRenderedScrollLeft - scrollLeft) < viewportW ? render() : h_render = setTimeout(render, 50), trigger(self.onViewportChanged, {}))), trigger(self.onScroll, {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      }), !(!s && !i);
    }

    function asyncPostProcessRows() {
      for (var e = getDataLength(); postProcessFromRow <= postProcessToRow;) {
        var t = vScrollDir >= 0 ? postProcessFromRow++ : postProcessToRow--,
            o = rowsCache[t];

        if (o && !(t >= e)) {
          postProcessedRows[t] || (postProcessedRows[t] = {}), ensureCellNodesInRowsCache(t);

          for (var n in o.cellNodesByColumnIdx) {
            if (o.cellNodesByColumnIdx.hasOwnProperty(n)) {
              n |= 0;
              var r = columns[n];

              if (r.asyncPostRender && !postProcessedRows[t][n]) {
                var i = o.cellNodesByColumnIdx[n];
                i && r.asyncPostRender(i, t, getDataItem(t), r), postProcessedRows[t][n] = !0;
              }
            }
          }

          return void (h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay));
        }
      }
    }

    function updateCellCssStylesOnRenderedRows(e, t) {
      var o, n, r, i;

      for (var s in rowsCache) {
        if (i = t && t[s], r = e && e[s], i) for (n in i) {
          r && i[n] == r[n] || (o = getCellNode(s, getColumnIndex(n)), o && (0, _jquery2.default)(o).removeClass(i[n]));
        }
        if (r) for (n in r) {
          i && i[n] == r[n] || (o = getCellNode(s, getColumnIndex(n)), o && (0, _jquery2.default)(o).addClass(r[n]));
        }
      }
    }

    function addCellCssStyles(e, t) {
      if (cellCssClasses[e]) throw "addCellCssStyles: cell CSS hash with key '" + e + "' already exists.";
      cellCssClasses[e] = t, updateCellCssStylesOnRenderedRows(t, null), trigger(self.onCellCssStylesChanged, {
        key: e,
        hash: t
      });
    }

    function removeCellCssStyles(e) {
      cellCssClasses[e] && (updateCellCssStylesOnRenderedRows(null, cellCssClasses[e]), delete cellCssClasses[e], trigger(self.onCellCssStylesChanged, {
        key: e,
        hash: null
      }));
    }

    function setCellCssStyles(e, t) {
      var o = cellCssClasses[e];
      cellCssClasses[e] = t, updateCellCssStylesOnRenderedRows(t, o), trigger(self.onCellCssStylesChanged, {
        key: e,
        hash: t
      });
    }

    function getCellCssStyles(e) {
      return cellCssClasses[e];
    }

    function flashCell(e, t, o) {
      if (o = o || 100, rowsCache[e]) {
        var n = function e(t) {
          t && setTimeout(function () {
            r.queue(function () {
              r.toggleClass(options.cellFlashingCssClass).dequeue(), e(t - 1);
            });
          }, o);
        },
            r = (0, _jquery2.default)(getCellNode(e, t));

        n(4);
      }
    }

    function handleDragInit(e, t) {
      var o = getCellFromEvent(e);
      if (!o || !cellExists(o.row, o.cell)) return !1;
      var n = trigger(self.onDragInit, t, e);
      return !!e.isImmediatePropagationStopped() && n;
    }

    function handleDragStart(e) {
      var t = _jquery2.default.Event(e.originalEvent.type, e.originalEvent),
          o = getCellFromEvent(t);

      if (!o || !cellExists(o.row, o.cell)) return !1;
      var n = trigger(self.onDragStart, e, t);
      return !!t.isImmediatePropagationStopped() && n;
    }

    function handleDrag(e) {
      var t = _jquery2.default.Event(e.originalEvent.type, e.originalEvent);

      return trigger(self.onDrag, e, t);
    }

    function handleDragEnd(e) {
      trigger(self.onDragEnd, e, _jquery2.default.Event("mousedown"));
    }

    function handleKeyDown(e) {
      trigger(self.onKeyDown, {
        row: activeRow,
        cell: activeCell
      }, e);
      var t = e.isImmediatePropagationStopped();
      if (!t) if (e.shiftKey || e.altKey || e.ctrlKey) 9 != e.which || !e.shiftKey || e.ctrlKey || e.altKey || (t = navigatePrev());else if (27 == e.which) {
        if (!getEditorLock().isActive()) return;
        cancelEditAndSetFocus();
      } else 34 == e.which ? (navigatePageDown(), t = !0) : 33 == e.which ? (navigatePageUp(), t = !0) : 37 == e.which ? t = navigateLeft() : 39 == e.which ? t = navigateRight() : 38 == e.which ? t = navigateUp() : 40 == e.which ? t = navigateDown() : 9 == e.which ? t = navigateNext() : 13 == e.which && (options.editable && (currentEditor ? activeRow === getDataLength() ? navigateDown() : commitEditAndSetFocus() : getEditorLock().commitCurrentEdit() && makeActiveCellEditable()), t = !0);

      if (t) {
        e.stopPropagation(), e.preventDefault();

        try {
          e.originalEvent.keyCode = 0;
        } catch (e) {}
      }
    }

    function handleClick(e) {
      currentEditor || (e.target != document.activeElement || (0, _jquery2.default)(e.target).hasClass("slick-cell")) && setFocus();
      var t = getCellFromEvent(e);
      !t || null !== currentEditor && activeRow == t.row && activeCell == t.cell || (trigger(self.onClick, {
        row: t.row,
        cell: t.cell
      }, e), e.isImmediatePropagationStopped() || activeCell == t.cell && activeRow == t.row || !canCellBeActive(t.row, t.cell) || getEditorLock().isActive() && !getEditorLock().commitCurrentEdit() || (scrollRowIntoView(t.row, !1), setActiveCellInternal(getCellNode(t.row, t.cell))));
    }

    function handleContextMenu(e) {
      var t = (0, _jquery2.default)(e.target).closest(".slick-cell", $canvas);
      0 !== t.length && (activeCellNode === t[0] && null !== currentEditor || trigger(self.onContextMenu, {}, e));
    }

    function handleDblClick(e) {
      var t = getCellFromEvent(e);
      !t || null !== currentEditor && activeRow == t.row && activeCell == t.cell || (trigger(self.onDblClick, {
        row: t.row,
        cell: t.cell
      }, e), e.isImmediatePropagationStopped() || options.editable && gotoCell(t.row, t.cell, !0));
    }

    function handleHeaderMouseEnter(e) {
      trigger(self.onHeaderMouseEnter, {
        column: (0, _jquery2.default)(this).data("column")
      }, e);
    }

    function handleHeaderMouseLeave(e) {
      trigger(self.onHeaderMouseLeave, {
        column: (0, _jquery2.default)(this).data("column")
      }, e);
    }

    function handleHeaderContextMenu(e) {
      var t = (0, _jquery2.default)(e.target).closest(".slick-header-column", ".slick-header-columns"),
          o = t && t.data("column");
      trigger(self.onHeaderContextMenu, {
        column: o
      }, e);
    }

    function handleHeaderClick(e) {
      var t = (0, _jquery2.default)(e.target).closest(".slick-header-column", ".slick-header-columns"),
          o = t && t.data("column");
      o && trigger(self.onHeaderClick, {
        column: o
      }, e);
    }

    function handleMouseEnter(e) {
      trigger(self.onMouseEnter, {}, e);
    }

    function handleMouseLeave(e) {
      trigger(self.onMouseLeave, {}, e);
    }

    function cellExists(e, t) {
      return !(e < 0 || e >= getDataLength() || t < 0 || t >= columns.length);
    }

    function getCellFromPoint(e, t) {
      for (var o = getRowFromPosition(t), n = 0, r = 0, i = 0; i < columns.length && r < e; i++) {
        r += columns[i].width, n++;
      }

      return n < 0 && (n = 0), {
        row: o,
        cell: n - 1
      };
    }

    function getCellFromNode(e) {
      var t = /l\d+/.exec(e.className);
      if (!t) throw "getCellFromNode: cannot get cell - " + e.className;
      return parseInt(t[0].substr(1, t[0].length - 1), 10);
    }

    function getRowFromNode(e) {
      for (var t in rowsCache) {
        for (var o in rowsCache[t].rowNode) {
          if (rowsCache[t].rowNode[o] === e) return 0 | t;
        }
      }

      return null;
    }

    function getFrozenRowOffset(e) {
      var t = hasFrozenRows ? options.frozenBottom ? e >= actualFrozenRow ? h < viewportTopH ? actualFrozenRow * options.rowHeight : h : 0 : e >= actualFrozenRow ? frozenRowsHeight : 0 : 0;
      return t;
    }

    function getCellFromEvent(e) {
      var t,
          o,
          n = (0, _jquery2.default)(e.target).closest(".slick-cell", $canvas);
      if (!n.length) return null;

      if (t = getRowFromNode(n[0].parentNode), hasFrozenRows) {
        var r = n.parents(".grid-canvas").offset(),
            i = 0,
            s = n.parents(".grid-canvas-bottom").length;
        s && (i = options.frozenBottom ? $canvasTopL.height() : frozenRowsHeight), t = getCellFromPoint(e.clientX - r.left, e.clientY - r.top + i + (0, _jquery2.default)(document).scrollTop()).row;
      }

      return o = getCellFromNode(n[0]), null == t || null == o ? null : {
        row: t,
        cell: o
      };
    }

    function getCellNodeBox(e, t) {
      if (!cellExists(e, t)) return null;

      for (var o = getFrozenRowOffset(e), n = getRowTop(e) - o, r = n + options.rowHeight - 1, i = 0, s = 0; s < t; s++) {
        i += columns[s].width, options.frozenColumn == s && (i = 0);
      }

      var l = i + columns[t].width;
      return {
        top: n,
        left: i,
        bottom: r,
        right: l
      };
    }

    function resetActiveCell() {
      setActiveCellInternal(null, !1);
    }

    function setFocus() {
      tabbingDirection == -1 ? $focusSink[0].focus() : $focusSink2[0].focus();
    }

    function scrollCellIntoView(e, t, o) {
      if (!(t <= options.frozenColumn)) {
        e < actualFrozenRow && scrollRowIntoView(e, o);
        var n = getColspan(e, t),
            r = columnPosLeft[t],
            i = columnPosRight[t + (n > 1 ? n - 1 : 0)],
            s = scrollLeft + $viewportScrollContainerX.width();
        r < scrollLeft ? ($viewportScrollContainerX.scrollLeft(r), handleScroll(), render()) : i > s && ($viewportScrollContainerX.scrollLeft(Math.min(r, i - $viewportScrollContainerX[0].clientWidth)), handleScroll(), render());
      }
    }

    function setActiveCellInternal(e, t) {
      null !== activeCellNode && (makeActiveCellNormal(), (0, _jquery2.default)(activeCellNode).removeClass("active"), rowsCache[activeRow] && (0, _jquery2.default)(rowsCache[activeRow].rowNode).removeClass("active"));
      var o = activeCellNode !== e;

      if (activeCellNode = e, null != activeCellNode) {
        var n = (0, _jquery2.default)(activeCellNode),
            r = n.offset(),
            i = Math.floor(n.parents(".grid-canvas").offset().top),
            s = n.parents(".grid-canvas-bottom").length;
        hasFrozenRows && s && (i -= options.frozenBottom ? $canvasTopL.height() : frozenRowsHeight);
        var l = getCellFromPoint(r.left, Math.ceil(r.top) - i);
        activeRow = l.row, activeCell = activePosX = activeCell = activePosX = getCellFromNode(activeCellNode[0]), n.addClass("active"), rowsCache[activeRow] && (0, _jquery2.default)(rowsCache[activeRow].rowNode).addClass("active"), null == t && (t = activeRow == getDataLength() || options.autoEdit), options.editable && t && isCellPotentiallyEditable(activeRow, activeCell) && (clearTimeout(h_editorLoader), options.asyncEditorLoading ? h_editorLoader = setTimeout(function () {
          makeActiveCellEditable();
        }, options.asyncEditorLoadDelay) : makeActiveCellEditable());
      } else activeRow = activeCell = null;

      o && (setTimeout(scrollActiveCellIntoView, 50), trigger(self.onActiveCellChanged, getActiveCell()));
    }

    function clearTextSelection() {
      if (document.selection && document.selection.empty) try {
        document.selection.empty();
      } catch (e) {} else if (window.getSelection) {
        var e = window.getSelection();
        e && e.removeAllRanges && e.removeAllRanges();
      }
    }

    function isCellPotentiallyEditable(e, t) {
      var o = getDataLength();
      return !(e < o && !getDataItem(e)) && !(columns[t].cannotTriggerInsert && e >= o) && !!getEditor(e, t);
    }

    function makeActiveCellNormal() {
      if (currentEditor) {
        if (trigger(self.onBeforeCellEditorDestroy, {
          editor: currentEditor
        }), currentEditor.destroy(), currentEditor = null, activeCellNode) {
          var e = getDataItem(activeRow);

          if ((0, _jquery2.default)(activeCellNode).removeClass("editable invalid"), e) {
            var t = columns[activeCell];
            activeCellNode[0].innerHTML = callFormatter(activeRow, activeCell, getDataItemValueForColumn(e, t), t, e), invalidatePostProcessingResults(activeRow);
          }
        }

        navigator.userAgent.toLowerCase().match(/msie/) && clearTextSelection(), getEditorLock().deactivate(editController);
      }
    }

    function makeActiveCellEditable(e) {
      if (activeCellNode) {
        if (!options.editable) throw "Grid : makeActiveCellEditable : should never get called when options.editable is false";

        if (clearTimeout(h_editorLoader), isCellPotentiallyEditable(activeRow, activeCell)) {
          var t = columns[activeCell],
              o = getDataItem(activeRow);
          if (trigger(self.onBeforeEditCell, {
            row: activeRow,
            cell: activeCell,
            item: o,
            column: t
          }) === !1) return void setFocus();
          getEditorLock().activate(editController), (0, _jquery2.default)(activeCellNode).addClass("editable"), e || (activeCellNode[0].innerHTML = ""), currentEditor = new (e || getEditor(activeRow, activeCell))({
            grid: self,
            gridPosition: absBox($container[0]),
            position: absBox(activeCellNode[0]),
            container: activeCellNode,
            column: t,
            item: o || {},
            commitChanges: commitEditAndSetFocus,
            cancelChanges: cancelEditAndSetFocus
          }), o && currentEditor.loadValue(o), serializedEditorValue = currentEditor.serializeValue(), currentEditor.position && handleActiveCellPositionChange();
        }
      }
    }

    function commitEditAndSetFocus() {
      getEditorLock().commitCurrentEdit() && (setFocus(), options.autoEdit && navigateDown());
    }

    function cancelEditAndSetFocus() {
      getEditorLock().cancelCurrentEdit() && setFocus();
    }

    function absBox(e) {
      var t = {
        top: e.offsetTop,
        left: e.offsetLeft,
        bottom: 0,
        right: 0,
        width: (0, _jquery2.default)(e).outerWidth(),
        height: (0, _jquery2.default)(e).outerHeight(),
        visible: !0
      };
      t.bottom = t.top + t.height, t.right = t.left + t.width;

      for (var o = e.offsetParent; (e = e.parentNode) != document.body;) {
        t.visible && e.scrollHeight != e.offsetHeight && "visible" != (0, _jquery2.default)(e).css("overflowY") && (t.visible = t.bottom > e.scrollTop && t.top < e.scrollTop + e.clientHeight), t.visible && e.scrollWidth != e.offsetWidth && "visible" != (0, _jquery2.default)(e).css("overflowX") && (t.visible = t.right > e.scrollLeft && t.left < e.scrollLeft + e.clientWidth), t.left -= e.scrollLeft, t.top -= e.scrollTop, e === o && (t.left += e.offsetLeft, t.top += e.offsetTop, o = e.offsetParent), t.bottom = t.top + t.height, t.right = t.left + t.width;
      }

      return t;
    }

    function getActiveCellPosition() {
      return absBox(activeCellNode[0]);
    }

    function getGridPosition() {
      return absBox($container[0]);
    }

    function handleActiveCellPositionChange() {
      if (activeCellNode && (trigger(self.onActiveCellPositionChanged, {}), currentEditor)) {
        var e = getActiveCellPosition();
        currentEditor.show && currentEditor.hide && (e.visible ? currentEditor.show() : currentEditor.hide()), currentEditor.position && currentEditor.position(e);
      }
    }

    function getCellEditor() {
      return currentEditor;
    }

    function getActiveCell() {
      return activeCellNode ? {
        row: activeRow,
        cell: activeCell
      } : null;
    }

    function getActiveCellNode() {
      return activeCellNode;
    }

    function scrollActiveCellIntoView() {
      null != activeRow && null != activeCell && scrollCellIntoView(activeRow, activeCell);
    }

    function scrollRowIntoView(e, t) {
      if (!hasFrozenRows || !options.frozenBottom && e > actualFrozenRow - 1 || options.frozenBottom && e < actualFrozenRow - 1) {
        var o = $viewportScrollContainerY.height(),
            n = e * options.rowHeight,
            r = (e + 1) * options.rowHeight - o + (viewportHasHScroll ? scrollbarDimensions.height : 0);
        (e + 1) * options.rowHeight > scrollTop + o + offset ? (scrollTo(t ? n : r), render()) : e * options.rowHeight < scrollTop + offset && (scrollTo(t ? r : n), render());
      }
    }

    function scrollRowToTop(e) {
      scrollTo(e * options.rowHeight), render();
    }

    function scrollPage(e) {
      var t = e * numVisibleRows;

      if (scrollTo((getRowFromPosition(scrollTop) + t) * options.rowHeight), render(), options.enableCellNavigation && null != activeRow) {
        var o = activeRow + t,
            n = getDataLengthIncludingAddNew();
        o >= n && (o = n - 1), o < 0 && (o = 0);

        for (var r = 0, i = null, s = activePosX; r <= activePosX;) {
          canCellBeActive(o, r) && (i = r), r += getColspan(o, r);
        }

        null !== i ? (setActiveCellInternal(getCellNode(o, i)), activePosX = s) : resetActiveCell();
      }
    }

    function navigatePageDown() {
      scrollPage(1);
    }

    function navigatePageUp() {
      scrollPage(-1);
    }

    function getColspan(e, t) {
      var o = data.getItemMetadata && data.getItemMetadata(e);
      if (!o || !o.columns) return 1;
      var n = columns[t] && (o.columns[columns[t].id] || o.columns[t]),
          r = n && n.colspan;
      return r = "*" === r ? columns.length - t : r || 1;
    }

    function findFirstFocusableCell(e) {
      for (var t = 0; t < columns.length;) {
        if (canCellBeActive(e, t)) return t;
        t += getColspan(e, t);
      }

      return null;
    }

    function findLastFocusableCell(e) {
      for (var t = 0, o = null; t < columns.length;) {
        canCellBeActive(e, t) && (o = t), t += getColspan(e, t);
      }

      return o;
    }

    function gotoRight(e, t, o) {
      if (t >= columns.length) return null;

      do {
        t += getColspan(e, t);
      } while (t < columns.length && !canCellBeActive(e, t));

      return t < columns.length ? {
        row: e,
        cell: t,
        posX: t
      } : null;
    }

    function gotoLeft(e, t, o) {
      if (t <= 0) return null;
      var n = findFirstFocusableCell(e);
      if (null === n || n >= t) return null;

      for (var r, i = {
        row: e,
        cell: n,
        posX: n
      };;) {
        if (r = gotoRight(i.row, i.cell, i.posX), !r) return null;
        if (r.cell >= t) return i;
        i = r;
      }
    }

    function gotoDown(e, t, o) {
      for (var n, r = getDataLengthIncludingAddNew();;) {
        if (++e >= r) return null;

        for (n = t = 0; t <= o;) {
          n = t, t += getColspan(e, t);
        }

        if (canCellBeActive(e, n)) return {
          row: e,
          cell: n,
          posX: o
        };
      }
    }

    function gotoUp(e, t, o) {
      for (var n;;) {
        if (--e < 0) return null;

        for (n = t = 0; t <= o;) {
          n = t, t += getColspan(e, t);
        }

        if (canCellBeActive(e, n)) return {
          row: e,
          cell: n,
          posX: o
        };
      }
    }

    function gotoNext(e, t, o) {
      if (null == e && null == t && (e = t = o = 0, canCellBeActive(e, t))) return {
        row: e,
        cell: t,
        posX: t
      };
      var n = gotoRight(e, t, o);
      if (n) return n;

      for (var r = null, i = getDataLengthIncludingAddNew(); ++e < i;) {
        if (r = findFirstFocusableCell(e), null !== r) return {
          row: e,
          cell: r,
          posX: r
        };
      }

      return null;
    }

    function gotoPrev(e, t, o) {
      if (null == e && null == t && (e = getDataLengthIncludingAddNew() - 1, t = o = columns.length - 1, canCellBeActive(e, t))) return {
        row: e,
        cell: t,
        posX: t
      };

      for (var n, r; !n && !(n = gotoLeft(e, t, o));) {
        if (--e < 0) return null;
        t = 0, r = findLastFocusableCell(e), null !== r && (n = {
          row: e,
          cell: r,
          posX: r
        });
      }

      return n;
    }

    function navigateRight() {
      return navigate("right");
    }

    function navigateLeft() {
      return navigate("left");
    }

    function navigateDown() {
      return navigate("down");
    }

    function navigateUp() {
      return navigate("up");
    }

    function navigateNext() {
      return navigate("next");
    }

    function navigatePrev() {
      return navigate("prev");
    }

    function navigate(e) {
      if (!options.enableCellNavigation) return !1;
      if (!activeCellNode && "prev" != e && "next" != e) return !1;
      if (!getEditorLock().commitCurrentEdit()) return !0;
      setFocus();
      var t = {
        up: -1,
        down: 1,
        left: -1,
        right: 1,
        prev: -1,
        next: 1
      };
      tabbingDirection = t[e];
      var o = {
        up: gotoUp,
        down: gotoDown,
        left: gotoLeft,
        right: gotoRight,
        prev: gotoPrev,
        next: gotoNext
      },
          n = o[e],
          r = n(activeRow, activeCell, activePosX);

      if (r) {
        if (hasFrozenRows && options.frozenBottom & r.row == getDataLength()) return;
        var i = r.row == getDataLength();
        return (!options.frozenBottom && r.row >= actualFrozenRow || options.frozenBottom && r.row < actualFrozenRow) && scrollCellIntoView(r.row, r.cell, !i), setActiveCellInternal(getCellNode(r.row, r.cell)), activePosX = r.posX, !0;
      }

      return setActiveCellInternal(getCellNode(activeRow, activeCell)), !1;
    }

    function getCellNode(e, t) {
      return rowsCache[e] ? (ensureCellNodesInRowsCache(e), rowsCache[e].cellNodesByColumnIdx[t]) : null;
    }

    function setActiveCell(e, t) {
      initialized && (e > getDataLength() || e < 0 || t >= columns.length || t < 0 || options.enableCellNavigation && (scrollCellIntoView(e, t, !1), setActiveCellInternal(getCellNode(e, t), !1)));
    }

    function canCellBeActive(e, t) {
      if (!options.enableCellNavigation || e >= getDataLengthIncludingAddNew() || e < 0 || t >= columns.length || t < 0) return !1;
      var o = data.getItemMetadata && data.getItemMetadata(e);
      if (o && "boolean" == typeof o.focusable) return o.focusable;
      var n = o && o.columns;
      return n && columns[t] && n[columns[t].id] && "boolean" == typeof n[columns[t].id].focusable ? n[columns[t].id].focusable : n && n[t] && "boolean" == typeof n[t].focusable ? n[t].focusable : columns[t] && columns[t].focusable;
    }

    function canCellBeSelected(e, t) {
      if (e >= getDataLength() || e < 0 || t >= columns.length || t < 0) return !1;
      var o = data.getItemMetadata && data.getItemMetadata(e);
      if (o && "boolean" == typeof o.selectable) return o.selectable;
      var n = o && o.columns && (o.columns[columns[t].id] || o.columns[t]);
      return n && "boolean" == typeof n.selectable ? n.selectable : columns[t].selectable;
    }

    function gotoCell(e, t, o) {
      if (initialized && canCellBeActive(e, t) && getEditorLock().commitCurrentEdit()) {
        scrollCellIntoView(e, t, !1);
        var n = getCellNode(e, t);
        setActiveCellInternal(n, o || e === getDataLength() || options.autoEdit), currentEditor || setFocus();
      }
    }

    function commitCurrentEdit() {
      var e = getDataItem(activeRow),
          t = columns[activeCell];

      if (currentEditor) {
        if (currentEditor.isValueChanged()) {
          var o = currentEditor.validate();

          if (o.valid) {
            if (activeRow < getDataLength()) {
              var n = {
                row: activeRow,
                cell: activeCell,
                editor: currentEditor,
                serializedValue: currentEditor.serializeValue(),
                prevSerializedValue: serializedEditorValue,
                execute: function execute() {
                  this.editor.applyValue(e, this.serializedValue), updateRow(this.row), trigger(self.onCellChange, {
                    row: activeRow,
                    cell: activeCell,
                    item: e
                  });
                },
                undo: function undo() {
                  this.editor.applyValue(e, this.prevSerializedValue), updateRow(this.row), trigger(self.onCellChange, {
                    row: activeRow,
                    cell: activeCell,
                    item: e
                  });
                }
              };
              options.editCommandHandler ? (makeActiveCellNormal(), options.editCommandHandler(e, t, n)) : (n.execute(), makeActiveCellNormal());
            } else {
              var r = {};
              currentEditor.applyValue(r, currentEditor.serializeValue()), makeActiveCellNormal(), trigger(self.onAddNewRow, {
                item: r,
                column: t
              });
            }

            return !getEditorLock().isActive();
          }

          return (0, _jquery2.default)(activeCellNode).removeClass("invalid"), (0, _jquery2.default)(activeCellNode).width(), (0, _jquery2.default)(activeCellNode).addClass("invalid"), trigger(self.onValidationError, {
            editor: currentEditor,
            cellNode: activeCellNode,
            validationResults: o,
            row: activeRow,
            cell: activeCell,
            column: t
          }), currentEditor.focus(), !1;
        }

        makeActiveCellNormal();
      }

      return !0;
    }

    function cancelCurrentEdit() {
      return makeActiveCellNormal(), !0;
    }

    function rowsToRanges(e) {
      for (var t = [], o = columns.length - 1, n = 0; n < e.length; n++) {
        t.push(new _slick2.default.Range(e[n], 0, e[n], o));
      }

      return t;
    }

    function getSelectedRows() {
      if (!selectionModel) throw "Selection model is not set";
      return selectedRows;
    }

    function setSelectedRows(e) {
      if (!selectionModel) throw "Selection model is not set";
      selectionModel.setSelectedRanges(rowsToRanges(e));
    }

    var defaults = {
      explicitInitialization: !1,
      rowHeight: 25,
      defaultColumnWidth: 80,
      enableAddRow: !1,
      leaveSpaceForNewRows: !1,
      editable: !1,
      autoEdit: !0,
      enableCellNavigation: !0,
      enableColumnReorder: !0,
      asyncEditorLoading: !1,
      asyncEditorLoadDelay: 100,
      forceFitColumns: !1,
      enableAsyncPostRender: !1,
      asyncPostRenderDelay: 50,
      autoHeight: !1,
      editorLock: _slick2.default.GlobalEditorLock,
      showHeaderRow: !1,
      headerRowHeight: 25,
      showFooterRow: !1,
      footerRowHeight: 25,
      showTopPanel: !1,
      topPanelHeight: 25,
      formatterFactory: null,
      editorFactory: null,
      cellFlashingCssClass: "flashing",
      selectedCellCssClass: "selected",
      multiSelect: !0,
      enableTextSelectionOnCells: !1,
      dataItemColumnValueExtractor: null,
      frozenBottom: !1,
      frozenColumn: -1,
      frozenRow: -1,
      fullWidthRows: !1,
      multiColumnSort: !1,
      defaultFormatter: defaultFormatter,
      forceSyncScrolling: !1,
      addNewRowCssClass: "new-row"
    },
        columnDefaults = {
      name: "",
      resizable: !0,
      sortable: !1,
      minWidth: 30,
      rerenderOnResize: !1,
      headerCssClass: null,
      defaultSortAsc: !0,
      focusable: !0,
      selectable: !0
    },
        th,
        h,
        ph,
        n,
        cj,
        page = 0,
        offset = 0,
        vScrollDir = 1,
        initialized = !1,
        $container,
        uid = "slickgrid_" + Math.round(1e6 * Math.random()),
        self = this,
        $focusSink,
        $focusSink2,
        $groupHeaders = (0, _jquery2.default)(),
        $headerScroller,
        $headers,
        $headerRow,
        $headerRowScroller,
        $headerRowSpacerL,
        $headerRowSpacerR,
        $footerRow,
        $footerRowScroller,
        $footerRowSpacerL,
        $footerRowSpacerR,
        $topPanelScroller,
        $topPanel,
        $viewport,
        $canvas,
        $style,
        $boundAncestors,
        treeColumns,
        stylesheet,
        columnCssRulesL,
        columnCssRulesR,
        viewportH,
        viewportW,
        canvasWidth,
        canvasWidthL,
        canvasWidthR,
        headersWidth,
        headersWidthL,
        headersWidthR,
        viewportHasHScroll,
        viewportHasVScroll,
        headerColumnWidthDiff = 0,
        headerColumnHeightDiff = 0,
        cellWidthDiff = 0,
        cellHeightDiff = 0,
        absoluteColumnMinWidth,
        hasFrozenRows = !1,
        frozenRowsHeight = 0,
        actualFrozenRow = -1,
        paneTopH = 0,
        paneBottomH = 0,
        viewportTopH = 0,
        viewportBottomH = 0,
        topPanelH = 0,
        headerRowH = 0,
        footerRowH = 0,
        tabbingDirection = 1,
        $activeCanvasNode,
        $activeViewportNode,
        activePosX,
        activeRow,
        activeCell,
        activeCellNode = null,
        currentEditor = null,
        serializedEditorValue,
        editController,
        rowsCache = {},
        renderedRows = 0,
        numVisibleRows = 0,
        prevScrollTop = 0,
        scrollTop = 0,
        lastRenderedScrollTop = 0,
        lastRenderedScrollLeft = 0,
        prevScrollLeft = 0,
        scrollLeft = 0,
        selectionModel,
        selectedRows = [],
        plugins = [],
        cellCssClasses = {},
        columnsById = {},
        sortColumns = [],
        columnPosLeft = [],
        columnPosRight = [],
        h_editorLoader = null,
        h_render = null,
        h_postrender = null,
        postProcessedRows = {},
        postProcessToRow = null,
        postProcessFromRow = null,
        counter_rows_rendered = 0,
        counter_rows_removed = 0,
        rowNodeFromLastMouseWheelEvent,
        zombieRowNodeFromLastMouseWheelEvent,
        $paneHeaderL,
        $paneHeaderR,
        $paneTopL,
        $paneTopR,
        $paneBottomL,
        $paneBottomR,
        $headerScrollerL,
        $headerScrollerR,
        $headerL,
        $headerR,
        $groupHeadersL,
        $groupHeadersR,
        $headerRowScrollerL,
        $headerRowScrollerR,
        $footerRowScrollerL,
        $footerRowScrollerR,
        $headerRowL,
        $headerRowR,
        $footerRowL,
        $footerRowR,
        $topPanelScrollerL,
        $topPanelScrollerR,
        $topPanelL,
        $topPanelR,
        $viewportTopL,
        $viewportTopR,
        $viewportBottomL,
        $viewportBottomR,
        $canvasTopL,
        $canvasTopR,
        $canvasBottomL,
        $canvasBottomR,
        $viewportScrollContainerX,
        $viewportScrollContainerY,
        $headerScrollContainer,
        $headerRowScrollContainer,
        $footerRowScrollContainer;
    this.debug = function () {
      var e = "";
      e += "\ncounter_rows_rendered:  " + counter_rows_rendered, e += "\ncounter_rows_removed:  " + counter_rows_removed, e += "\nrenderedRows:  " + renderedRows, e += "\nnumVisibleRows:  " + numVisibleRows, e += "\nmaxSupportedCssHeight:  " + maxSupportedCssHeight, e += "\nn(umber of pages):  " + n, e += "\n(current) page:  " + page, e += "\npage height (ph):  " + ph, e += "\nvScrollDir:  " + vScrollDir, alert(e);
    }, this.eval = function (expr) {
      return eval(expr);
    }, _jquery2.default.extend(this, {
      slickGridVersion: "2.1",
      onScroll: new _slick2.default.Event(),
      onSort: new _slick2.default.Event(),
      onHeaderMouseEnter: new _slick2.default.Event(),
      onHeaderMouseLeave: new _slick2.default.Event(),
      onHeaderContextMenu: new _slick2.default.Event(),
      onHeaderClick: new _slick2.default.Event(),
      onHeaderCellRendered: new _slick2.default.Event(),
      onBeforeHeaderCellDestroy: new _slick2.default.Event(),
      onHeaderRowCellRendered: new _slick2.default.Event(),
      onFooterRowCellRendered: new _slick2.default.Event(),
      onBeforeHeaderRowCellDestroy: new _slick2.default.Event(),
      onBeforeFooterRowCellDestroy: new _slick2.default.Event(),
      onMouseEnter: new _slick2.default.Event(),
      onMouseLeave: new _slick2.default.Event(),
      onClick: new _slick2.default.Event(),
      onDblClick: new _slick2.default.Event(),
      onContextMenu: new _slick2.default.Event(),
      onKeyDown: new _slick2.default.Event(),
      onAddNewRow: new _slick2.default.Event(),
      onValidationError: new _slick2.default.Event(),
      onViewportChanged: new _slick2.default.Event(),
      onColumnsReordered: new _slick2.default.Event(),
      onColumnsResized: new _slick2.default.Event(),
      onCellChange: new _slick2.default.Event(),
      onBeforeEditCell: new _slick2.default.Event(),
      onBeforeCellEditorDestroy: new _slick2.default.Event(),
      onBeforeDestroy: new _slick2.default.Event(),
      onActiveCellChanged: new _slick2.default.Event(),
      onActiveCellPositionChanged: new _slick2.default.Event(),
      onDragInit: new _slick2.default.Event(),
      onDragStart: new _slick2.default.Event(),
      onDrag: new _slick2.default.Event(),
      onDragEnd: new _slick2.default.Event(),
      onSelectedRowsChanged: new _slick2.default.Event(),
      onCellCssStylesChanged: new _slick2.default.Event(),
      registerPlugin: registerPlugin,
      unregisterPlugin: unregisterPlugin,
      getColumns: getColumns,
      setColumns: setColumns,
      getColumnIndex: getColumnIndex,
      updateColumnHeader: updateColumnHeader,
      setSortColumn: setSortColumn,
      setSortColumns: setSortColumns,
      getSortColumns: getSortColumns,
      autosizeColumns: autosizeColumns,
      getOptions: getOptions,
      setOptions: setOptions,
      getData: getData,
      getDataLength: getDataLength,
      getDataItem: getDataItem,
      setData: setData,
      getSelectionModel: getSelectionModel,
      setSelectionModel: setSelectionModel,
      getSelectedRows: getSelectedRows,
      setSelectedRows: setSelectedRows,
      getContainerNode: getContainerNode,
      render: render,
      invalidate: invalidate,
      invalidateRow: invalidateRow,
      invalidateRows: invalidateRows,
      invalidateAllRows: invalidateAllRows,
      updateCell: updateCell,
      updateRow: updateRow,
      getViewport: getVisibleRange,
      getRenderedRange: getRenderedRange,
      resizeCanvas: resizeCanvas,
      updateRowCount: updateRowCount,
      scrollRowIntoView: scrollRowIntoView,
      scrollRowToTop: scrollRowToTop,
      scrollCellIntoView: scrollCellIntoView,
      getCanvasNode: getCanvasNode,
      getCanvases: getCanvases,
      getActiveCanvasNode: getActiveCanvasNode,
      setActiveCanvasNode: setActiveCanvasNode,
      getViewportNode: getViewportNode,
      getActiveViewportNode: getActiveViewportNode,
      setActiveViewportNode: setActiveViewportNode,
      focus: setFocus,
      getCellFromPoint: getCellFromPoint,
      getCellFromEvent: getCellFromEvent,
      getActiveCell: getActiveCell,
      setActiveCell: setActiveCell,
      getActiveCellNode: getActiveCellNode,
      getActiveCellPosition: getActiveCellPosition,
      resetActiveCell: resetActiveCell,
      editActiveCell: makeActiveCellEditable,
      getCellEditor: getCellEditor,
      getCellNode: getCellNode,
      getCellNodeBox: getCellNodeBox,
      canCellBeSelected: canCellBeSelected,
      canCellBeActive: canCellBeActive,
      navigatePrev: navigatePrev,
      navigateNext: navigateNext,
      navigateUp: navigateUp,
      navigateDown: navigateDown,
      navigateLeft: navigateLeft,
      navigateRight: navigateRight,
      navigatePageUp: navigatePageUp,
      navigatePageDown: navigatePageDown,
      gotoCell: gotoCell,
      getTopPanel: getTopPanel,
      setTopPanelVisibility: setTopPanelVisibility,
      setHeaderRowVisibility: setHeaderRowVisibility,
      getHeaderRow: getHeaderRow,
      getHeaderRowColumn: getHeaderRowColumn,
      setFooterRowVisibility: setFooterRowVisibility,
      getFooterRow: getFooterRow,
      getFooterRowColumn: getFooterRowColumn,
      getGridPosition: getGridPosition,
      flashCell: flashCell,
      addCellCssStyles: addCellCssStyles,
      setCellCssStyles: setCellCssStyles,
      removeCellCssStyles: removeCellCssStyles,
      getCellCssStyles: getCellCssStyles,
      getFrozenRowOffset: getFrozenRowOffset,
      init: finishInitialization,
      destroy: destroy,
      getEditorLock: getEditorLock,
      getEditController: getEditController
    }), init();
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var _jquery = __webpack_require__(2),
      _jquery2 = _interopRequireDefault(_jquery),
      _interact = __webpack_require__(5),
      _interact2 = _interopRequireDefault(_interact),
      _slick = __webpack_require__(1),
      _slick2 = _interopRequireDefault(_slick);

  _slick2.default.FrozenGrid = SlickGrid, exports.default = SlickGrid;
  var scrollbarDimensions, maxSupportedCssHeight;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t() {
      fe = !0;
    }

    function o() {
      fe = !1, oe();
    }

    function n(e) {
      we = e;
    }

    function r(e) {
      Re = e;
    }

    function i(e) {
      e = e || 0;

      for (var t = void 0, o = e, n = ae.length; o < n; o++) {
        if (t = ae[o][le], void 0 === t) throw "Each data element must implement a unique 'id' property";
        de[t] = o;
      }
    }

    function s() {
      for (var e = void 0, t = 0, o = ae.length; t < o; t++) {
        if (e = ae[t][le], void 0 === e || de[e] !== t) throw "Each data element must implement a unique 'id' property";
      }
    }

    function l() {
      return ae;
    }

    function a(e, t) {
      void 0 !== t && (le = t), ae = ye = e, de = {}, i(), s(), oe();
    }

    function c(e) {
      void 0 != e.pageSize && (ke = e.pageSize, De = ke ? Math.min(De, Math.max(0, Math.ceil(ze / ke) - 1)) : 0), void 0 != e.pageNum && (De = Math.min(e.pageNum, Math.max(0, Math.ceil(ze / ke) - 1))), Me.notify(u(), null, ie), oe();
    }

    function u() {
      var e = ke ? Math.max(1, Math.ceil(ze / ke)) : 1;
      return {
        pageSize: ke,
        pageNum: De,
        totalRows: ze,
        totalPages: e,
        dataView: ie
      };
    }

    function p(e, t) {
      ge = t, me = e, ve = null, t === !1 && ae.reverse(), ae.sort(e), t === !1 && ae.reverse(), de = {}, i(), oe();
    }

    function f(e, t) {
      ge = t, ve = e, me = null;
      var o = Object.prototype.toString;
      Object.prototype.toString = "function" == typeof e ? e : function () {
        return this[e];
      }, t === !1 && ae.reverse(), ae.sort(), Object.prototype.toString = o, t === !1 && ae.reverse(), de = {}, i(), oe();
    }

    function g() {
      me ? p(me, ge) : ve && f(ve, ge);
    }

    function v(t) {
      he = t, e.inlineFilters && (be = K(), Se = U()), oe();
    }

    function m() {
      return _e;
    }

    function w(t) {
      e.groupItemMetadataProvider || (e.groupItemMetadataProvider = GroupItemMetadataProvider()), $e = [], Pe = [], t = t || [], _e = t instanceof Array ? t : [t];

      for (var o = 0; o < _e.length; o++) {
        var n = _e[o] = h.default.extend(!0, {}, Ee, _e[o]);
        n.getterIsAFn = "function" == typeof n.getter, n.compiledAccumulators = [];

        for (var r = n.aggregators.length; r--;) {
          n.compiledAccumulators[r] = G(n.aggregators[r]);
        }

        Pe[o] = {};
      }

      oe();
    }

    function C(e, t, o) {
      return null == e ? void w([]) : void w({
        getter: e,
        formatter: t,
        comparer: o
      });
    }

    function R(e, t) {
      if (!_e.length) throw new Error("At least one grouping must be specified before calling setAggregators().");
      _e[0].aggregators = e, _e[0].aggregateCollapsed = t, w(_e);
    }

    function y(e) {
      return ae[e];
    }

    function b(e) {
      return de[e];
    }

    function S() {
      if (!ue) {
        ue = {};

        for (var e = 0, t = ce.length; e < t; e++) {
          ue[ce[e][le]] = e;
        }
      }
    }

    function x(e) {
      return S(), ue[e];
    }

    function E(e) {
      return ae[de[e]];
    }

    function _(e) {
      var t = [];
      S();

      for (var o = 0, n = e.length; o < n; o++) {
        var r = ue[e[o]];
        null != r && (t[t.length] = r);
      }

      return t;
    }

    function $(e) {
      for (var t = [], o = 0, n = e.length; o < n; o++) {
        e[o] < ce.length && (t[t.length] = ce[e[o]][le]);
      }

      return t;
    }

    function P(e, t) {
      if (void 0 === de[e] || e !== t[le]) throw "Invalid or non-matching id";
      ae[de[e]] = t, pe || (pe = {}), pe[e] = !0, oe();
    }

    function T(e, t) {
      ae.splice(e, 0, t), i(e), oe();
    }

    function k(e) {
      ae.push(e), i(ae.length - 1), oe();
    }

    function D(e) {
      var t = de[e];
      if (void 0 === t) throw "Invalid id";
      delete de[e], ae.splice(t, 1), i(t), oe();
    }

    function z() {
      return ce.length;
    }

    function L(e) {
      var t = ce[e];

      if (t && t.__group && t.totals && !t.totals.initialized) {
        var o = _e[t.level];
        o.displayTotalsRow || (B(t.totals), t.title = o.formatter ? o.formatter(t) : t.value);
      } else t && t.__groupTotals && !t.initialized && B(t);

      return t;
    }

    function F(t) {
      var o = ce[t];
      return void 0 === o ? null : o.__group ? e.groupItemMetadataProvider.getGroupRowMetadata(o) : o.__groupTotals ? e.groupItemMetadataProvider.getTotalsRowMetadata(o) : null;
    }

    function M(e, t) {
      if (null == e) for (var o = 0; o < _e.length; o++) {
        Pe[o] = {}, _e[o].collapsed = t;
      } else Pe[e] = {}, _e[e].collapsed = t;
      oe();
    }

    function H(e) {
      M(e, !0);
    }

    function I(e) {
      M(e, !1);
    }

    function A(e, t, o) {
      Pe[e][t] = _e[e].collapsed ^ o, oe();
    }

    function N(e) {
      var t = Array.prototype.slice.call(arguments),
          o = t[0];
      1 == t.length && o.indexOf(Te) != -1 ? A(o.split(Te).length - 1, o, !0) : A(t.length - 1, t.join(Te), !0);
    }

    function W(e) {
      var t = Array.prototype.slice.call(arguments),
          o = t[0];
      1 == t.length && o.indexOf(Te) != -1 ? A(o.split(Te).length - 1, o, !1) : A(t.length - 1, t.join(Te), !1);
    }

    function j() {
      return $e;
    }

    function q(e, t) {
      for (var o = void 0, n = void 0, r = [], i = {}, s = void 0, l = t ? t.level + 1 : 0, a = _e[l], c = 0, u = a.predefinedValues.length; c < u; c++) {
        n = a.predefinedValues[c], o = i[n], o || (o = new d.default.Group(), o.value = n, o.level = l, o.groupingKey = (t ? t.groupingKey + Te : "") + n, r[r.length] = o, i[n] = o);
      }

      for (var h = 0, p = e.length; h < p; h++) {
        s = e[h], n = a.getterIsAFn ? a.getter(s) : s[a.getter], o = i[n], o || (o = new d.default.Group(), o.value = n, o.level = l, o.groupingKey = (t ? t.groupingKey + Te : "") + n, r[r.length] = o, i[n] = o), o.rows[o.count++] = s;
      }

      if (l < _e.length - 1) for (var f = 0; f < r.length; f++) {
        o = r[f], o.groups = q(o.rows, o);
      }
      return r.sort(_e[l].comparer), r;
    }

    function B(e) {
      var t = e.group,
          o = _e[t.level],
          n = t.level == _e.length,
          r = void 0,
          i = o.aggregators.length;
      if (!n && o.aggregateChildGroups) for (var s = t.groups.length; s--;) {
        t.groups[s].totals.initialized || B(t.groups[s].totals);
      }

      for (; i--;) {
        r = o.aggregators[i], r.init(), !n && o.aggregateChildGroups ? o.compiledAccumulators[i].call(r, t.groups) : o.compiledAccumulators[i].call(r, t.rows), r.storeResult(e);
      }

      e.initialized = !0;
    }

    function V(e) {
      var t = _e[e.level],
          o = new d.default.GroupTotals();
      o.group = e, e.totals = o, t.lazyTotalsCalculation || B(o);
    }

    function O(e, t) {
      t = t || 0;

      for (var o = _e[t], n = o.collapsed, r = Pe[t], i = e.length, s = void 0; i--;) {
        s = e[i], s.collapsed && !o.aggregateCollapsed || (s.groups && O(s.groups, t + 1), o.aggregators.length && (o.aggregateEmpty || s.rows.length || s.groups && s.groups.length) && V(s), s.collapsed = n ^ r[s.groupingKey], s.title = o.formatter ? o.formatter(s) : s.value);
      }
    }

    function X(e, t) {
      t = t || 0;

      for (var o = _e[t], n = [], r = void 0, i = 0, s = void 0, l = 0, a = e.length; l < a; l++) {
        if (s = e[l], n[i++] = s, !s.collapsed) {
          r = s.groups ? X(s.groups, t + 1) : s.rows;

          for (var c = 0, d = r.length; c < d; c++) {
            n[i++] = r[c];
          }
        }

        s.totals && o.displayTotalsRow && (!s.collapsed || o.aggregateCollapsed) && (n[i++] = s.totals);
      }

      return n;
    }

    function Y(e) {
      var t = /^function[^(]*\(([^)]*)\)\s*{([\s\S]*)}$/,
          o = e.toString().match(t);
      return {
        params: o[1].split(","),
        body: o[2]
      };
    }

    function G(e) {
      var t = Y(e.accumulate),
          o = new Function("_items", "for (let " + t.params[0] + ", _i=0, _il=_items.length; _i<_il; _i++) {" + t.params[0] + " = _items[_i]; " + t.body + "}");
      return o.displayName = "compiledAccumulatorLoop", o;
    }

    function K() {
      var e = Y(he),
          t = "{ continue _coreloop; }$1",
          o = "{ _retval[_idx++] = $item$; continue _coreloop; }$1",
          n = e.body.replace(/return false\s*([;}]|\}|$)/gi, t).replace(/return!1([;}]|\}|$)/gi, t).replace(/return true\s*([;}]|\}|$)/gi, o).replace(/return!0([;}]|\}|$)/gi, o).replace(/return ([^;}]+?)\s*([;}]|$)/gi, "{ if ($1) { _retval[_idx++] = $item$; }; continue _coreloop; }$2"),
          r = ["let _retval = [], _idx = 0; ", "let $item$, $args$ = _args; ", "_coreloop: ", "for (let _i = 0, _il = _items.length; _i < _il; _i++) { ", "$item$ = _items[_i]; ", "$filter$; ", "} ", "return _retval; "].join("");
      r = r.replace(/\$filter\$/gi, n), r = r.replace(/\$item\$/gi, e.params[0]), r = r.replace(/\$args\$/gi, e.params[1]);
      var i = new Function("_items,_args", r);
      return i.displayName = "compiledFilter", i;
    }

    function U() {
      var e = Y(he),
          t = "{ continue _coreloop; }$1",
          o = "{ _cache[_i] = true;_retval[_idx++] = $item$; continue _coreloop; }$1",
          n = e.body.replace(/return false\s*([;}]|\}|$)/gi, t).replace(/return!1([;}]|\}|$)/gi, t).replace(/return true\s*([;}]|\}|$)/gi, o).replace(/return!0([;}]|\}|$)/gi, o).replace(/return ([^;}]+?)\s*([;}]|$)/gi, "{ if ((_cache[_i] = $1)) { _retval[_idx++] = $item$; }; continue _coreloop; }$2"),
          r = ["let _retval = [], _idx = 0; ", "let $item$, $args$ = _args; ", "_coreloop: ", "for (let _i = 0, _il = _items.length; _i < _il; _i++) { ", "$item$ = _items[_i]; ", "if (_cache[_i]) { ", "_retval[_idx++] = $item$; ", "continue _coreloop; ", "} ", "$filter$; ", "} ", "return _retval; "].join("");
      r = r.replace(/\$filter\$/gi, n), r = r.replace(/\$item\$/gi, e.params[0]), r = r.replace(/\$args\$/gi, e.params[1]);
      var i = new Function("_items,_args,_cache", r);
      return i.displayName = "compiledFilterWithCaching", i;
    }

    function Q(e, t) {
      for (var o = [], n = 0, r = 0, i = e.length; r < i; r++) {
        he(e[r], t) && (o[n++] = e[r]);
      }

      return o;
    }

    function J(e, t, o) {
      for (var n = [], r = 0, i = void 0, s = 0, l = e.length; s < l; s++) {
        i = e[s], o[s] ? n[r++] = i : he(i, t) && (n[r++] = i, o[s] = !0);
      }

      return n;
    }

    function Z(t) {
      if (he) {
        var o = e.inlineFilters ? be : Q,
            n = e.inlineFilters ? Se : J;
        we.isFilterNarrowing ? ye = o(ye, Re) : we.isFilterExpanding ? ye = n(t, Re, xe) : we.isFilterUnchanged || (ye = o(t, Re));
      } else ye = ke ? t : t.concat();

      var r = void 0;
      return ke ? (ye.length < De * ke && (De = Math.floor(ye.length / ke)), r = ye.slice(ke * De, ke * De + ke)) : r = ye, {
        totalRows: ye.length,
        rows: r
      };
    }

    function ee(e, t) {
      var o = void 0,
          n = void 0,
          r = void 0,
          i = [],
          s = 0,
          l = t.length;
      we && we.ignoreDiffsBefore && (s = Math.max(0, Math.min(t.length, we.ignoreDiffsBefore))), we && we.ignoreDiffsAfter && (l = Math.min(t.length, Math.max(0, we.ignoreDiffsAfter)));

      for (var a = s, c = e.length; a < l; a++) {
        a >= c ? i[i.length] = a : (o = t[a], n = e[a], (_e.length && (r = o.__nonDataRow || n.__nonDataRow) && o.__group !== n.__group || o.__group && !o.equals(n) || r && (o.__groupTotals || n.__groupTotals) || o[le] != n[le] || pe && pe[o[le]]) && (i[i.length] = a));
      }

      return i;
    }

    function te(e) {
      ue = null, we.isFilterNarrowing == Ce.isFilterNarrowing && we.isFilterExpanding == Ce.isFilterExpanding || (xe = []);
      var t = Z(e);
      ze = t.totalRows;
      var o = t.rows;
      $e = [], _e.length && ($e = q(o), $e.length && (O($e), o = X($e)));
      var n = ee(ce, o);
      return ce = o, n;
    }

    function oe() {
      if (!fe) {
        var e = ce.length,
            t = ze,
            o = te(ae, he);
        ke && ze < De * ke && (De = Math.max(0, Math.ceil(ze / ke) - 1), o = te(ae, he)), pe = null, Ce = we, we = {}, t !== ze && Me.notify(u(), null, ie), e !== ce.length && Le.notify({
          previous: e,
          current: ce.length,
          dataView: ie
        }, null, ie), o.length > 0 && Fe.notify({
          rows: o,
          dataView: ie
        }, null, ie);
      }
    }

    function ne(e, t, o) {
      function n(t) {
        l.join(",") != t.join(",") && (l = t, a.notify({
          grid: e,
          ids: l,
          dataView: i
        }, new d.default.EventData(), i));
      }

      function r() {
        if (l.length > 0) {
          s = !0;
          var o = i.mapIdsToRows(l);
          t || n(i.mapRowsToIds(o)), e.setSelectedRows(o), s = !1;
        }
      }

      var i = this,
          s = void 0,
          l = i.mapRowsToIds(e.getSelectedRows()),
          a = new d.default.Event();
      return e.onSelectedRowsChanged.subscribe(function (t, r) {
        if (!s) {
          var a = i.mapRowsToIds(e.getSelectedRows());

          if (o && e.getOptions().multiSelect) {
            var c = h.default.grep(l, function (e) {
              return void 0 === i.getRowById(e);
            });
            n(c.concat(a));
          } else n(a);
        }
      }), this.onRowsChanged.subscribe(r), this.onRowCountChanged.subscribe(r), a;
    }

    function re(e, t) {
      function o(e) {
        r = {};

        for (var t in e) {
          var o = ce[t][le];
          r[o] = e[t];
        }
      }

      function n() {
        if (r) {
          i = !0, S();
          var o = {};

          for (var n in r) {
            var s = ue[n];
            void 0 != s && (o[s] = r[n]);
          }

          e.setCellCssStyles(t, o), i = !1;
        }
      }

      var r = void 0,
          i = void 0;
      o(e.getCellCssStyles(t)), e.onCellCssStylesChanged.subscribe(function (e, n) {
        i || t == n.key && n.hash && o(n.hash);
      }), this.onRowsChanged.subscribe(n), this.onRowCountChanged.subscribe(n);
    }

    var ie = this,
        se = {
      groupItemMetadataProvider: null,
      inlineFilters: !1
    },
        le = "id",
        ae = [],
        ce = [],
        de = {},
        ue = null,
        he = null,
        pe = null,
        fe = !1,
        ge = !0,
        ve = void 0,
        me = void 0,
        we = {},
        Ce = {},
        Re = void 0,
        ye = [],
        be = void 0,
        Se = void 0,
        xe = [],
        Ee = {
      getter: null,
      formatter: null,
      comparer: function comparer(e, t) {
        return e.value === t.value ? 0 : e.value > t.value ? 1 : -1;
      },
      predefinedValues: [],
      aggregators: [],
      aggregateEmpty: !1,
      aggregateCollapsed: !1,
      aggregateChildGroups: !1,
      collapsed: !1,
      displayTotalsRow: !0,
      lazyTotalsCalculation: !1
    },
        _e = [],
        $e = [],
        Pe = [],
        Te = ":|:",
        ke = 0,
        De = 0,
        ze = 0,
        Le = new d.default.Event(),
        Fe = new d.default.Event(),
        Me = new d.default.Event();
    e = h.default.extend(!0, {}, se, e), h.default.extend(this, {
      beginUpdate: t,
      endUpdate: o,
      setPagingOptions: c,
      getPagingInfo: u,
      getItems: l,
      setItems: a,
      setFilter: v,
      sort: p,
      fastSort: f,
      reSort: g,
      setGrouping: w,
      getGrouping: m,
      groupBy: C,
      setAggregators: R,
      collapseAllGroups: H,
      expandAllGroups: I,
      collapseGroup: N,
      expandGroup: W,
      getGroups: j,
      getIdxById: b,
      getRowById: x,
      getItemById: E,
      getItemByIdx: y,
      mapRowsToIds: $,
      mapIdsToRows: _,
      setRefreshHints: n,
      setFilterArgs: r,
      refresh: oe,
      updateItem: P,
      insertItem: T,
      addItem: k,
      deleteItem: D,
      syncGridSelection: ne,
      syncGridCellCssStyles: re,
      getLength: z,
      getItem: L,
      getItemMetadata: F,
      onRowCountChanged: Le,
      onRowsChanged: Fe,
      onPagingInfoChanged: Me
    });
  }

  function i(e) {
    this.field_ = e, this.init = function () {
      this.count_ = 0, this.nonNullCount_ = 0, this.sum_ = 0;
    }, this.accumulate = function (e) {
      var t = e[this.field_];
      this.count_++, null == t || "" === t || isNaN(t) || (this.nonNullCount_++, this.sum_ += parseFloat(t));
    }, this.storeResult = function (e) {
      e.avg || (e.avg = {}), 0 != this.nonNullCount_ && (e.avg[this.field_] = this.sum_ / this.nonNullCount_);
    };
  }

  function s(e) {
    this.field_ = e, this.init = function () {
      this.min_ = null;
    }, this.accumulate = function (e) {
      var t = e[this.field_];
      null == t || "" === t || isNaN(t) || (null == this.min_ || t < this.min_) && (this.min_ = t);
    }, this.storeResult = function (e) {
      e.min || (e.min = {}), e.min[this.field_] = this.min_;
    };
  }

  function l(e) {
    this.field_ = e, this.init = function () {
      this.max_ = null;
    }, this.accumulate = function (e) {
      var t = e[this.field_];
      null == t || "" === t || isNaN(t) || (null == this.max_ || t > this.max_) && (this.max_ = t);
    }, this.storeResult = function (e) {
      e.max || (e.max = {}), e.max[this.field_] = this.max_;
    };
  }

  function a(e) {
    this.field_ = e, this.init = function () {
      this.sum_ = null;
    }, this.accumulate = function (e) {
      var t = e[this.field_];
      null == t || "" === t || isNaN(t) || (this.sum_ += parseFloat(t));
    }, this.storeResult = function (e) {
      e.sum || (e.sum = {}), e.sum[this.field_] = this.sum_;
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c = o(1),
      d = n(c),
      u = o(2),
      h = n(u),
      p = o(31),
      f = n(p),
      g = {
    Avg: i,
    Min: s,
    Max: l,
    Sum: a
  },
      v = {
    DataView: r,
    GroupMetaDataProvider: f.default,
    Aggregators: g
  };
  t.default = v;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    var t = void 0,
        o = void 0;
    this.init = function () {
      t = (0, v.default)("<INPUT type=text class='editor-text' />").appendTo(e.container).bind("keydown.nav", function (e) {
        e.keyCode !== m.LEFT && e.keyCode !== m.RIGHT || e.stopImmediatePropagation();
      }).focus().select();
    }, this.destroy = function () {
      t.remove();
    }, this.focus = function () {
      t.focus();
    }, this.getValue = function () {
      return t.val();
    }, this.setValue = function (e) {
      t.val(e);
    }, this.loadValue = function (n) {
      o = n[e.column.field] || "", t.val(o), t[0].defaultValue = o, t.select();
    }, this.serializeValue = function () {
      return t.val();
    }, this.applyValue = function (t, o) {
      t[e.column.field] = o;
    }, this.isValueChanged = function () {
      return !("" == t.val() && null == o) && t.val() != o;
    }, this.validate = function () {
      var o = !0,
          n = null;

      if (e.column.validator) {
        var r = e.column.validator(t.val(), e);
        o = r.valid, n = r.msg;
      }

      return {
        valid: !0,
        msg: null
      };
    }, this.init();
  }

  function i(e) {
    var t = void 0,
        o = void 0;
    this.init = function () {
      t = (0, v.default)("<INPUT type=text class='editor-text' />"), t.bind("keydown.nav", function (e) {
        e.keyCode !== m.LEFT && e.keyCode !== m.RIGHT || e.stopImmediatePropagation();
      }), t.appendTo(e.container), t.focus().select();
    }, this.destroy = function () {
      t.remove();
    }, this.focus = function () {
      t.focus();
    }, this.loadValue = function (n) {
      o = n[e.column.field], t.val(o), t[0].defaultValue = o, t.select();
    }, this.serializeValue = function () {
      return parseInt(t.val(), 10) || 0;
    }, this.applyValue = function (t, o) {
      t[e.column.field] = o;
    }, this.isValueChanged = function () {
      return !("" == t.val() && null == o) && t.val() != o;
    }, this.validate = function () {
      if (isNaN(t.val())) return {
        valid: !1,
        msg: "Please enter a valid integer"
      };

      if (e.column.validator) {
        var o = e.column.validator(t.val());
        if (!o.valid) return o;
      }

      return {
        valid: !0,
        msg: null
      };
    }, this.init();
  }

  function s(e) {
    function t() {
      var t = e.column.editorFixedDecimalPlaces;
      return "undefined" == typeof t && (t = s.DefaultDecimalPlaces), t || 0 === t ? t : null;
    }

    var o = void 0,
        n = void 0;
    this.init = function () {
      o = (0, v.default)("<INPUT type=text class='editor-text' />"), o.bind("keydown.nav", function (e) {
        e.keyCode !== m.LEFT && e.keyCode !== m.RIGHT || e.stopImmediatePropagation();
      }), o.appendTo(e.container), o.focus().select();
    }, this.destroy = function () {
      o.remove();
    }, this.focus = function () {
      o.focus();
    }, this.loadValue = function (r) {
      n = r[e.column.field];
      var i = t();
      null !== i && (n || 0 === n) && n.toFixed && (n = n.toFixed(i)), o.val(n), o[0].defaultValue = n, o.select();
    }, this.serializeValue = function () {
      var e = parseFloat(o.val()) || 0,
          n = t();
      return null !== n && (e || 0 === e) && e.toFixed && (e = parseFloat(e.toFixed(n))), e;
    }, this.applyValue = function (t, o) {
      t[e.column.field] = o;
    }, this.isValueChanged = function () {
      return !("" == o.val() && null == n) && o.val() != n;
    }, this.validate = function () {
      if (isNaN(o.val())) return {
        valid: !1,
        msg: "Please enter a valid number"
      };

      if (e.column.validator) {
        var t = e.column.validator(o.val(), e);
        if (!t.valid) return t;
      }

      return {
        valid: !0,
        msg: null
      };
    }, this.init();
  }

  function l(e) {
    var t = void 0,
        o = void 0,
        n = void 0,
        r = e.column.options && e.column.options.date ? e.column.options.date : {};
    this.init = function () {
      n = r.defaultDate = e.item[e.column.field], t = (0, v.default)('<input type=text data-default-date="' + n + '" class="editor-text" />'), t.appendTo(e.container), t.focus().val(n).select(), o = (0, f.default)(t[0], r);
    }, this.destroy = function () {
      o.destroy(), t.remove();
    }, this.show = function () {
      o.open(), o.positionCalendar();
    }, this.hide = function () {
      o.close();
    }, this.position = function (e) {
      o.positionCalendar();
    }, this.focus = function () {
      t.focus();
    }, this.loadValue = function (o) {
      n = o[e.column.field], t.val(n), t.select();
    }, this.serializeValue = function () {
      return t.val();
    }, this.applyValue = function (t, o) {
      t[e.column.field] = o;
    }, this.isValueChanged = function () {
      return !("" == t.val() && null == n) && t.val() != n;
    }, this.validate = function () {
      if (e.column.validator) {
        var o = e.column.validator(t.val(), e);
        if (!o.valid) return o;
      }

      return {
        valid: !0,
        msg: null
      };
    }, this.init();
  }

  function a(e) {
    var t = void 0,
        o = void 0;
    this.init = function () {
      t = (0, v.default)("<select tabIndex='0' class='editor-yesno'><option value='yes'>Yes</option><option value='no'>No</option></select>"), t.appendTo(e.container), t.focus();
    }, this.destroy = function () {
      t.remove();
    }, this.focus = function () {
      t.focus();
    }, this.loadValue = function (n) {
      t.val((o = n[e.column.field]) ? "yes" : "no"), t.select();
    }, this.serializeValue = function () {
      return "yes" == t.val();
    }, this.applyValue = function (t, o) {
      t[e.column.field] = o;
    }, this.isValueChanged = function () {
      return t.val() != o;
    }, this.validate = function () {
      var o = !0,
          n = null;

      if (e.column.validator) {
        var r = e.column.validator(t.val(), e);
        o = r.valid, n = r.msg;
      }

      return {
        valid: !0,
        msg: null
      };
    }, this.init();
  }

  function c(e) {
    var t = void 0,
        o = void 0;
    this.init = function () {
      t = (0, v.default)("<INPUT type=checkbox value='true' class='editor-checkbox' hideFocus>"), t.appendTo(e.container), t.focus();
    }, this.destroy = function () {
      t.remove();
    }, this.focus = function () {
      t.focus();
    }, this.loadValue = function (n) {
      o = !!n[e.column.field], o ? t.prop("checked", !0) : t.prop("checked", !1);
    }, this.serializeValue = function () {
      return t.prop("checked");
    }, this.applyValue = function (t, o) {
      t[e.column.field] = o;
    }, this.isValueChanged = function () {
      return this.serializeValue() !== o;
    }, this.validate = function () {
      var o = !0,
          n = null;

      if (e.column.validator) {
        var r = e.column.validator(t.val(), e);
        o = r.valid, n = r.msg;
      }

      return {
        valid: !0,
        msg: null
      };
    }, this.init();
  }

  function d(e) {
    var t = void 0,
        o = void 0,
        n = void 0,
        r = this;
    this.init = function () {
      var n = (0, v.default)("body");
      o = (0, v.default)("<div class='slick-large-editor-text' />").appendTo(n), t = (0, v.default)("<textarea hidefocus rows=5 />").appendTo(o), (0, v.default)("<div><button>Save</button> <button>Cancel</button></div>").appendTo(o), o.find("button:first").bind("click", this.save), o.find("button:last").bind("click", this.cancel), t.bind("keydown", this.handleKeyDown), r.position(e.position), t.focus().select();
    }, this.handleKeyDown = function (t) {
      t.which == m.ENTER && t.ctrlKey ? r.save() : t.which == m.ESCAPE ? (t.preventDefault(), r.cancel()) : t.which == m.TAB && t.shiftKey ? (t.preventDefault(), e.grid.navigatePrev()) : t.which == m.TAB && (t.preventDefault(), e.grid.navigateNext());
    }, this.save = function () {
      e.commitChanges();
    }, this.cancel = function () {
      t.val(n), e.cancelChanges();
    }, this.hide = function () {
      o.hide();
    }, this.show = function () {
      o.show();
    }, this.position = function (e) {
      o.css("top", e.top - 5).css("left", e.left - 5);
    }, this.destroy = function () {
      o.remove();
    }, this.focus = function () {
      t.focus();
    }, this.loadValue = function (o) {
      t.val(n = o[e.column.field]), t.select();
    }, this.serializeValue = function () {
      return t.val();
    }, this.applyValue = function (t, o) {
      t[e.column.field] = o;
    }, this.isValueChanged = function () {
      return !("" == t.val() && null == n) && t.val() != n;
    }, this.validate = function () {
      var t = !0,
          o = null;

      if (e.column.validator) {
        var n = e.column.validator($select.val(), e);
        t = n.valid, o = n.msg;
      }

      return {
        valid: !0,
        msg: null
      };
    }, this.init();
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u = o(1),
      h = n(u),
      p = o(32),
      f = n(p),
      g = o(2),
      v = n(g),
      m = h.default.keyCode,
      w = {
    Text: r,
    Integer: i,
    Float: s,
    Date: l,
    YesNoSelect: a,
    Checkbox: c,
    LongText: d
  };
  h.default.Editors = w, t.default = w, s.DefaultDecimalPlaces = null;
}, function (e, t) {
  "use strict";

  function o(e, t, o, n, r) {
    return null == o || "" === o ? "-" : o < 50 ? "<span style='color:red;font-weight:bold;'>" + o + "%</span>" : "<span style='color:green'>" + o + "%</span>";
  }

  function n(e, t, o, n, r) {
    if (null == o || "" === o) return "";
    var i = void 0;
    return i = o < 30 ? "red" : o < 70 ? "silver" : "green", "<span class='percent-complete-bar' style='background:" + i + ";width:" + o + "%'></span>";
  }

  function r(e, t, o, n, r) {
    return o ? "Yes" : "No";
  }

  function i(e, t, o, n, r) {
    return o ? "✔" : "";
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = {
    PercentComplete: o,
    PercentCompleteBar: n,
    YesNo: r,
    Checkmark: i
  };
}, function (module, exports, __webpack_require__) {
  "use strict";

  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function SlickGrid(container, data, columns, options) {
    function init() {
      if ($container = (0, _jquery2.default)(container), $container.length < 1) throw new Error("SlickGrid requires a valid container, " + container + " does not exist in the DOM.");
      cacheCssForHiddenInit(), maxSupportedCssHeight = maxSupportedCssHeight || getMaxSupportedCssHeight(), scrollbarDimensions = scrollbarDimensions || measureScrollbar(), options = _jquery2.default.extend({}, defaults, options), validateAndEnforceOptions(), columnDefaults.width = options.defaultColumnWidth, columnsById = {};

      for (var e = 0; e < columns.length; e++) {
        var t = columns[e] = _jquery2.default.extend({}, columnDefaults, columns[e]);

        columnsById[t.id] = e, t.minWidth && t.width < t.minWidth && (t.width = t.minWidth), t.maxWidth && t.width > t.maxWidth && (t.width = t.maxWidth);
      }

      editController = {
        commitCurrentEdit: commitCurrentEdit,
        cancelCurrentEdit: cancelCurrentEdit
      }, $container.empty().css("overflow", "hidden").css("outline", 0).addClass(uid).addClass("ui-widget"), /relative|absolute|fixed/.test($container.css("position")) || $container.css("position", "relative"), $focusSink = (0, _jquery2.default)("<div tabIndex='0' hideFocus style='position:fixed;width:0;height:0;top:0;left:0;outline:0;'></div>").appendTo($container), $headerScroller = (0, _jquery2.default)("<div class='slick-header ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($container), $headers = (0, _jquery2.default)("<div class='slick-header-columns' />").appendTo($headerScroller), $headers.width(getHeadersWidth()), $headerRowScroller = (0, _jquery2.default)("<div class='slick-headerrow ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($container), $headerRow = (0, _jquery2.default)("<div class='slick-headerrow-columns' />").appendTo($headerRowScroller), $headerRowSpacer = (0, _jquery2.default)("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").css("width", getCanvasWidth() + scrollbarDimensions.width + "px").appendTo($headerRowScroller), $topPanelScroller = (0, _jquery2.default)("<div class='slick-top-panel-scroller ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($container), $topPanel = (0, _jquery2.default)("<div class='slick-top-panel' style='width:10000px' />").appendTo($topPanelScroller), options.showTopPanel || $topPanelScroller.hide(), options.showHeaderRow || $headerRowScroller.hide(), $viewport = (0, _jquery2.default)("<div class='slick-viewport' style='width:100%;overflow:auto;outline:0;position:relative;;'>").appendTo($container), $viewport.css("overflow-y", options.autoHeight ? "hidden" : "auto"), $canvas = (0, _jquery2.default)("<div class='grid-canvas' />").appendTo($viewport), options.createFooterRow && ($footerRowScroller = (0, _jquery2.default)("<div class='slick-footerrow ui-state-default' style='overflow:hidden;position:relative;' />").appendTo($container), $footerRow = (0, _jquery2.default)("<div class='slick-footerrow-columns' />").appendTo($footerRowScroller), $footerRowSpacer = (0, _jquery2.default)("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>").css("width", getCanvasWidth() + scrollbarDimensions.width + "px").appendTo($footerRowScroller), options.showFooterRow || $footerRowScroller.hide()), $focusSink2 = $focusSink.clone().appendTo($container), options.explicitInitialization || finishInitialization();
    }

    function finishInitialization() {
      initialized || (initialized = !0, viewportW = parseFloat(_jquery2.default.css($container[0], "width", !0)), measureCellPaddingAndBorder(), disableSelection($headers), options.enableTextSelectionOnCells || $viewport.bind("selectstart.ui", function (e) {
        return (0, _jquery2.default)(e.target).is("input,textarea");
      }), updateColumnCaches(), createColumnHeaders(), setupColumnSort(), createCssRules(), resizeCanvas(), bindAncestorScrollEvents(), $container.bind("resize.slickgrid", resizeCanvas), $viewport.bind("scroll", handleScroll), $headerScroller.bind("contextmenu", handleHeaderContextMenu).bind("click", handleHeaderClick).delegate(".slick-header-column", "mouseenter", handleHeaderMouseEnter).delegate(".slick-header-column", "mouseleave", handleHeaderMouseLeave), $headerRowScroller.bind("scroll", handleHeaderRowScroll), options.createFooterRow && $footerRowScroller.bind("scroll", handleFooterRowScroll), $focusSink.add($focusSink2).bind("keydown", handleKeyDown), $canvas.bind("keydown", handleKeyDown).bind("click", handleClick).bind("dblclick", handleDblClick).bind("contextmenu", handleContextMenu).delegate(".slick-cell", "mouseenter", handleMouseEnter).delegate(".slick-cell", "mouseleave", handleMouseLeave), (0, _interact2.default)($canvas[0]).allowFrom("div.slick-cell").draggable({
        onmove: handleDrag,
        onstart: handleDragStart,
        onend: handleDragEnd
      }).styleCursor(!1), navigator.userAgent.toLowerCase().match(/webkit/) && navigator.userAgent.toLowerCase().match(/macintosh/) && $canvas.bind("mousewheel", handleMouseWheel), restoreCssFromHiddenInit());
    }

    function cacheCssForHiddenInit() {
      $hiddenParents = $container.parents().addBack().not(":visible"), $hiddenParents.each(function () {
        var e = {};

        for (var t in cssShow) {
          e[t] = this.style[t], this.style[t] = cssShow[t];
        }

        oldProps.push(e);
      });
    }

    function restoreCssFromHiddenInit() {
      $hiddenParents.each(function (e) {
        var t = oldProps[e];

        for (var o in cssShow) {
          this.style[o] = t[o];
        }
      });
    }

    function registerPlugin(e) {
      plugins.unshift(e), e.init(self);
    }

    function unregisterPlugin(e) {
      for (var t = plugins.length; t >= 0; t--) {
        if (plugins[t] === e) {
          plugins[t].destroy && plugins[t].destroy(), plugins.splice(t, 1);
          break;
        }
      }
    }

    function setSelectionModel(e) {
      selectionModel && (selectionModel.onSelectedRangesChanged.unsubscribe(handleSelectedRangesChanged), selectionModel.destroy && selectionModel.destroy()), selectionModel = e, selectionModel && (selectionModel.init(self), selectionModel.onSelectedRangesChanged.subscribe(handleSelectedRangesChanged));
    }

    function getSelectionModel() {
      return selectionModel;
    }

    function getCanvasNode() {
      return $canvas[0];
    }

    function measureScrollbar() {
      var e = (0, _jquery2.default)("<div style='position:absolute; top:-10000px; left:-10000px; width:100px; height:100px; overflow:scroll;'></div>").appendTo("body"),
          t = {
        width: e.width() - e[0].clientWidth,
        height: e.height() - e[0].clientHeight
      };
      return e.remove(), t;
    }

    function getHeadersWidth() {
      for (var e = 0, t = 0, o = columns.length; t < o; t++) {
        var n = columns[t].width;
        e += n;
      }

      return e += scrollbarDimensions.width, Math.max(e, viewportW) + 1e3;
    }

    function getCanvasWidth() {
      for (var e = viewportHasVScroll ? viewportW - scrollbarDimensions.width : viewportW, t = 0, o = columns.length; o--;) {
        t += columns[o].width;
      }

      return options.fullWidthRows ? Math.max(t, e) : t;
    }

    function updateCanvasWidth(e) {
      var t = canvasWidth;
      canvasWidth = getCanvasWidth(), canvasWidth != t && ($canvas.width(canvasWidth), $headerRow.width(canvasWidth), options.createFooterRow && $footerRow.width(canvasWidth), $headers.width(getHeadersWidth()), viewportHasHScroll = canvasWidth > viewportW - scrollbarDimensions.width);
      var o = canvasWidth + (viewportHasVScroll ? scrollbarDimensions.width : 0);
      $headerRowSpacer.width(o), options.createFooterRow && $footerRowSpacer.width(o), (canvasWidth != t || e) && applyColumnWidths();
    }

    function disableSelection(e) {
      e && e.jquery && e.attr("unselectable", "on").css("MozUserSelect", "none").bind("selectstart.ui", function () {
        return !1;
      });
    }

    function getMaxSupportedCssHeight() {
      for (var e = 1e6, t = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9, o = (0, _jquery2.default)("<div style='display:none' />").appendTo(document.body);;) {
        var n = 2 * e;
        if (o.css("height", n), n > t || o.height() !== n) break;
        e = n;
      }

      return o.remove(), e;
    }

    function bindAncestorScrollEvents() {
      for (var e = $canvas[0]; (e = e.parentNode) != document.body && null != e;) {
        if (e == $viewport[0] || e.scrollWidth != e.clientWidth || e.scrollHeight != e.clientHeight) {
          var t = (0, _jquery2.default)(e);
          $boundAncestors = $boundAncestors ? $boundAncestors.add(t) : t, t.bind("scroll." + uid, handleActiveCellPositionChange);
        }
      }
    }

    function unbindAncestorScrollEvents() {
      $boundAncestors && ($boundAncestors.unbind("scroll." + uid), $boundAncestors = null);
    }

    function updateColumnHeader(e, t, o) {
      if (initialized) {
        var n = getColumnIndex(e);

        if (null != n) {
          var r = columns[n],
              i = $headers.children().eq(n);
          i && (void 0 !== t && (columns[n].name = t), void 0 !== o && (columns[n].toolTip = o), trigger(self.onBeforeHeaderCellDestroy, {
            node: i[0],
            column: r,
            grid: self
          }), i.attr("title", o || "").children().eq(0).html(t), trigger(self.onHeaderCellRendered, {
            node: i[0],
            column: r,
            grid: self
          }));
        }
      }
    }

    function getHeaderRow() {
      return $headerRow[0];
    }

    function getFooterRow() {
      return $footerRow[0];
    }

    function getHeaderRowColumn(e) {
      var t = getColumnIndex(e),
          o = $headerRow.children().eq(t);
      return o && o[0];
    }

    function getFooterRowColumn(e) {
      var t = getColumnIndex(e),
          o = $footerRow.children().eq(t);
      return o && o[0];
    }

    function createColumnHeaders() {
      function e() {
        (0, _jquery2.default)(this).addClass("ui-state-hover");
      }

      function t() {
        (0, _jquery2.default)(this).removeClass("ui-state-hover");
      }

      $headers.find(".slick-header-column").each(function () {
        var e = (0, _jquery2.default)(this).data("column");
        e && trigger(self.onBeforeHeaderCellDestroy, {
          node: this,
          column: e,
          grid: self
        });
      }), $headers.empty(), $headers.width(getHeadersWidth()), $headerRow.find(".slick-headerrow-column").each(function () {
        var e = (0, _jquery2.default)(this).data("column");
        e && trigger(self.onBeforeHeaderRowCellDestroy, {
          node: this,
          column: e,
          grid: self
        });
      }), $headerRow.empty(), options.createFooterRow && ($footerRow.find(".slick-footerrow-column").each(function () {
        var e = (0, _jquery2.default)(this).data("column");
        e && trigger(self.onBeforeFooterRowCellDestroy, {
          node: this,
          column: e
        });
      }), $footerRow.empty());

      for (var o = 0; o < columns.length; o++) {
        var n = columns[o],
            r = (0, _jquery2.default)("<div class='ui-state-default slick-header-column' />").html("<span class='slick-column-name'>" + n.name + "</span>").width(n.width - headerColumnWidthDiff).attr("id", "" + uid + n.id).attr("title", n.toolTip || "").data("column", n).addClass(n.headerCssClass || "").appendTo($headers);

        if ((options.enableColumnReorder || n.sortable) && r.on("mouseenter", e).on("mouseleave", t), n.sortable && (r.addClass("slick-header-sortable"), r.append("<span class='slick-sort-indicator' />")), trigger(self.onHeaderCellRendered, {
          node: r[0],
          column: n,
          grid: self
        }), options.showHeaderRow) {
          var i = (0, _jquery2.default)("<div class='ui-state-default slick-headerrow-column l" + o + " r" + o + "'></div>").data("column", n).appendTo($headerRow);
          trigger(self.onHeaderRowCellRendered, {
            node: i[0],
            column: n,
            grid: self
          });
        }

        if (options.createFooterRow && options.showFooterRow) {
          var s = (0, _jquery2.default)("<div class='ui-state-default slick-footerrow-column l" + o + " r" + o + "'></div>").data("column", n).appendTo($footerRow);
          trigger(self.onFooterRowCellRendered, {
            node: s[0],
            column: n
          });
        }
      }

      setSortColumns(sortColumns), setupColumnResize(), options.enableColumnReorder && setupColumnReorder();
    }

    function setupColumnSort() {
      $headers.click(function (e) {
        if (e.metaKey = e.metaKey || e.ctrlKey, !(0, _jquery2.default)(e.target).hasClass("slick-resizable-handle")) {
          var t = (0, _jquery2.default)(e.target).closest(".slick-header-column");

          if (t.length) {
            var o = t.data("column");

            if (o.sortable) {
              if (!getEditorLock().commitCurrentEdit()) return;

              for (var n = null, r = 0; r < sortColumns.length; r++) {
                if (sortColumns[r].columnId == o.id) {
                  n = sortColumns[r], n.sortAsc = !n.sortAsc;
                  break;
                }
              }

              e.metaKey && options.multiColumnSort ? n && sortColumns.splice(r, 1) : ((e.shiftKey || e.metaKey) && options.multiColumnSort || (sortColumns = []), n ? 0 == sortColumns.length && sortColumns.push(n) : (n = {
                columnId: o.id,
                sortAsc: o.defaultSortAsc
              }, sortColumns.push(n))), setSortColumns(sortColumns), options.multiColumnSort ? trigger(self.onSort, {
                multiColumnSort: !0,
                sortCols: _jquery2.default.map(sortColumns, function (e) {
                  return {
                    sortCol: columns[getColumnIndex(e.columnId)],
                    sortAsc: e.sortAsc
                  };
                }),
                grid: self
              }, e) : trigger(self.onSort, {
                multiColumnSort: !1,
                sortCol: o,
                sortAsc: n.sortAsc,
                grid: self
              }, e);
            }
          }
        }
      });
    }

    function setupColumnReorder() {
      var e = 0,
          t = 0,
          o = document.createElement("div");
      o.className = "interact-placeholder", (0, _interact2.default)(".slick-header-column", {
        context: $container[0]
      }).ignoreFrom(".slick-resizable-handle").draggable({
        inertia: !0,
        restrict: {
          restriction: "parent",
          endOnly: !0,
          elementRect: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
          }
        },
        autoScroll: !0,
        axis: "x",
        onstart: function onstart(n) {
          e = 0, t = n.target.offsetWidth, $headers.find(".slick-header-column").each(function (e) {
            (0, _jquery2.default)(this).data("index", e);
          }), o.style.height = n.target.offsetHeight + "px", o.style.width = t + "px", (0, _jquery2.default)(n.target).after(o).css({
            position: "absolute",
            zIndex: 1e3,
            marginLeft: (0, _jquery2.default)(n.target).position().left
          });
        },
        onmove: function onmove(t) {
          e += t.dx, t.target.style.transform = "translate3d(" + e + "px, -3px, 100px)";
        },
        onend: function onend(n) {
          e = 0, t = 0, (0, _jquery2.default)(n.target).css({
            position: "relative",
            zIndex: "",
            marginLeft: 0,
            transform: "none"
          }), o.parentNode.removeChild(o);
          var r = [];
          $headers.find(".slick-header-column").each(function (e) {
            r.push(columns[(0, _jquery2.default)(this).data("index")]), (0, _jquery2.default)(this).removeData("index");
          }), setColumns(r), trigger(self.onColumnsReordered, {
            grid: self
          }), setupColumnResize();
        }
      }).dropzone({
        accept: ".slick-header-column",
        ondragenter: function ondragenter(e) {
          e.target.classList.add("interact-drop-active"), e.relatedTarget.classList.add("interact-can-drop");
        },
        ondragleave: function ondragleave(e) {
          e.target.classList.remove("interact-drop-active"), e.relatedTarget.classList.remove("interact-can-drop");
        },
        ondrop: function ondrop(t) {
          t.target.classList.remove("interact-drop-active"), t.relatedTarget.classList.remove("interact-can-drop"), (0, _jquery2.default)(t.target)[e > 0 ? "after" : "before"](t.relatedTarget);
        }
      }).styleCursor(!1);
    }

    function setupColumnResize() {
      var e, t, o, n;
      t = $headers.children(), t.find(".slick-resizable-handle").remove(), t.each(function (e, t) {
        columns[e].resizable && (void 0 === o && (o = e), n = e);
      }), void 0 !== o && t.each(function (t, r) {
        if (!(t < o || options.forceFitColumns && t >= n)) {
          e = (0, _jquery2.default)(r);
          var i = (0, _jquery2.default)("<div class='slick-resizable-handle' />");

          if (i.appendTo(r), !e.data("resizable")) {
            var s = columns[t];
            s.resizable && (e.data("resizable", !0), (0, _interact2.default)(r).resizable({
              preserveAspectRatio: !1,
              edges: {
                left: !0,
                right: !0,
                bottom: !1,
                top: !1
              }
            }).on("resizestart", function (e) {
              return !!getEditorLock().commitCurrentEdit() && (s.previousWidth = e.rect.width, void e.target.classList.add("slick-header-column-active"));
            }).on("resizemove", function (e) {
              var t = e.dx,
                  o = s.width += t;
              s.minWidth > 0 && s.minWidth > o ? o = s.minWidth : s.maxWidth > 0 && s.maxWidth < o && (o = s.maxWidth), s.width = o, options.forceFitColumns && autosizeColumns(), applyColumnHeaderWidths(), options.syncColumnCellResize && applyColumnWidths();
            }).on("resizeend", function (e) {
              e.target.classList.remove("slick-header-column-active"), invalidateAllRows(), updateCanvasWidth(!0), render(), trigger(self.onColumnsResized, {
                grid: self
              });
            }));
          }
        }
      });
    }

    function getVBoxDelta(e) {
      var t = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"],
          o = 0;
      return _jquery2.default.each(t, function (t, n) {
        o += parseFloat(e.css(n)) || 0;
      }), o;
    }

    function measureCellPaddingAndBorder() {
      var e,
          t = ["borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight"],
          o = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"],
          n = _jquery2.default.fn.jquery.split(".");

      jQueryNewWidthBehaviour = 1 == n[0] && n[1] >= 8 || n[0] >= 2, e = (0, _jquery2.default)("<div class='ui-state-default slick-header-column' style='visibility:hidden'>-</div>").appendTo($headers), headerColumnWidthDiff = headerColumnHeightDiff = 0, "border-box" != e.css("box-sizing") && "border-box" != e.css("-moz-box-sizing") && "border-box" != e.css("-webkit-box-sizing") && (_jquery2.default.each(t, function (t, o) {
        headerColumnWidthDiff += parseFloat(e.css(o)) || 0;
      }), _jquery2.default.each(o, function (t, o) {
        headerColumnHeightDiff += parseFloat(e.css(o)) || 0;
      })), e.remove();
      var r = (0, _jquery2.default)("<div class='slick-row' />").appendTo($canvas);
      e = (0, _jquery2.default)("<div class='slick-cell' id='' style='visibility:hidden'>-</div>").appendTo(r), cellWidthDiff = cellHeightDiff = 0, "border-box" != e.css("box-sizing") && "border-box" != e.css("-moz-box-sizing") && "border-box" != e.css("-webkit-box-sizing") && (_jquery2.default.each(t, function (t, o) {
        cellWidthDiff += parseFloat(e.css(o)) || 0;
      }), _jquery2.default.each(o, function (t, o) {
        cellHeightDiff += parseFloat(e.css(o)) || 0;
      })), r.remove(), absoluteColumnMinWidth = Math.max(headerColumnWidthDiff, cellWidthDiff);
    }

    function createCssRules() {
      $style = (0, _jquery2.default)("<style type='text/css' rel='stylesheet' />").appendTo((0, _jquery2.default)("head"));

      for (var e = options.rowHeight - cellHeightDiff, t = ["." + uid + " .slick-header-column { left: 0; }", "." + uid + " .slick-top-panel { height:" + options.topPanelHeight + "px; }", "." + uid + " .slick-headerrow-columns { height:" + options.headerRowHeight + "px; }", "." + uid + " .slick-footerrow-columns { height:" + options.footerRowHeight + "px; }", "." + uid + " .slick-cell { height:" + e + "px; }", "." + uid + " .slick-row { height:" + options.rowHeight + "px; }"], o = 0; o < columns.length; o++) {
        t.push("." + uid + " .l" + o + " { }"), t.push("." + uid + " .r" + o + " { }");
      }

      $style[0].styleSheet ? $style[0].styleSheet.cssText = t.join(" ") : $style[0].appendChild(document.createTextNode(t.join(" ")));
    }

    function getColumnCssRules(e) {
      if (!stylesheet) {
        for (var t = document.styleSheets, o = 0; o < t.length; o++) {
          if ((t[o].ownerNode || t[o].owningElement) == $style[0]) {
            stylesheet = t[o];
            break;
          }
        }

        if (!stylesheet) throw new Error("Cannot find stylesheet.");
        columnCssRulesL = [], columnCssRulesR = [];

        for (var n, r, i = stylesheet.cssRules || stylesheet.rules, o = 0; o < i.length; o++) {
          var s = i[o].selectorText;
          (n = /\.l\d+/.exec(s)) ? (r = parseInt(n[0].substr(2, n[0].length - 2), 10), columnCssRulesL[r] = i[o]) : (n = /\.r\d+/.exec(s)) && (r = parseInt(n[0].substr(2, n[0].length - 2), 10), columnCssRulesR[r] = i[o]);
        }
      }

      return {
        left: columnCssRulesL[e],
        right: columnCssRulesR[e]
      };
    }

    function removeCssRules() {
      $style.remove(), stylesheet = null;
    }

    function destroy() {
      getEditorLock().cancelCurrentEdit(), trigger(self.onBeforeDestroy, {
        grid: self
      });

      for (var e = plugins.length; e--;) {
        unregisterPlugin(plugins[e]);
      }

      unbindAncestorScrollEvents(), $container.unbind(".slickgrid"), removeCssRules(), $container.empty().removeClass(uid);
    }

    function trigger(e, t, o) {
      return o = o || new _slick2.default.EventData(), t = t || {}, t.grid = self, e.notify(t, o, self);
    }

    function getEditorLock() {
      return options.editorLock;
    }

    function getEditController() {
      return editController;
    }

    function getColumnIndex(e) {
      return columnsById[e];
    }

    function autosizeColumns() {
      var e,
          t,
          o,
          n = [],
          r = 0,
          i = 0,
          s = viewportHasVScroll ? viewportW - scrollbarDimensions.width : viewportW;

      for (e = 0; e < columns.length; e++) {
        t = columns[e], n.push(t.width), i += t.width, t.resizable && (r += t.width - Math.max(t.minWidth, absoluteColumnMinWidth));
      }

      for (o = i; i > s && r;) {
        var l = (i - s) / r;

        for (e = 0; e < columns.length && i > s; e++) {
          t = columns[e];
          var a = n[e];

          if (!(!t.resizable || a <= t.minWidth || a <= absoluteColumnMinWidth)) {
            var c = Math.max(t.minWidth, absoluteColumnMinWidth),
                d = Math.floor(l * (a - c)) || 1;
            d = Math.min(d, a - c), i -= d, r -= d, n[e] -= d;
          }
        }

        if (o <= i) break;
        o = i;
      }

      for (o = i; i < s;) {
        var u = s / i;

        for (e = 0; e < columns.length && i < s; e++) {
          t = columns[e];
          var h,
              p = n[e];
          h = !t.resizable || t.maxWidth <= p ? 0 : Math.min(Math.floor(u * p) - p, t.maxWidth - p || 1e6) || 1, i += h, n[e] += i <= s ? h : 0;
        }

        if (o >= i) break;
        o = i;
      }

      var f = !1;

      for (e = 0; e < columns.length; e++) {
        columns[e].rerenderOnResize && columns[e].width != n[e] && (f = !0), columns[e].width = n[e];
      }

      applyColumnHeaderWidths(), updateCanvasWidth(!0), f && (invalidateAllRows(), render());
    }

    function applyColumnHeaderWidths() {
      if (initialized) {
        for (var e, t = 0, o = $headers.children("[id]"), n = o.length; t < n; t++) {
          e = (0, _jquery2.default)(o[t]), jQueryNewWidthBehaviour ? e.outerWidth() !== columns[t].width && e.outerWidth(columns[t].width) : e.width() !== columns[t].width - headerColumnWidthDiff && e.width(columns[t].width - headerColumnWidthDiff);
        }

        updateColumnCaches();
      }
    }

    function applyColumnWidths() {
      for (var e, t, o = 0, n = 0; n < columns.length; n++) {
        e = columns[n].width, t = getColumnCssRules(n), t.left.style.left = o + "px", t.right.style.right = canvasWidth - o - e + "px", o += columns[n].width;
      }
    }

    function setSortColumn(e, t) {
      setSortColumns([{
        columnId: e,
        sortAsc: t
      }]);
    }

    function setSortColumns(e) {
      sortColumns = e;
      var t = $headers.children();
      t.removeClass("slick-header-column-sorted").find(".slick-sort-indicator").removeClass("slick-sort-indicator-asc slick-sort-indicator-desc"), _jquery2.default.each(sortColumns, function (e, o) {
        null == o.sortAsc && (o.sortAsc = !0);
        var n = getColumnIndex(o.columnId);
        null != n && t.eq(n).addClass("slick-header-column-sorted").find(".slick-sort-indicator").addClass(o.sortAsc ? "slick-sort-indicator-asc" : "slick-sort-indicator-desc");
      });
    }

    function getSortColumns() {
      return sortColumns;
    }

    function handleSelectedRangesChanged(e, t) {
      selectedRows = [];

      for (var o = {}, n = 0; n < t.length; n++) {
        for (var r = t[n].fromRow; r <= t[n].toRow; r++) {
          o[r] || (selectedRows.push(r), o[r] = {});

          for (var i = t[n].fromCell; i <= t[n].toCell; i++) {
            canCellBeSelected(r, i) && (o[r][columns[i].id] = options.selectedCellCssClass);
          }
        }
      }

      setCellCssStyles(options.selectedCellCssClass, o), trigger(self.onSelectedRowsChanged, {
        rows: getSelectedRows(),
        grid: self
      }, e);
    }

    function getColumns() {
      return columns;
    }

    function updateColumnCaches() {
      columnPosLeft = [], columnPosRight = [];

      for (var e = 0, t = 0, o = columns.length; t < o; t++) {
        columnPosLeft[t] = e, columnPosRight[t] = e + columns[t].width, e += columns[t].width;
      }
    }

    function setColumns(e) {
      columns = e, columnsById = {};

      for (var t = 0; t < columns.length; t++) {
        var o = columns[t] = _jquery2.default.extend({}, columnDefaults, columns[t]);

        columnsById[o.id] = t, o.minWidth && o.width < o.minWidth && (o.width = o.minWidth), o.maxWidth && o.width > o.maxWidth && (o.width = o.maxWidth);
      }

      updateColumnCaches(), initialized && (invalidateAllRows(), createColumnHeaders(), removeCssRules(), createCssRules(), resizeCanvas(), applyColumnWidths(), handleScroll());
    }

    function getOptions() {
      return options;
    }

    function setOptions(e) {
      getEditorLock().commitCurrentEdit() && (makeActiveCellNormal(), options.enableAddRow !== e.enableAddRow && invalidateRow(getDataLength()), options = _jquery2.default.extend(options, e), validateAndEnforceOptions(), $viewport.css("overflow-y", options.autoHeight ? "hidden" : "auto"), render());
    }

    function validateAndEnforceOptions() {
      options.autoHeight && (options.leaveSpaceForNewRows = !1);
    }

    function setData(e, t) {
      data = e, invalidateAllRows(), updateRowCount(), t && scrollTo(0);
    }

    function getData() {
      return data;
    }

    function getDataLength() {
      return data.getLength ? data.getLength() : data.length;
    }

    function getDataLengthIncludingAddNew() {
      return getDataLength() + (options.enableAddRow ? 1 : 0);
    }

    function getDataItem(e) {
      return data.getItem ? data.getItem(e) : data[e];
    }

    function getTopPanel() {
      return $topPanel[0];
    }

    function setTopPanelVisibility(e) {
      options.showTopPanel != e && (options.showTopPanel = e, e ? $topPanelScroller.slideDown("fast", resizeCanvas) : $topPanelScroller.slideUp("fast", resizeCanvas));
    }

    function setHeaderRowVisibility(e) {
      options.showHeaderRow != e && (options.showHeaderRow = e, e ? $headerRowScroller.slideDown("fast", resizeCanvas) : $headerRowScroller.slideUp("fast", resizeCanvas));
    }

    function setFooterRowVisibility(e) {
      options.showFooterRow != e && (options.showFooterRow = e, e ? $footerRowScroller.slideDown("fast", resizeCanvas) : $footerRowScroller.slideUp("fast", resizeCanvas));
    }

    function getContainerNode() {
      return $container.get(0);
    }

    function getRowTop(e) {
      return options.rowHeight * e - offset;
    }

    function getRowFromPosition(e) {
      return Math.floor((e + offset) / options.rowHeight);
    }

    function scrollTo(e) {
      e = Math.max(e, 0), e = Math.min(e, th - viewportH + (viewportHasHScroll ? scrollbarDimensions.height : 0));
      var t = offset;
      page = Math.min(n - 1, Math.floor(e / ph)), offset = Math.round(page * cj);
      var o = e - offset;

      if (offset != t) {
        var r = getVisibleRange(o);
        cleanupRows(r), updateRowPositions();
      }

      prevScrollTop != o && (vScrollDir = prevScrollTop + t < o + offset ? 1 : -1, $viewport[0].scrollTop = lastRenderedScrollTop = scrollTop = prevScrollTop = o, trigger(self.onViewportChanged, {
        grid: self
      }));
    }

    function defaultFormatter(e, t, o, n, r) {
      return null == o ? "" : (o + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    function getFormatter(e, t) {
      var o = data.getItemMetadata && data.getItemMetadata(e),
          n = o && o.columns && (o.columns[t.id] || o.columns[getColumnIndex(t.id)]);
      return n && n.formatter || o && o.formatter || t.formatter || options.formatterFactory && options.formatterFactory.getFormatter(t) || options.defaultFormatter;
    }

    function getEditor(e, t) {
      var o = columns[t],
          n = data.getItemMetadata && data.getItemMetadata(e),
          r = n && n.columns;
      return r && r[o.id] && void 0 !== r[o.id].editor ? r[o.id].editor : r && r[t] && void 0 !== r[t].editor ? r[t].editor : o.editor || options.editorFactory && options.editorFactory.getEditor(o);
    }

    function getDataItemValueForColumn(e, t) {
      return options.dataItemColumnValueExtractor ? options.dataItemColumnValueExtractor(e, t) : e[t.field];
    }

    function appendRowHtml(e, t, o, n) {
      var r = getDataItem(t),
          i = t < n && !r,
          s = "slick-row" + (i ? " loading" : "") + (t === activeRow ? " active" : "") + (t % 2 == 1 ? " odd" : " even");
      r || (s += " " + options.addNewRowCssClass);
      var l = data.getItemMetadata && data.getItemMetadata(t);
      l && l.cssClasses && (s += " " + l.cssClasses), e.push("<div class='ui-widget-content " + s + "' style='top:" + getRowTop(t) + "px'>");

      for (var a, c, d = 0, u = columns.length; d < u; d++) {
        if (c = columns[d], a = 1, l && l.columns) {
          var h = l.columns[c.id] || l.columns[d];
          a = h && h.colspan || 1, "*" === a && (a = u - d);
        }

        if (columnPosRight[Math.min(u - 1, d + a - 1)] > o.leftPx) {
          if (columnPosLeft[d] > o.rightPx) break;
          appendCellHtml(e, t, d, a, r);
        }

        a > 1 && (d += a - 1);
      }

      e.push("</div>");
    }

    function appendCellHtml(e, t, o, n, r) {
      var i = columns[o],
          s = "slick-cell l" + o + " r" + Math.min(columns.length - 1, o + n - 1) + (i.cssClass ? " " + i.cssClass : "");
      t === activeRow && o === activeCell && (s += " active");

      for (var l in cellCssClasses) {
        cellCssClasses[l][t] && cellCssClasses[l][t][i.id] && (s += " " + cellCssClasses[l][t][i.id]);
      }

      if (e.push("<div class='" + s + "'>"), r) {
        var a = getDataItemValueForColumn(r, i);
        e.push(getFormatter(t, i)(t, o, a, i, r));
      }

      e.push("</div>"), rowsCache[t].cellRenderQueue.push(o), rowsCache[t].cellColSpans[o] = n;
    }

    function cleanupRows(e) {
      for (var t in rowsCache) {
        (t = parseInt(t, 10)) !== activeRow && (t < e.top || t > e.bottom) && removeRowFromCache(t);
      }

      options.enableAsyncPostRenderCleanup && startPostProcessingCleanup();
    }

    function invalidate() {
      updateRowCount(), invalidateAllRows(), render();
    }

    function invalidateAllRows() {
      currentEditor && makeActiveCellNormal();

      for (var e in rowsCache) {
        removeRowFromCache(e);
      }

      options.enableAsyncPostRenderCleanup && startPostProcessingCleanup();
    }

    function queuePostProcessedRowForCleanup(e, t, o) {
      postProcessgroupId++;

      for (var n in t) {
        t.hasOwnProperty(n) && postProcessedCleanupQueue.push({
          actionType: "C",
          groupId: postProcessgroupId,
          node: e.cellNodesByColumnIdx[0 | n],
          columnIdx: 0 | n,
          rowIdx: o
        });
      }

      postProcessedCleanupQueue.push({
        actionType: "R",
        groupId: postProcessgroupId,
        node: e.rowNode
      }), (0, _jquery2.default)(e.rowNode).detach();
    }

    function queuePostProcessedCellForCleanup(e, t, o) {
      postProcessedCleanupQueue.push({
        actionType: "C",
        groupId: postProcessgroupId,
        node: e,
        columnIdx: t,
        rowIdx: o
      }), (0, _jquery2.default)(e).detach();
    }

    function removeRowFromCache(e) {
      var t = rowsCache[e];
      t && (rowNodeFromLastMouseWheelEvent === t.rowNode ? (t.rowNode.style.display = "none", zombieRowNodeFromLastMouseWheelEvent = rowNodeFromLastMouseWheelEvent, zombieRowCacheFromLastMouseWheelEvent = t, zombieRowPostProcessedFromLastMouseWheelEvent = postProcessedRows[e]) : options.enableAsyncPostRenderCleanup && postProcessedRows[e] ? queuePostProcessedRowForCleanup(t, postProcessedRows[e], e) : $canvas[0].removeChild(t.rowNode), delete rowsCache[e], delete postProcessedRows[e], renderedRows--, counter_rows_removed++);
    }

    function invalidateRows(e) {
      var t, o;

      if (e && e.length) {
        for (vScrollDir = 0, t = 0, o = e.length; t < o; t++) {
          currentEditor && activeRow === e[t] && makeActiveCellNormal(), rowsCache[e[t]] && removeRowFromCache(e[t]);
        }

        options.enableAsyncPostRenderCleanup && startPostProcessingCleanup();
      }
    }

    function invalidateRow(e) {
      invalidateRows([e]);
    }

    function updateCell(e, t) {
      var o = getCellNode(e, t);

      if (o) {
        var n = columns[t],
            r = getDataItem(e);
        currentEditor && activeRow === e && activeCell === t ? currentEditor.loadValue(r) : (o.innerHTML = r ? getFormatter(e, n)(e, t, getDataItemValueForColumn(r, n), n, r) : "", invalidatePostProcessingResults(e));
      }
    }

    function updateRow(e) {
      var t = rowsCache[e];

      if (t) {
        ensureCellNodesInRowsCache(e);
        var o = getDataItem(e);

        for (var n in t.cellNodesByColumnIdx) {
          if (t.cellNodesByColumnIdx.hasOwnProperty(n)) {
            n |= 0;
            var r = columns[n],
                i = t.cellNodesByColumnIdx[n];
            e === activeRow && n === activeCell && currentEditor ? currentEditor.loadValue(o) : o ? i.innerHTML = getFormatter(e, r)(e, n, getDataItemValueForColumn(o, r), r, o) : i.innerHTML = "";
          }
        }

        invalidatePostProcessingResults(e);
      }
    }

    function getViewportHeight() {
      return parseFloat(_jquery2.default.css($container[0], "height", !0)) - parseFloat(_jquery2.default.css($container[0], "paddingTop", !0)) - parseFloat(_jquery2.default.css($container[0], "paddingBottom", !0)) - parseFloat(_jquery2.default.css($headerScroller[0], "height")) - getVBoxDelta($headerScroller) - (options.showTopPanel ? options.topPanelHeight + getVBoxDelta($topPanelScroller) : 0) - (options.showHeaderRow ? options.headerRowHeight + getVBoxDelta($headerRowScroller) : 0) - (options.createFooterRow && options.showFooterRow ? options.footerRowHeight + getVBoxDelta($footerRowScroller) : 0);
    }

    function resizeCanvas() {
      initialized && (viewportH = options.autoHeight ? options.rowHeight * getDataLengthIncludingAddNew() : getViewportHeight(), numVisibleRows = Math.ceil(viewportH / options.rowHeight), viewportW = parseFloat(_jquery2.default.css($container[0], "width", !0)), options.autoHeight || $viewport.height(viewportH), options.forceFitColumns && autosizeColumns(), updateRowCount(), handleScroll(), lastRenderedScrollLeft = -1, render());
    }

    function updateRowCount() {
      if (initialized) {
        var e = getDataLengthIncludingAddNew(),
            t = e + (options.leaveSpaceForNewRows ? numVisibleRows - 1 : 0),
            o = viewportHasVScroll;
        viewportHasVScroll = !options.autoHeight && t * options.rowHeight > viewportH, viewportHasHScroll = canvasWidth > viewportW - scrollbarDimensions.width, makeActiveCellNormal();
        var r = e - 1;

        for (var i in rowsCache) {
          i > r && removeRowFromCache(i);
        }

        options.enableAsyncPostRenderCleanup && startPostProcessingCleanup(), activeCellNode && activeRow > r && resetActiveCell();
        var s = h;
        th = Math.max(options.rowHeight * t, viewportH - scrollbarDimensions.height), th < maxSupportedCssHeight ? (h = ph = th, n = 1, cj = 0) : (h = maxSupportedCssHeight, ph = h / 100, n = Math.floor(th / ph), cj = (th - h) / (n - 1)), h !== s && ($canvas.css("height", h), scrollTop = $viewport[0].scrollTop);
        var l = scrollTop + offset <= th - viewportH;
        0 == th || 0 == scrollTop ? page = offset = 0 : scrollTo(l ? scrollTop + offset : th - viewportH), h != s && options.autoHeight && resizeCanvas(), options.forceFitColumns && o != viewportHasVScroll && autosizeColumns(), updateCanvasWidth(!1);
      }
    }

    function getVisibleRange(e, t) {
      return null == e && (e = scrollTop), null == t && (t = scrollLeft), {
        top: getRowFromPosition(e),
        bottom: getRowFromPosition(e + viewportH) + 1,
        leftPx: t,
        rightPx: t + viewportW
      };
    }

    function getRenderedRange(e, t) {
      var o = getVisibleRange(e, t),
          n = Math.round(viewportH / options.rowHeight),
          r = 3;
      return vScrollDir == -1 ? (o.top -= n, o.bottom += r) : 1 == vScrollDir ? (o.top -= r, o.bottom += n) : (o.top -= r, o.bottom += r), o.top = Math.max(0, o.top), o.bottom = Math.min(getDataLengthIncludingAddNew() - 1, o.bottom), o.leftPx -= viewportW, o.rightPx += viewportW, o.leftPx = Math.max(0, o.leftPx), o.rightPx = Math.min(canvasWidth, o.rightPx), o;
    }

    function ensureCellNodesInRowsCache(e) {
      var t = rowsCache[e];
      if (t && t.cellRenderQueue.length) for (var o = t.rowNode.lastChild; t.cellRenderQueue.length;) {
        var n = t.cellRenderQueue.pop();
        t.cellNodesByColumnIdx[n] = o, o = o.previousSibling;
      }
    }

    function cleanUpCells(e, t) {
      var o = 0,
          n = rowsCache[t],
          r = [];

      for (var i in n.cellNodesByColumnIdx) {
        if (n.cellNodesByColumnIdx.hasOwnProperty(i)) {
          i |= 0;
          var s = n.cellColSpans[i];
          (columnPosLeft[i] > e.rightPx || columnPosRight[Math.min(columns.length - 1, i + s - 1)] < e.leftPx) && (t == activeRow && i == activeCell || r.push(i));
        }
      }

      var l, a;

      for (postProcessgroupId++; null != (l = r.pop());) {
        a = n.cellNodesByColumnIdx[l], options.enableAsyncPostRenderCleanup && postProcessedRows[t] && postProcessedRows[t][l] ? queuePostProcessedCellForCleanup(a, l, t) : n.rowNode.removeChild(a), delete n.cellColSpans[l], delete n.cellNodesByColumnIdx[l], postProcessedRows[t] && delete postProcessedRows[t][l], o++;
      }
    }

    function cleanUpAndRenderCells(e) {
      for (var t, o, n, r = [], i = [], s = 0, l = e.top, a = e.bottom; l <= a; l++) {
        if (t = rowsCache[l]) {
          ensureCellNodesInRowsCache(l), cleanUpCells(e, l), o = 0;
          var c = data.getItemMetadata && data.getItemMetadata(l);
          c = c && c.columns;

          for (var d = getDataItem(l), u = 0, h = columns.length; u < h && !(columnPosLeft[u] > e.rightPx); u++) {
            if (null == (n = t.cellColSpans[u])) {
              if (n = 1, c) {
                var p = c[columns[u].id] || c[u];
                n = p && p.colspan || 1, "*" === n && (n = h - u);
              }

              columnPosRight[Math.min(h - 1, u + n - 1)] > e.leftPx && (appendCellHtml(r, l, u, n, d), o++), u += n > 1 ? n - 1 : 0;
            } else u += n > 1 ? n - 1 : 0;
          }

          o && (s += o, i.push(l));
        }
      }

      if (r.length) {
        var f = document.createElement("div");
        f.innerHTML = r.join("");

        for (var g, v; null != (g = i.pop());) {
          t = rowsCache[g];

          for (var m; null != (m = t.cellRenderQueue.pop());) {
            v = f.lastChild, t.rowNode.appendChild(v), t.cellNodesByColumnIdx[m] = v;
          }
        }
      }
    }

    function renderRows(e) {
      for (var t = $canvas[0], o = [], n = [], r = !1, i = getDataLength(), s = e.top, l = e.bottom; s <= l; s++) {
        rowsCache[s] || (renderedRows++, n.push(s), rowsCache[s] = {
          rowNode: null,
          cellColSpans: [],
          cellNodesByColumnIdx: [],
          cellRenderQueue: []
        }, appendRowHtml(o, s, e, i), activeCellNode && activeRow === s && (r = !0), counter_rows_rendered++);
      }

      if (n.length) {
        var a = document.createElement("div");
        a.innerHTML = o.join("");

        for (var s = 0, l = n.length; s < l; s++) {
          rowsCache[n[s]].rowNode = t.appendChild(a.firstChild);
        }

        r && (activeCellNode = getCellNode(activeRow, activeCell));
      }
    }

    function startPostProcessing() {
      options.enableAsyncPostRender && (clearTimeout(h_postrender), h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay));
    }

    function startPostProcessingCleanup() {
      options.enableAsyncPostRenderCleanup && (clearTimeout(h_postrenderCleanup), h_postrenderCleanup = setTimeout(asyncPostProcessCleanupRows, options.asyncPostRenderCleanupDelay));
    }

    function invalidatePostProcessingResults(e) {
      for (var t in postProcessedRows[e]) {
        postProcessedRows[e].hasOwnProperty(t) && (postProcessedRows[e][t] = "C");
      }

      postProcessFromRow = Math.min(postProcessFromRow, e), postProcessToRow = Math.max(postProcessToRow, e), startPostProcessing();
    }

    function updateRowPositions() {
      for (var e in rowsCache) {
        rowsCache[e].rowNode.style.top = getRowTop(e) + "px";
      }
    }

    function render() {
      if (initialized) {
        var e = getVisibleRange(),
            t = getRenderedRange();
        cleanupRows(t), lastRenderedScrollLeft != scrollLeft && cleanUpAndRenderCells(t), renderRows(t), postProcessFromRow = e.top, postProcessToRow = Math.min(getDataLengthIncludingAddNew() - 1, e.bottom), startPostProcessing(), lastRenderedScrollTop = scrollTop, lastRenderedScrollLeft = scrollLeft, h_render = null;
      }
    }

    function handleHeaderRowScroll() {
      var e = $headerRowScroller[0].scrollLeft;
      e != $viewport[0].scrollLeft && ($viewport[0].scrollLeft = e);
    }

    function handleFooterRowScroll() {
      var e = $footerRowScroller[0].scrollLeft;
      e != $viewport[0].scrollLeft && ($viewport[0].scrollLeft = e);
    }

    function handleScroll() {
      scrollTop = $viewport[0].scrollTop, scrollLeft = $viewport[0].scrollLeft;
      var e = Math.abs(scrollTop - prevScrollTop),
          t = Math.abs(scrollLeft - prevScrollLeft);
      if (t && (prevScrollLeft = scrollLeft, $headerScroller[0].scrollLeft = scrollLeft, $topPanelScroller[0].scrollLeft = scrollLeft, $headerRowScroller[0].scrollLeft = scrollLeft, options.createFooterRow && ($footerRowScroller[0].scrollLeft = scrollLeft)), e) if (vScrollDir = prevScrollTop < scrollTop ? 1 : -1, prevScrollTop = scrollTop, e < viewportH) scrollTo(scrollTop + offset);else {
        var o = offset;
        page = h == viewportH ? 0 : Math.min(n - 1, Math.floor(scrollTop * ((th - viewportH) / (h - viewportH)) * (1 / ph))), offset = Math.round(page * cj), o != offset && invalidateAllRows();
      }
      (t || e) && (h_render && clearTimeout(h_render), (Math.abs(lastRenderedScrollTop - scrollTop) > 20 || Math.abs(lastRenderedScrollLeft - scrollLeft) > 20) && (options.forceSyncScrolling || Math.abs(lastRenderedScrollTop - scrollTop) < viewportH && Math.abs(lastRenderedScrollLeft - scrollLeft) < viewportW ? render() : h_render = setTimeout(render, 50), trigger(self.onViewportChanged, {
        grid: self
      }))), trigger(self.onScroll, {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        grid: self
      });
    }

    function asyncPostProcessRows() {
      for (var e = getDataLength(); postProcessFromRow <= postProcessToRow;) {
        var t = vScrollDir >= 0 ? postProcessFromRow++ : postProcessToRow--,
            o = rowsCache[t];

        if (o && !(t >= e)) {
          postProcessedRows[t] || (postProcessedRows[t] = {}), ensureCellNodesInRowsCache(t);

          for (var n in o.cellNodesByColumnIdx) {
            if (o.cellNodesByColumnIdx.hasOwnProperty(n)) {
              n |= 0;
              var r = columns[n],
                  i = postProcessedRows[t][n];

              if (r.asyncPostRender && "R" !== i) {
                var s = o.cellNodesByColumnIdx[n];
                s && r.asyncPostRender(s, t, getDataItem(t), r, "C" === i), postProcessedRows[t][n] = "R";
              }
            }
          }

          return void (h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay));
        }
      }
    }

    function asyncPostProcessCleanupRows() {
      if (postProcessedCleanupQueue.length > 0) {
        for (var e = postProcessedCleanupQueue[0].groupId; postProcessedCleanupQueue.length > 0 && postProcessedCleanupQueue[0].groupId == e;) {
          var t = postProcessedCleanupQueue.shift();

          if ("R" == t.actionType && (0, _jquery2.default)(t.node).remove(), "C" == t.actionType) {
            var o = columns[t.columnIdx];
            o.asyncPostRenderCleanup && t.node && o.asyncPostRenderCleanup(t.node, t.rowIdx, o);
          }
        }

        h_postrenderCleanup = setTimeout(asyncPostProcessCleanupRows, options.asyncPostRenderCleanupDelay);
      }
    }

    function updateCellCssStylesOnRenderedRows(e, t) {
      var o, n, r, i;

      for (var s in rowsCache) {
        if (i = t && t[s], r = e && e[s], i) for (n in i) {
          r && i[n] == r[n] || (o = getCellNode(s, getColumnIndex(n)), o && (0, _jquery2.default)(o).removeClass(i[n]));
        }
        if (r) for (n in r) {
          i && i[n] == r[n] || (o = getCellNode(s, getColumnIndex(n)), o && (0, _jquery2.default)(o).addClass(r[n]));
        }
      }
    }

    function addCellCssStyles(e, t) {
      if (cellCssClasses[e]) throw "addCellCssStyles: cell CSS hash with key '" + e + "' already exists.";
      cellCssClasses[e] = t, updateCellCssStylesOnRenderedRows(t, null), trigger(self.onCellCssStylesChanged, {
        key: e,
        hash: t,
        grid: self
      });
    }

    function removeCellCssStyles(e) {
      cellCssClasses[e] && (updateCellCssStylesOnRenderedRows(null, cellCssClasses[e]), delete cellCssClasses[e], trigger(self.onCellCssStylesChanged, {
        key: e,
        hash: null,
        grid: self
      }));
    }

    function setCellCssStyles(e, t) {
      var o = cellCssClasses[e];
      cellCssClasses[e] = t, updateCellCssStylesOnRenderedRows(t, o), trigger(self.onCellCssStylesChanged, {
        key: e,
        hash: t,
        grid: self
      });
    }

    function getCellCssStyles(e) {
      return cellCssClasses[e];
    }

    function flashCell(e, t, o) {
      if (o = o || 100, rowsCache[e]) {
        var n = function e(t) {
          t && setTimeout(function () {
            r.queue(function () {
              r.toggleClass(options.cellFlashingCssClass).dequeue(), e(t - 1);
            });
          }, o);
        },
            r = (0, _jquery2.default)(getCellNode(e, t));

        n(4);
      }
    }

    function handleMouseWheel(e) {
      var t = (0, _jquery2.default)(e.target).closest(".slick-row")[0];
      t != rowNodeFromLastMouseWheelEvent && (zombieRowNodeFromLastMouseWheelEvent && zombieRowNodeFromLastMouseWheelEvent != t && (options.enableAsyncPostRenderCleanup && zombieRowPostProcessedFromLastMouseWheelEvent ? queuePostProcessedRowForCleanup(zombieRowCacheFromLastMouseWheelEvent, zombieRowPostProcessedFromLastMouseWheelEvent) : $canvas[0].removeChild(zombieRowNodeFromLastMouseWheelEvent), zombieRowNodeFromLastMouseWheelEvent = null, zombieRowCacheFromLastMouseWheelEvent = null, zombieRowPostProcessedFromLastMouseWheelEvent = null, options.enableAsyncPostRenderCleanup && startPostProcessingCleanup()), rowNodeFromLastMouseWheelEvent = t);
    }

    function handleDragStart(e) {
      var t = _jquery2.default.Event(e.originalEvent.type, e.originalEvent),
          o = getCellFromEvent(t);

      if (!o || !cellExists(o.row, o.cell)) return !1;
      var n = trigger(self.onDragStart, e, t);
      return !!t.isImmediatePropagationStopped() && n;
    }

    function handleDrag(e) {
      var t = _jquery2.default.Event(e.originalEvent.type, e.originalEvent);

      return trigger(self.onDrag, e, t);
    }

    function handleDragEnd(e) {
      trigger(self.onDragEnd, e, _jquery2.default.Event("mousedown"));
    }

    function handleKeyDown(e) {
      trigger(self.onKeyDown, {
        row: activeRow,
        cell: activeCell,
        grid: self
      }, e);
      var t = e.isImmediatePropagationStopped(),
          o = _slick2.default.keyCode;
      if (!t) if (e.shiftKey || e.altKey || e.ctrlKey) e.which != o.TAB || !e.shiftKey || e.ctrlKey || e.altKey || (t = navigatePrev());else {
        if (options.editable && currentEditor && currentEditor.keyCaptureList && currentEditor.keyCaptureList.indexOf(e.which) > -1) return;

        if (e.which == o.ESCAPE) {
          if (!getEditorLock().isActive()) return;
          cancelEditAndSetFocus();
        } else e.which == o.PAGE_DOWN ? (navigatePageDown(), t = !0) : e.which == o.PAGE_UP ? (navigatePageUp(), t = !0) : e.which == o.LEFT ? t = navigateLeft() : e.which == o.RIGHT ? t = navigateRight() : e.which == o.UP ? t = navigateUp() : e.which == o.DOWN ? t = navigateDown() : e.which == o.TAB ? t = navigateNext() : e.which == o.ENTER && (options.editable && (currentEditor ? activeRow === getDataLength() ? navigateDown() : commitEditAndSetFocus() : getEditorLock().commitCurrentEdit() && makeActiveCellEditable()), t = !0);
      }

      if (t) {
        e.stopPropagation(), e.preventDefault();

        try {
          e.originalEvent.keyCode = 0;
        } catch (e) {}
      }
    }

    function handleClick(e) {
      currentEditor || (e.target != document.activeElement || (0, _jquery2.default)(e.target).hasClass("slick-cell")) && setFocus();
      var t = getCellFromEvent(e);
      !t || null !== currentEditor && activeRow == t.row && activeCell == t.cell || (trigger(self.onClick, {
        row: t.row,
        cell: t.cell,
        grid: self
      }, e), e.isImmediatePropagationStopped() || activeCell == t.cell && activeRow == t.row || !canCellBeActive(t.row, t.cell) || getEditorLock().isActive() && !getEditorLock().commitCurrentEdit() || (scrollRowIntoView(t.row, !1), setActiveCellInternal(getCellNode(t.row, t.cell))));
    }

    function handleContextMenu(e) {
      var t = (0, _jquery2.default)(e.target).closest(".slick-cell", $canvas);
      0 !== t.length && (activeCellNode === t[0] && null !== currentEditor || trigger(self.onContextMenu, {
        grid: self
      }, e));
    }

    function handleDblClick(e) {
      var t = getCellFromEvent(e);
      !t || null !== currentEditor && activeRow == t.row && activeCell == t.cell || (trigger(self.onDblClick, {
        row: t.row,
        cell: t.cell,
        grid: self
      }, e), e.isImmediatePropagationStopped() || options.editable && gotoCell(t.row, t.cell, !0));
    }

    function handleHeaderMouseEnter(e) {
      trigger(self.onHeaderMouseEnter, {
        column: (0, _jquery2.default)(this).data("column"),
        grid: self
      }, e);
    }

    function handleHeaderMouseLeave(e) {
      trigger(self.onHeaderMouseLeave, {
        column: (0, _jquery2.default)(this).data("column"),
        grid: self
      }, e);
    }

    function handleHeaderContextMenu(e) {
      var t = (0, _jquery2.default)(e.target).closest(".slick-header-column", ".slick-header-columns"),
          o = t && t.data("column");
      trigger(self.onHeaderContextMenu, {
        column: o,
        grid: self
      }, e);
    }

    function handleHeaderClick(e) {
      var t = (0, _jquery2.default)(e.target).closest(".slick-header-column", ".slick-header-columns"),
          o = t && t.data("column");
      o && trigger(self.onHeaderClick, {
        column: o,
        grid: self
      }, e);
    }

    function handleMouseEnter(e) {
      trigger(self.onMouseEnter, {
        grid: self
      }, e);
    }

    function handleMouseLeave(e) {
      trigger(self.onMouseLeave, {
        grid: self
      }, e);
    }

    function cellExists(e, t) {
      return !(e < 0 || e >= getDataLength() || t < 0 || t >= columns.length);
    }

    function getCellFromPoint(e, t) {
      for (var o = getRowFromPosition(t), n = 0, r = 0, i = 0; i < columns.length && r < e; i++) {
        r += columns[i].width, n++;
      }

      return n < 0 && (n = 0), {
        row: o,
        cell: n - 1
      };
    }

    function getCellFromNode(e) {
      var t = /l\d+/.exec(e.className);
      if (!t) throw "getCellFromNode: cannot get cell - " + e.className;
      return parseInt(t[0].substr(1, t[0].length - 1), 10);
    }

    function getRowFromNode(e) {
      for (var t in rowsCache) {
        if (rowsCache[t].rowNode === e) return 0 | t;
      }

      return null;
    }

    function getCellFromEvent(e) {
      var t = (0, _jquery2.default)(e.target).closest(".slick-cell", $canvas);
      if (!t.length) return null;
      var o = getRowFromNode(t[0].parentNode),
          n = getCellFromNode(t[0]);
      return null == o || null == n ? null : {
        row: o,
        cell: n
      };
    }

    function getCellNodeBox(e, t) {
      if (!cellExists(e, t)) return null;

      for (var o = getRowTop(e), n = o + options.rowHeight - 1, r = 0, i = 0; i < t; i++) {
        r += columns[i].width;
      }

      var s = r + columns[t].width;
      return {
        top: o,
        left: r,
        bottom: n,
        right: s
      };
    }

    function resetActiveCell() {
      setActiveCellInternal(null, !1);
    }

    function setFocus() {
      tabbingDirection == -1 ? $focusSink[0].focus() : $focusSink2[0].focus();
    }

    function scrollCellIntoView(e, t, o) {
      scrollRowIntoView(e, o);
      var n = getColspan(e, t),
          r = columnPosLeft[t],
          i = columnPosRight[t + (n > 1 ? n - 1 : 0)],
          s = scrollLeft + viewportW;
      r < scrollLeft ? ($viewport.scrollLeft(r), handleScroll(), render()) : i > s && ($viewport.scrollLeft(Math.min(r, i - $viewport[0].clientWidth)), handleScroll(), render());
    }

    function setActiveCellInternal(e, t) {
      null !== activeCellNode && (makeActiveCellNormal(), (0, _jquery2.default)(activeCellNode).removeClass("active"), rowsCache[activeRow] && (0, _jquery2.default)(rowsCache[activeRow].rowNode).removeClass("active"));
      var o = activeCellNode !== e;
      activeCellNode = e, null != activeCellNode ? (activeRow = getRowFromNode(activeCellNode.parentNode), activeCell = activePosX = getCellFromNode(activeCellNode), null == t && (t = activeRow == getDataLength() || options.autoEdit), (0, _jquery2.default)(activeCellNode).addClass("active"), (0, _jquery2.default)(rowsCache[activeRow].rowNode).addClass("active"), options.editable && t && isCellPotentiallyEditable(activeRow, activeCell) && (clearTimeout(h_editorLoader), options.asyncEditorLoading ? h_editorLoader = setTimeout(function () {
        makeActiveCellEditable();
      }, options.asyncEditorLoadDelay) : makeActiveCellEditable())) : activeRow = activeCell = null, o && trigger(self.onActiveCellChanged, getActiveCell());
    }

    function clearTextSelection() {
      if (document.selection && document.selection.empty) try {
        document.selection.empty();
      } catch (e) {} else if (window.getSelection) {
        var e = window.getSelection();
        e && e.removeAllRanges && e.removeAllRanges();
      }
    }

    function isCellPotentiallyEditable(e, t) {
      var o = getDataLength();
      return !(e < o && !getDataItem(e)) && !(columns[t].cannotTriggerInsert && e >= o) && !!getEditor(e, t);
    }

    function makeActiveCellNormal() {
      if (currentEditor) {
        if (trigger(self.onBeforeCellEditorDestroy, {
          editor: currentEditor,
          grid: self
        }), currentEditor.destroy(), currentEditor = null, activeCellNode) {
          var e = getDataItem(activeRow);

          if ((0, _jquery2.default)(activeCellNode).removeClass("editable invalid"), e) {
            var t = columns[activeCell],
                o = getFormatter(activeRow, t);
            activeCellNode.innerHTML = o(activeRow, activeCell, getDataItemValueForColumn(e, t), t, e, self), invalidatePostProcessingResults(activeRow);
          }
        }

        navigator.userAgent.toLowerCase().match(/msie/) && clearTextSelection(), getEditorLock().deactivate(editController);
      }
    }

    function makeActiveCellEditable(e) {
      if (activeCellNode) {
        if (!options.editable) throw "Grid : makeActiveCellEditable : should never get called when options.editable is false";

        if (clearTimeout(h_editorLoader), isCellPotentiallyEditable(activeRow, activeCell)) {
          var t = columns[activeCell],
              o = getDataItem(activeRow);
          if (trigger(self.onBeforeEditCell, {
            row: activeRow,
            cell: activeCell,
            item: o,
            column: t,
            grid: self
          }) === !1) return void setFocus();
          getEditorLock().activate(editController), (0, _jquery2.default)(activeCellNode).addClass("editable");
          var n = e || getEditor(activeRow, activeCell);
          e || n.suppressClearOnEdit || (activeCellNode.innerHTML = ""), currentEditor = new n({
            grid: self,
            gridPosition: absBox($container[0]),
            position: absBox(activeCellNode),
            container: activeCellNode,
            column: t,
            item: o || {},
            commitChanges: commitEditAndSetFocus,
            cancelChanges: cancelEditAndSetFocus
          }), o && currentEditor.loadValue(o), serializedEditorValue = currentEditor.serializeValue(), currentEditor.position && handleActiveCellPositionChange();
        }
      }
    }

    function commitEditAndSetFocus() {
      getEditorLock().commitCurrentEdit() && (setFocus(), options.autoEdit && navigateDown());
    }

    function cancelEditAndSetFocus() {
      getEditorLock().cancelCurrentEdit() && setFocus();
    }

    function absBox(e) {
      var t = {
        top: e.offsetTop,
        left: e.offsetLeft,
        bottom: 0,
        right: 0,
        width: (0, _jquery2.default)(e).outerWidth(),
        height: (0, _jquery2.default)(e).outerHeight(),
        visible: !0
      };
      t.bottom = t.top + t.height, t.right = t.left + t.width;

      for (var o = e.offsetParent; (e = e.parentNode) != document.body && null != e;) {
        t.visible && e.scrollHeight != e.offsetHeight && "visible" != (0, _jquery2.default)(e).css("overflowY") && (t.visible = t.bottom > e.scrollTop && t.top < e.scrollTop + e.clientHeight), t.visible && e.scrollWidth != e.offsetWidth && "visible" != (0, _jquery2.default)(e).css("overflowX") && (t.visible = t.right > e.scrollLeft && t.left < e.scrollLeft + e.clientWidth), t.left -= e.scrollLeft, t.top -= e.scrollTop, e === o && (t.left += e.offsetLeft, t.top += e.offsetTop, o = e.offsetParent), t.bottom = t.top + t.height, t.right = t.left + t.width;
      }

      return t;
    }

    function getActiveCellPosition() {
      return absBox(activeCellNode);
    }

    function getGridPosition() {
      return absBox($container[0]);
    }

    function handleActiveCellPositionChange() {
      if (activeCellNode && (trigger(self.onActiveCellPositionChanged, {
        grid: self
      }), currentEditor)) {
        var e = getActiveCellPosition();
        currentEditor.show && currentEditor.hide && (e.visible ? currentEditor.show() : currentEditor.hide()), currentEditor.position && currentEditor.position(e);
      }
    }

    function getCellEditor() {
      return currentEditor;
    }

    function getActiveCell() {
      return activeCellNode ? {
        row: activeRow,
        cell: activeCell,
        grid: self
      } : null;
    }

    function getActiveCellNode() {
      return activeCellNode;
    }

    function scrollRowIntoView(e, t) {
      var o = e * options.rowHeight,
          n = (e + 1) * options.rowHeight - viewportH + (viewportHasHScroll ? scrollbarDimensions.height : 0);
      (e + 1) * options.rowHeight > scrollTop + viewportH + offset ? (scrollTo(t ? o : n), render()) : e * options.rowHeight < scrollTop + offset && (scrollTo(t ? n : o), render());
    }

    function scrollRowToTop(e) {
      scrollTo(e * options.rowHeight), render();
    }

    function scrollPage(e) {
      var t = e * numVisibleRows;

      if (scrollTo((getRowFromPosition(scrollTop) + t) * options.rowHeight), render(), options.enableCellNavigation && null != activeRow) {
        var o = activeRow + t,
            n = getDataLengthIncludingAddNew();
        o >= n && (o = n - 1), o < 0 && (o = 0);

        for (var r = 0, i = null, s = activePosX; r <= activePosX;) {
          canCellBeActive(o, r) && (i = r), r += getColspan(o, r);
        }

        null !== i ? (setActiveCellInternal(getCellNode(o, i)), activePosX = s) : resetActiveCell();
      }
    }

    function navigatePageDown() {
      scrollPage(1);
    }

    function navigatePageUp() {
      scrollPage(-1);
    }

    function getColspan(e, t) {
      var o = data.getItemMetadata && data.getItemMetadata(e);
      if (!o || !o.columns) return 1;
      var n = o.columns[columns[t].id] || o.columns[t],
          r = n && n.colspan;
      return r = "*" === r ? columns.length - t : r || 1;
    }

    function findFirstFocusableCell(e) {
      for (var t = 0; t < columns.length;) {
        if (canCellBeActive(e, t)) return t;
        t += getColspan(e, t);
      }

      return null;
    }

    function findLastFocusableCell(e) {
      for (var t = 0, o = null; t < columns.length;) {
        canCellBeActive(e, t) && (o = t), t += getColspan(e, t);
      }

      return o;
    }

    function gotoRight(e, t, o) {
      if (t >= columns.length) return null;

      do {
        t += getColspan(e, t);
      } while (t < columns.length && !canCellBeActive(e, t));

      return t < columns.length ? {
        row: e,
        cell: t,
        posX: t
      } : null;
    }

    function gotoLeft(e, t, o) {
      if (t <= 0) return null;
      var n = findFirstFocusableCell(e);
      if (null === n || n >= t) return null;

      for (var r, i = {
        row: e,
        cell: n,
        posX: n
      };;) {
        if (r = gotoRight(i.row, i.cell, i.posX), !r) return null;
        if (r.cell >= t) return i;
        i = r;
      }
    }

    function gotoDown(e, t, o) {
      for (var n, r = getDataLengthIncludingAddNew();;) {
        if (++e >= r) return null;

        for (n = t = 0; t <= o;) {
          n = t, t += getColspan(e, t);
        }

        if (canCellBeActive(e, n)) return {
          row: e,
          cell: n,
          posX: o
        };
      }
    }

    function gotoUp(e, t, o) {
      for (var n;;) {
        if (--e < 0) return null;

        for (n = t = 0; t <= o;) {
          n = t, t += getColspan(e, t);
        }

        if (canCellBeActive(e, n)) return {
          row: e,
          cell: n,
          posX: o
        };
      }
    }

    function gotoNext(e, t, o) {
      if (null == e && null == t && (e = t = o = 0, canCellBeActive(e, t))) return {
        row: e,
        cell: t,
        posX: t
      };
      var n = gotoRight(e, t, o);
      if (n) return n;

      for (var r = null, i = getDataLengthIncludingAddNew(); ++e < i;) {
        if (r = findFirstFocusableCell(e), null !== r) return {
          row: e,
          cell: r,
          posX: r
        };
      }

      return null;
    }

    function gotoPrev(e, t, o) {
      if (null == e && null == t && (e = getDataLengthIncludingAddNew() - 1, t = o = columns.length - 1, canCellBeActive(e, t))) return {
        row: e,
        cell: t,
        posX: t
      };

      for (var n, r; !n && !(n = gotoLeft(e, t, o));) {
        if (--e < 0) return null;
        t = 0, r = findLastFocusableCell(e), null !== r && (n = {
          row: e,
          cell: r,
          posX: r
        });
      }

      return n;
    }

    function navigateRight() {
      return navigate("right");
    }

    function navigateLeft() {
      return navigate("left");
    }

    function navigateDown() {
      return navigate("down");
    }

    function navigateUp() {
      return navigate("up");
    }

    function navigateNext() {
      return navigate("next");
    }

    function navigatePrev() {
      return navigate("prev");
    }

    function navigate(e) {
      if (!options.enableCellNavigation) return !1;
      if (!activeCellNode && "prev" != e && "next" != e) return !1;
      if (!getEditorLock().commitCurrentEdit()) return !0;
      setFocus();
      var t = {
        up: -1,
        down: 1,
        left: -1,
        right: 1,
        prev: -1,
        next: 1
      };
      tabbingDirection = t[e];
      var o = {
        up: gotoUp,
        down: gotoDown,
        left: gotoLeft,
        right: gotoRight,
        prev: gotoPrev,
        next: gotoNext
      },
          n = o[e],
          r = n(activeRow, activeCell, activePosX);

      if (r) {
        var i = r.row == getDataLength();
        return scrollCellIntoView(r.row, r.cell, !i), setActiveCellInternal(getCellNode(r.row, r.cell)), activePosX = r.posX, !0;
      }

      return setActiveCellInternal(getCellNode(activeRow, activeCell)), !1;
    }

    function getCellNode(e, t) {
      return rowsCache[e] ? (ensureCellNodesInRowsCache(e), rowsCache[e].cellNodesByColumnIdx[t]) : null;
    }

    function setActiveCell(e, t) {
      initialized && (e > getDataLength() || e < 0 || t >= columns.length || t < 0 || options.enableCellNavigation && (scrollCellIntoView(e, t, !1), setActiveCellInternal(getCellNode(e, t), !1)));
    }

    function canCellBeActive(e, t) {
      if (!options.enableCellNavigation || e >= getDataLengthIncludingAddNew() || e < 0 || t >= columns.length || t < 0) return !1;
      var o = data.getItemMetadata && data.getItemMetadata(e);
      if (o && "boolean" == typeof o.focusable) return o.focusable;
      var n = o && o.columns;
      return n && n[columns[t].id] && "boolean" == typeof n[columns[t].id].focusable ? n[columns[t].id].focusable : n && n[t] && "boolean" == typeof n[t].focusable ? n[t].focusable : columns[t].focusable;
    }

    function canCellBeSelected(e, t) {
      if (e >= getDataLength() || e < 0 || t >= columns.length || t < 0) return !1;
      var o = data.getItemMetadata && data.getItemMetadata(e);
      if (o && "boolean" == typeof o.selectable) return o.selectable;
      var n = o && o.columns && (o.columns[columns[t].id] || o.columns[t]);
      return n && "boolean" == typeof n.selectable ? n.selectable : columns[t].selectable;
    }

    function gotoCell(e, t, o) {
      if (initialized && canCellBeActive(e, t) && getEditorLock().commitCurrentEdit()) {
        scrollCellIntoView(e, t, !1);
        var n = getCellNode(e, t);
        setActiveCellInternal(n, o || e === getDataLength() || options.autoEdit), currentEditor || setFocus();
      }
    }

    function commitCurrentEdit() {
      var e = getDataItem(activeRow),
          t = columns[activeCell];

      if (currentEditor) {
        if (currentEditor.isValueChanged()) {
          var o = currentEditor.validate();

          if (o.valid) {
            if (activeRow < getDataLength()) {
              var n = {
                row: activeRow,
                cell: activeCell,
                editor: currentEditor,
                serializedValue: currentEditor.serializeValue(),
                prevSerializedValue: serializedEditorValue,
                execute: function execute() {
                  this.editor.applyValue(e, this.serializedValue), updateRow(this.row), trigger(self.onCellChange, {
                    row: activeRow,
                    cell: activeCell,
                    item: e,
                    grid: self
                  });
                },
                undo: function undo() {
                  this.editor.applyValue(e, this.prevSerializedValue), updateRow(this.row), trigger(self.onCellChange, {
                    row: activeRow,
                    cell: activeCell,
                    item: e,
                    grid: self
                  });
                }
              };
              options.editCommandHandler ? (makeActiveCellNormal(), options.editCommandHandler(e, t, n)) : (n.execute(), makeActiveCellNormal());
            } else {
              var r = {};
              currentEditor.applyValue(r, currentEditor.serializeValue()), makeActiveCellNormal(), trigger(self.onAddNewRow, {
                item: r,
                column: t,
                grid: self
              });
            }

            return !getEditorLock().isActive();
          }

          return (0, _jquery2.default)(activeCellNode).removeClass("invalid"), (0, _jquery2.default)(activeCellNode).width(), (0, _jquery2.default)(activeCellNode).addClass("invalid"), trigger(self.onValidationError, {
            editor: currentEditor,
            cellNode: activeCellNode,
            validationResults: o,
            row: activeRow,
            cell: activeCell,
            column: t,
            grid: self
          }), currentEditor.focus(), !1;
        }

        makeActiveCellNormal();
      }

      return !0;
    }

    function cancelCurrentEdit() {
      return makeActiveCellNormal(), !0;
    }

    function rowsToRanges(e) {
      for (var t = [], o = columns.length - 1, n = 0; n < e.length; n++) {
        t.push(new _slick2.default.Range(e[n], 0, e[n], o));
      }

      return t;
    }

    function getSelectedRows() {
      if (!selectionModel) throw "Selection model is not set";
      return selectedRows;
    }

    function setSelectedRows(e) {
      if (!selectionModel) throw "Selection model is not set";
      selectionModel.setSelectedRanges(rowsToRanges(e));
    }

    var defaults = {
      explicitInitialization: !1,
      rowHeight: 25,
      defaultColumnWidth: 80,
      enableAddRow: !1,
      leaveSpaceForNewRows: !1,
      editable: !1,
      autoEdit: !0,
      enableCellNavigation: !0,
      enableColumnReorder: !0,
      asyncEditorLoading: !1,
      asyncEditorLoadDelay: 100,
      forceFitColumns: !1,
      enableAsyncPostRender: !1,
      asyncPostRenderDelay: 50,
      enableAsyncPostRenderCleanup: !1,
      asyncPostRenderCleanupDelay: 40,
      autoHeight: !1,
      editorLock: _slick2.default.GlobalEditorLock,
      showHeaderRow: !1,
      headerRowHeight: 25,
      createFooterRow: !1,
      showFooterRow: !1,
      footerRowHeight: 25,
      showTopPanel: !1,
      topPanelHeight: 25,
      formatterFactory: null,
      editorFactory: null,
      cellFlashingCssClass: "flashing",
      selectedCellCssClass: "selected",
      multiSelect: !0,
      enableTextSelectionOnCells: !1,
      dataItemColumnValueExtractor: null,
      fullWidthRows: !1,
      multiColumnSort: !1,
      defaultFormatter: defaultFormatter,
      forceSyncScrolling: !1,
      addNewRowCssClass: "new-row"
    },
        columnDefaults = {
      name: "",
      resizable: !0,
      sortable: !1,
      minWidth: 30,
      rerenderOnResize: !1,
      headerCssClass: null,
      defaultSortAsc: !0,
      focusable: !0,
      selectable: !0
    },
        th,
        h,
        ph,
        n,
        cj,
        page = 0,
        offset = 0,
        vScrollDir = 1,
        initialized = !1,
        $container,
        uid = "slickgrid_" + Math.round(1e6 * Math.random()),
        self = this,
        $focusSink,
        $focusSink2,
        $headerScroller,
        $headers,
        $headerRow,
        $headerRowScroller,
        $headerRowSpacer,
        $footerRow,
        $footerRowScroller,
        $footerRowSpacer,
        $topPanelScroller,
        $topPanel,
        $viewport,
        $canvas,
        $style,
        $boundAncestors,
        stylesheet,
        columnCssRulesL,
        columnCssRulesR,
        viewportH,
        viewportW,
        canvasWidth,
        viewportHasHScroll,
        viewportHasVScroll,
        headerColumnWidthDiff = 0,
        headerColumnHeightDiff = 0,
        cellWidthDiff = 0,
        cellHeightDiff = 0,
        jQueryNewWidthBehaviour = !1,
        absoluteColumnMinWidth,
        tabbingDirection = 1,
        activePosX,
        activeRow,
        activeCell,
        activeCellNode = null,
        currentEditor = null,
        serializedEditorValue,
        editController,
        rowsCache = {},
        renderedRows = 0,
        numVisibleRows,
        prevScrollTop = 0,
        scrollTop = 0,
        lastRenderedScrollTop = 0,
        lastRenderedScrollLeft = 0,
        prevScrollLeft = 0,
        scrollLeft = 0,
        selectionModel,
        selectedRows = [],
        plugins = [],
        cellCssClasses = {},
        columnsById = {},
        sortColumns = [],
        columnPosLeft = [],
        columnPosRight = [],
        h_editorLoader = null,
        h_render = null,
        h_postrender = null,
        h_postrenderCleanup = null,
        postProcessedRows = {},
        postProcessToRow = null,
        postProcessFromRow = null,
        postProcessedCleanupQueue = [],
        postProcessgroupId = 0,
        counter_rows_rendered = 0,
        counter_rows_removed = 0,
        rowNodeFromLastMouseWheelEvent,
        zombieRowNodeFromLastMouseWheelEvent,
        zombieRowCacheFromLastMouseWheelEvent,
        zombieRowPostProcessedFromLastMouseWheelEvent,
        cssShow = {
      position: "absolute",
      visibility: "hidden",
      display: "block"
    },
        $hiddenParents,
        oldProps = [];
    this.debug = function () {
      var e = "";
      e += "\ncounter_rows_rendered:  " + counter_rows_rendered, e += "\ncounter_rows_removed:  " + counter_rows_removed, e += "\nrenderedRows:  " + renderedRows, e += "\nnumVisibleRows:  " + numVisibleRows, e += "\nmaxSupportedCssHeight:  " + maxSupportedCssHeight, e += "\nn(umber of pages):  " + n, e += "\n(current) page:  " + page, e += "\npage height (ph):  " + ph, e += "\nvScrollDir:  " + vScrollDir, alert(e);
    }, this.eval = function (expr) {
      return eval(expr);
    }, _jquery2.default.extend(this, {
      slickGridVersion: "2.2.4",
      onScroll: new _slick2.default.Event(),
      onSort: new _slick2.default.Event(),
      onHeaderMouseEnter: new _slick2.default.Event(),
      onHeaderMouseLeave: new _slick2.default.Event(),
      onHeaderContextMenu: new _slick2.default.Event(),
      onHeaderClick: new _slick2.default.Event(),
      onHeaderCellRendered: new _slick2.default.Event(),
      onBeforeHeaderCellDestroy: new _slick2.default.Event(),
      onHeaderRowCellRendered: new _slick2.default.Event(),
      onFooterRowCellRendered: new _slick2.default.Event(),
      onBeforeHeaderRowCellDestroy: new _slick2.default.Event(),
      onBeforeFooterRowCellDestroy: new _slick2.default.Event(),
      onMouseEnter: new _slick2.default.Event(),
      onMouseLeave: new _slick2.default.Event(),
      onClick: new _slick2.default.Event(),
      onDblClick: new _slick2.default.Event(),
      onContextMenu: new _slick2.default.Event(),
      onKeyDown: new _slick2.default.Event(),
      onAddNewRow: new _slick2.default.Event(),
      onValidationError: new _slick2.default.Event(),
      onViewportChanged: new _slick2.default.Event(),
      onColumnsReordered: new _slick2.default.Event(),
      onColumnsResized: new _slick2.default.Event(),
      onCellChange: new _slick2.default.Event(),
      onBeforeEditCell: new _slick2.default.Event(),
      onBeforeCellEditorDestroy: new _slick2.default.Event(),
      onBeforeDestroy: new _slick2.default.Event(),
      onActiveCellChanged: new _slick2.default.Event(),
      onActiveCellPositionChanged: new _slick2.default.Event(),
      onDragInit: new _slick2.default.Event(),
      onDragStart: new _slick2.default.Event(),
      onDrag: new _slick2.default.Event(),
      onDragEnd: new _slick2.default.Event(),
      onSelectedRowsChanged: new _slick2.default.Event(),
      onCellCssStylesChanged: new _slick2.default.Event(),
      registerPlugin: registerPlugin,
      unregisterPlugin: unregisterPlugin,
      getColumns: getColumns,
      setColumns: setColumns,
      getColumnIndex: getColumnIndex,
      updateColumnHeader: updateColumnHeader,
      setSortColumn: setSortColumn,
      setSortColumns: setSortColumns,
      getSortColumns: getSortColumns,
      autosizeColumns: autosizeColumns,
      getOptions: getOptions,
      setOptions: setOptions,
      getData: getData,
      getDataLength: getDataLength,
      getDataItem: getDataItem,
      setData: setData,
      getSelectionModel: getSelectionModel,
      setSelectionModel: setSelectionModel,
      getSelectedRows: getSelectedRows,
      setSelectedRows: setSelectedRows,
      getContainerNode: getContainerNode,
      render: render,
      invalidate: invalidate,
      invalidateRow: invalidateRow,
      invalidateRows: invalidateRows,
      invalidateAllRows: invalidateAllRows,
      updateCell: updateCell,
      updateRow: updateRow,
      getViewport: getVisibleRange,
      getRenderedRange: getRenderedRange,
      resizeCanvas: resizeCanvas,
      updateRowCount: updateRowCount,
      scrollRowIntoView: scrollRowIntoView,
      scrollRowToTop: scrollRowToTop,
      scrollCellIntoView: scrollCellIntoView,
      getCanvasNode: getCanvasNode,
      focus: setFocus,
      getCellFromPoint: getCellFromPoint,
      getCellFromEvent: getCellFromEvent,
      getActiveCell: getActiveCell,
      setActiveCell: setActiveCell,
      getActiveCellNode: getActiveCellNode,
      getActiveCellPosition: getActiveCellPosition,
      resetActiveCell: resetActiveCell,
      editActiveCell: makeActiveCellEditable,
      getCellEditor: getCellEditor,
      getCellNode: getCellNode,
      getCellNodeBox: getCellNodeBox,
      canCellBeSelected: canCellBeSelected,
      canCellBeActive: canCellBeActive,
      navigatePrev: navigatePrev,
      navigateNext: navigateNext,
      navigateUp: navigateUp,
      navigateDown: navigateDown,
      navigateLeft: navigateLeft,
      navigateRight: navigateRight,
      navigatePageUp: navigatePageUp,
      navigatePageDown: navigatePageDown,
      gotoCell: gotoCell,
      getTopPanel: getTopPanel,
      setTopPanelVisibility: setTopPanelVisibility,
      setHeaderRowVisibility: setHeaderRowVisibility,
      getHeaderRow: getHeaderRow,
      getHeaderRowColumn: getHeaderRowColumn,
      setFooterRowVisibility: setFooterRowVisibility,
      getFooterRow: getFooterRow,
      getFooterRowColumn: getFooterRowColumn,
      getGridPosition: getGridPosition,
      flashCell: flashCell,
      addCellCssStyles: addCellCssStyles,
      setCellCssStyles: setCellCssStyles,
      removeCellCssStyles: removeCellCssStyles,
      getCellCssStyles: getCellCssStyles,
      init: finishInitialization,
      destroy: destroy,
      getEditorLock: getEditorLock,
      getEditController: getEditController
    }), init();
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var _jquery = __webpack_require__(2),
      _jquery2 = _interopRequireDefault(_jquery),
      _interact = __webpack_require__(5),
      _interact2 = _interopRequireDefault(_interact),
      _slick = __webpack_require__(1),
      _slick2 = _interopRequireDefault(_slick);

  _slick2.default.Grid = SlickGrid, exports.default = SlickGrid;
  var scrollbarDimensions, maxSupportedCssHeight;
}, function (e, t, o) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function r(e) {
    function t(t, o, n, r, i) {
      if (!e.enableExpandCollapse) return i.title;
      var s = 15 * i.level + "px";
      return "<span class='" + e.toggleCssClass + " " + (i.collapsed ? e.toggleCollapsedCssClass : e.toggleExpandedCssClass) + "' style='margin-left:" + s + "'></span><span class='" + e.groupTitleCssClass + "' level='" + i.level + "'>" + i.title + "</span>";
    }

    function o(e, t, o, n, r) {
      return n.groupTotalsFormatter && n.groupTotalsFormatter(r, n) || "";
    }

    function n(e) {
      u = e, u.onClick.subscribe(i), u.onKeyDown.subscribe(l);
    }

    function r() {
      u && (u.onClick.unsubscribe(i), u.onKeyDown.unsubscribe(l));
    }

    function i(t, o) {
      var n = this.getDataItem(o.row);

      if (n && n instanceof a.default.Group && (0, s.default)(t.target).hasClass(e.toggleCssClass)) {
        var r = u.getRenderedRange();
        this.getData().setRefreshHints({
          ignoreDiffsBefore: r.top,
          ignoreDiffsAfter: r.bottom + 1
        }), n.collapsed ? this.getData().expandGroup(n.groupingKey) : this.getData().collapseGroup(n.groupingKey), t.stopImmediatePropagation(), t.preventDefault();
      }
    }

    function l(t) {
      if (e.enableExpandCollapse && t.which == a.default.keyCode.SPACE) {
        var o = this.getActiveCell();

        if (o) {
          var n = this.getDataItem(o.row);

          if (n && n instanceof a.default.Group) {
            var r = u.getRenderedRange();
            this.getData().setRefreshHints({
              ignoreDiffsBefore: r.top,
              ignoreDiffsAfter: r.bottom + 1
            }), n.collapsed ? this.getData().expandGroup(n.groupingKey) : this.getData().collapseGroup(n.groupingKey), t.stopImmediatePropagation(), t.preventDefault();
          }
        }
      }
    }

    function c(t) {
      return {
        selectable: !1,
        focusable: e.groupFocusable,
        cssClasses: e.groupCssClass,
        columns: {
          0: {
            colspan: "*",
            formatter: e.groupFormatter,
            editor: null
          }
        }
      };
    }

    function d(t) {
      return {
        selectable: !1,
        focusable: e.totalsFocusable,
        cssClasses: e.totalsCssClass,
        formatter: e.totalsFormatter,
        editor: null
      };
    }

    var u = void 0,
        h = {
      groupCssClass: "slick-group",
      groupTitleCssClass: "slick-group-title",
      totalsCssClass: "slick-group-totals",
      groupFocusable: !0,
      totalsFocusable: !1,
      toggleCssClass: "slick-group-toggle",
      toggleExpandedCssClass: "expanded",
      toggleCollapsedCssClass: "collapsed",
      enableExpandCollapse: !0,
      groupFormatter: t,
      totalsFormatter: o
    };
    return e = s.default.extend(!0, {}, h, e), {
      init: n,
      destroy: r,
      getGroupRowMetadata: c,
      getTotalsRowMetadata: d
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = o(2),
      s = n(i),
      l = o(1),
      a = n(l);
  t.default = r;
}, function (e, t) {
  e.exports = require("flatpickr");
}]));